var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 863.188,
    height: 704.176,
    viewBox: "0 0 863.188 704.176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settings_2_BW",
    "data-name": "settings 2 BW",
    transform: "translate(-78.63 -114.294)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "background",
    transform: "translate(117.235 114.294)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ground_grey",
    transform: "translate(24.065 293.408)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4383",
    "data-name": "Group 4383",
    transform: "translate(397.589 220.94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4382",
    "data-name": "Group 4382"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2565",
    "data-name": "Path 2565",
    d: "M736.863,850.61H982.589a.806.806,0,0,0,0-1.61H736.863a.805.805,0,0,0,0,1.61Z",
    transform: "translate(-736.075 -849)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4385",
    "data-name": "Group 4385",
    transform: "translate(592.91 202.738)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4384",
    "data-name": "Group 4384"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2566",
    "data-name": "Path 2566",
    d: "M1015.863,824.61h153.316a.806.806,0,0,0,0-1.61H1015.862a.805.805,0,0,0,0,1.61Z",
    transform: "translate(-1015.075 -823)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4387",
    "data-name": "Group 4387",
    transform: "translate(0 335.052)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4386",
    "data-name": "Group 4386"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2567",
    "data-name": "Path 2567",
    d: "M168.885,1013.61H276a.806.806,0,0,0,0-1.61H168.885a.808.808,0,0,0,0,1.61Z",
    transform: "translate(-168.15 -1012)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4389",
    "data-name": "Group 4389",
    transform: "translate(658.699 328.752)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4388",
    "data-name": "Group 4388"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2568",
    "data-name": "Path 2568",
    d: "M1109.785,1004.61H1239.3a.806.806,0,0,0,0-1.61H1109.785a.808.808,0,0,0,0,1.61Z",
    transform: "translate(-1109.05 -1003)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4391",
    "data-name": "Group 4391",
    transform: "translate(425.906 333.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4390",
    "data-name": "Group 4390"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2569",
    "data-name": "Path 2569",
    d: "M777,1012.5c3.36,3.08,6.791,6.231,10.151,9.311l1.12-1.12a96.516,96.516,0,0,1-10.361-10.361l-1.12,1.12,10.921,11.131a.794.794,0,0,0,1.26-.14h.77a8.548,8.548,0,0,1-1.19-.49c-.42.35-.84.63-1.33.98-.84-.56-1.68.84-.77,1.33a2.452,2.452,0,0,0,3.64-2.73.853.853,0,0,0-1.19-.49c-1.33.7-2.03,3.78.21,3.57a1.659,1.659,0,0,0,.07-3.29c-2.03-.35-2.94,2.45-1.33,3.57,2.52,1.68,3.15-2.17,2.87-3.71a.76.76,0,0,0-.56-.56,2.27,2.27,0,0,0-2.66,1.05,7.722,7.722,0,0,1,1.26-.14L777.837,1010.4c-.7-.7-1.75.35-1.12,1.12a96.534,96.534,0,0,0,10.361,10.361c.77.63,1.89-.42,1.12-1.12-3.36-3.08-6.791-6.231-10.151-9.311a.743.743,0,1,0-1.05,1.05Z",
    transform: "translate(-776.523 -1010.172)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4393",
    "data-name": "Group 4393",
    transform: "translate(422.446 333.905)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4392",
    "data-name": "Group 4392"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2570",
    "data-name": "Path 2570",
    d: "M772.574,1019c7.631-1.89,15.192-3.99,22.752-6.161a.813.813,0,0,0,0-1.54c-.42-.14-.77-.28-1.19-.42l.21,1.47c.07-.56.14-1.12.21-1.61a8.546,8.546,0,0,1-.49,1.19l1.68,1.47c.35-.28.63-.49.98-.77-.49-.49-.91-1.05-1.4-1.54-.35.28-.63.49-.98.77l1.05.84c-.98.35-.56,1.89.42,1.54,2.73-.98.84-3.29-1.05-3.85a.8.8,0,0,0-.98.77,2.776,2.776,0,0,0,2.52,3.08.8.8,0,0,0,.98-.77,2.866,2.866,0,0,0-3.71-2.94c-.49.07-.7.77-.49,1.19.7,1.26,3.57,3.57,4.2.84.63-2.52-2.66-2.03-3.85-1.33a.82.82,0,0,0,.21,1.47c.42.14.77.28,1.19.42v-1.54c-7.561,2.17-15.122,4.2-22.752,6.161-.91,0-.49,1.47.49,1.26Z",
    transform: "translate(-771.581 -1010.361)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4395",
    "data-name": "Group 4395",
    transform: "translate(422.004 364.066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4394",
    "data-name": "Group 4394"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2571",
    "data-name": "Path 2571",
    d: "M771.685,1057.824c4.831-.35,9.661-.84,14.492-1.54a.81.81,0,0,0,.35-1.33,4.7,4.7,0,0,0-.49-.77c-.21.35-.35.63-.56.98,0-.14-.07-.28-.07-.42-.07.35-.21.7-.28,1.05,0-.56.07-1.12.07-1.68-.35-.91-1.89-.56-1.54.42.56,1.47,3.15,4.55,4.551,1.75,1.26-2.59-2.45-2.87-3.85-1.89a.731.731,0,0,0-.28,1.05,3.577,3.577,0,0,0,3.36,1.82.929.929,0,0,0,.77-.56,2.439,2.439,0,0,0-3.08-3.15.858.858,0,0,0-.56.98,1.991,1.991,0,0,0,.84,1.47c.14-.42.21-.91.35-1.33-4.691.63-9.381,1.19-14.071,1.47-.98.14-.98,1.75,0,1.68Z",
    transform: "translate(-770.95 -1053.444)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4397",
    "data-name": "Group 4397",
    transform: "translate(444.289 362.659)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4396",
    "data-name": "Group 4396"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2572",
    "data-name": "Path 2572",
    d: "M803.915,1064.011c5.181-3.57,10.221-7.351,15.122-11.271.77-.63-.35-1.75-1.12-1.12-4.83,3.85-9.731,7.491-14.771,10.991-.84.63-.07,1.96.77,1.4Z",
    transform: "translate(-802.781 -1051.434)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4399",
    "data-name": "Group 4399",
    transform: "translate(442.941 373.059)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4398",
    "data-name": "Group 4398"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2573",
    "data-name": "Path 2573",
    d: "M802.427,1068.257c.14-.35.7-.56.7-.07.07.42-.35.42-.56.21a.173.173,0,0,1-.07-.28.708.708,0,0,1,.49-.28c.28.07.28.56,0,.7.21,0,.42-.07.63-.07a1.793,1.793,0,0,1-1.19-1.05,8.552,8.552,0,0,1-.49,1.19,1.437,1.437,0,0,1,.77,0,.768.768,0,1,0,.77-1.33,3.126,3.126,0,0,0-1.96-.21.853.853,0,0,0-.49,1.19,3.584,3.584,0,0,0,1.61,1.61,1.05,1.05,0,0,0,1.26,0,1.792,1.792,0,0,0,.7-.91,1.928,1.928,0,0,0-2.24-2.59,2.079,2.079,0,0,0-1.47,1.47,1.844,1.844,0,0,0,.84,1.89,1.852,1.852,0,0,0,2.94-1.82,1.8,1.8,0,0,0-1.68-1.61,1.987,1.987,0,0,0-1.96,1.12c-.14.42-.14.84.28,1.05a.779.779,0,0,0,1.12-.21Z",
    transform: "translate(-800.856 -1066.289)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4401",
    "data-name": "Group 4401",
    transform: "translate(672.114 93.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4400",
    "data-name": "Group 4400"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2574",
    "data-name": "Path 2574",
    d: "M1139.125,727.543a191.572,191.572,0,0,1-7.771-34.864c-.7-5.741-1.19-11.481-1.4-17.292-.07-1.33-.42-3.78,1.05-4.62.77-.49,2.45-.42,3.36-.56,3.5-.56,7-.98,10.571-1.33a203,203,0,0,1,34.514-.56c2.94.21,5.881.49,8.751.84,1.68.21,3.5.28,5.181.63,2.03.49,2.17.84,2.31,2.94.28,5.741.35,11.481.07,17.292a177.118,177.118,0,0,1-6.3,39.694.8.8,0,0,0,1.54.42,182.971,182.971,0,0,0,6.091-60.7.819.819,0,0,0-.56-.77,197.376,197.376,0,0,0-33.954-2.38c-5.881.07-11.761.42-17.572,1.05q-3.465.315-6.931.84c-2.38.35-5.6.35-7.771,1.33-3.08,1.4-1.89,5.951-1.75,8.681q.42,8.086,1.47,16.172a197.877,197.877,0,0,0,7.631,33.744c.28.84,1.82.42,1.47-.56Z",
    transform: "translate(-1128.211 -666.255)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4403",
    "data-name": "Group 4403",
    transform: "translate(676.396 134.39)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4402",
    "data-name": "Group 4402"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2575",
    "data-name": "Path 2575",
    d: "M1134.589,726.651c9.871,8.471,21.352,14.492,32.9,20.3.91.49,1.68-.91.77-1.33-11.411-5.741-22.892-11.621-32.623-20.022-.7-.7-1.82.35-1.05,1.05Z",
    transform: "translate(-1134.329 -725.37)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4405",
    "data-name": "Group 4405",
    transform: "translate(673.073 109.159)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4404",
    "data-name": "Group 4404"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2576",
    "data-name": "Path 2576",
    d: "M1129.8,690.639a213.484,213.484,0,0,0,60.206,44.8c.91.42,1.68-.91.77-1.33a211.617,211.617,0,0,1-59.926-44.525c-.63-.77-1.75.35-1.05,1.05Z",
    transform: "translate(-1129.582 -689.329)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4407",
    "data-name": "Group 4407",
    transform: "translate(681.537 94.678)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4406",
    "data-name": "Group 4406"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2577",
    "data-name": "Path 2577",
    d: "M1141.832,669.733a161.01,161.01,0,0,0,54.4,46.695c.91.49,1.68-.91.77-1.33a158.948,158.948,0,0,1-53.836-46.135c-.56-.77-1.96,0-1.33.77Z",
    transform: "translate(-1141.672 -668.644)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4409",
    "data-name": "Group 4409",
    transform: "translate(704.149 93.935)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4408",
    "data-name": "Group 4408"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2578",
    "data-name": "Path 2578",
    d: "M1174.2,668.925c11.061,10.5,21.772,21.7,34.514,30.243.84.56,1.61-.77.77-1.33-12.6-8.4-23.242-19.6-34.163-30.033a.793.793,0,0,0-1.12,1.12Z",
    transform: "translate(-1173.971 -667.583)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4411",
    "data-name": "Group 4411",
    transform: "translate(678.902 3.177)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4410",
    "data-name": "Group 4410"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2579",
    "data-name": "Path 2579",
    d: "M1147.353,629.132a49.558,49.558,0,0,1-4.9-9.591c-.42-1.12-3.64-10.081-1.47-10.361a.827.827,0,0,0,.77-.98,55.322,55.322,0,0,1-2.03-11.2,18.534,18.534,0,0,1-.14-4.83c.35-1.96,1.4-2.1,1.75-3.43.7-2.8-.35-6.091-.7-8.961-.42-3.64-.77-7.281-.91-10.921a48.257,48.257,0,0,1,2.73-18.9c1.05-2.8,2.94-7.561,5.531-9.311,4.551-3.08,8.121,2.45,10.081,5.741,3.08,5.111,4.551,11.061,5.741,16.942,1.33,6.651,2.45,13.3,3.36,20.022a357.424,357.424,0,0,1,3.22,44.945.806.806,0,0,0,1.61,0,367.057,367.057,0,0,0-2.66-41.094c-1.47-11.621-2.73-24.153-6.791-35.214-1.96-5.321-8.961-19.182-15.962-12.041-7.491,7.561-8.751,20.3-8.331,30.313.14,3.85.63,7.7,1.12,11.551.21,1.82.84,3.92.42,5.741a15.035,15.035,0,0,1-1.33,2.59c-.98,2.38-.42,5.671-.14,8.121a65.889,65.889,0,0,0,1.96,10.361c.28-.35.49-.63.77-.98-7.211.84,3.29,19.672,5.04,22.332.42.77,1.82,0,1.26-.84Z",
    transform: "translate(-1137.907 -537.942)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4413",
    "data-name": "Group 4413",
    transform: "translate(709.679 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4412",
    "data-name": "Group 4412"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2580",
    "data-name": "Path 2580",
    d: "M1183.5,597.388c.56-1.82,1.12-3.64,1.68-5.391.28-.77.49-1.61.77-2.38.07-.14,2.1-5.391,3.01-2.52a.787.787,0,0,0,1.54-.21,48.1,48.1,0,0,1,3.22-14.7,8.535,8.535,0,0,0-1.19.49c.49.35.98.7,1.54,1.05a.772.772,0,0,0,1.05-.28,253.06,253.06,0,0,1,23.172-38.854l-1.47-.42c2.17,18.342-1.96,36.4-8.121,53.626a.773.773,0,0,0,.77.98l4.62-.42c-.28-.35-.49-.63-.77-.98a115.711,115.711,0,0,1-14,39.554.769.769,0,1,0,1.33.77,115.914,115.914,0,0,0,14.211-39.9c.07-.49-.21-1.05-.77-.98l-4.62.42c.28.35.49.63.77.98,6.161-17.292,10.361-35.564,8.191-54.046a.807.807,0,0,0-1.47-.42,256.446,256.446,0,0,0-23.172,38.854c.35-.07.7-.21,1.05-.28-.49-.35-.98-.7-1.54-1.05-.49-.35-.98.07-1.19.49a50.841,50.841,0,0,0-3.29,15.122c.49-.07,1.05-.14,1.54-.21a2.565,2.565,0,0,0-3.99-1.33c-1.12.7-1.47,2.03-1.89,3.22-.98,2.73-1.75,5.6-2.59,8.4a.835.835,0,0,0,1.61.42Z",
    transform: "translate(-1181.871 -533.404)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4415",
    "data-name": "Group 4415",
    transform: "translate(715.292 3.313)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4414",
    "data-name": "Group 4414"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2581",
    "data-name": "Path 2581",
    d: "M1218.389,538.881c-.14,8.4-3.71,17.082-6.021,25.133a201.37,201.37,0,0,1-8.051,24.012c-5.6,13.161-12.531,25.833-14.422,40.184-.14.98,1.47.98,1.61,0,2.03-15.332,10.011-28.843,15.752-42.985,3.01-7.421,5.111-15.192,7.351-22.892,2.17-7.561,5.391-15.542,5.531-23.522a.9.9,0,0,0-1.75.07Z",
    transform: "translate(-1189.888 -538.137)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4417",
    "data-name": "Group 4417",
    transform: "translate(688.735 3.836)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4416",
    "data-name": "Group 4416"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2582",
    "data-name": "Path 2582",
    d: "M1152.056,540.085c3.15,5.881,3.99,12.6,4.97,19.112,1.26,8.121,1.89,16.312,2.38,24.5.84,15.192,2.66,30.173,4.691,45.225.14.84,1.68.7,1.54-.21a5.135,5.135,0,0,0-.35-1.4c-.42-.91-1.75-.14-1.33.77.07.21.07.42.14.56.49-.07,1.05-.14,1.54-.21-2.17-16.242-3.92-32.413-4.9-48.8a209.582,209.582,0,0,0-2.38-21.912c-.98-6.3-1.96-12.741-4.97-18.482-.42-.84-1.82-.07-1.33.84Z",
    transform: "translate(-1151.953 -538.884)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4419",
    "data-name": "Group 4419",
    transform: "translate(679.467 39.297)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4418",
    "data-name": "Group 4418"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2583",
    "data-name": "Path 2583",
    d: "M1138.844,590.7c4.551,7.7,11.481,14.352,17.292,21.142.63.77,1.75-.35,1.12-1.12-5.671-6.651-12.531-13.231-17.012-20.792-.56-.91-1.96-.07-1.4.77Z",
    transform: "translate(-1138.715 -589.537)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4421",
    "data-name": "Group 4421",
    transform: "translate(695.95 21.052)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4420",
    "data-name": "Group 4420"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2584",
    "data-name": "Path 2584",
    d: "M1169.848,564.263c-.49,3.85-2.17,7.351-3.36,10.991-1.05,3.22-2.1,6.441-4.13,9.241a.772.772,0,0,0,.28,1.05.069.069,0,0,1,.07.07c.35.14.91.14,1.05-.28.07-.14.07-.21.14-.35.42-.91-.98-1.75-1.33-.77-.07.14-.07.21-.14.35.35-.07.7-.21,1.05-.28a.069.069,0,0,1-.07-.07c.07.35.21.7.28,1.05,2.1-2.87,3.15-6.231,4.27-9.591,1.26-3.78,2.94-7.421,3.43-11.411.21-1.05-1.4-1.05-1.54,0Z",
    transform: "translate(-1162.259 -563.475)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4423",
    "data-name": "Group 4423",
    transform: "translate(722.299 37.976)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4422",
    "data-name": "Group 4422"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2585",
    "data-name": "Path 2585",
    d: "M1199.9,588.385a81.283,81.283,0,0,0,3.71,21.282.8.8,0,0,0,1.54-.42,81.538,81.538,0,0,1-3.64-20.862c-.14-.98-1.68-.98-1.61,0Z",
    transform: "translate(-1199.897 -587.65)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4425",
    "data-name": "Group 4425",
    transform: "translate(716.563 76.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4424",
    "data-name": "Group 4424"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2586",
    "data-name": "Path 2586",
    d: "M1192.681,653.8a42.014,42.014,0,0,0,18.692-9.871c.77-.7-.35-1.82-1.12-1.12a40.263,40.263,0,0,1-17.992,9.451.8.8,0,0,0,.42,1.54Z",
    transform: "translate(-1191.703 -642.583)",
    fill: "#e8e8e8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "ground",
    transform: "translate(0 447.071)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4427",
    "data-name": "Group 4427",
    transform: "translate(166.635 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4426",
    "data-name": "Group 4426"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2587",
    "data-name": "Path 2587",
    d: "M372.85,755H836.439a1.051,1.051,0,0,0,0-2.1H372.85a1.05,1.05,0,1,0,0,2.1Z",
    transform: "translate(-371.8 -752.9)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4429",
    "data-name": "Group 4429",
    transform: "translate(663.897 1.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4428",
    "data-name": "Group 4428"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2588",
    "data-name": "Path 2588",
    d: "M1083.15,757.5h157.8a1.052,1.052,0,0,0,0-2.1h-157.8a1.05,1.05,0,1,0,0,2.1Z",
    transform: "translate(-1082.1 -755.4)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4431",
    "data-name": "Group 4431",
    transform: "translate(620.475 16.872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4430",
    "data-name": "Group 4430"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2589",
    "data-name": "Path 2589",
    d: "M1021.073,779.1h85.059a1.051,1.051,0,0,0,0-2.1h-85.059a1.051,1.051,0,0,0,0,2.1Z",
    transform: "translate(-1020.075 -777)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4433",
    "data-name": "Group 4433",
    transform: "translate(0 108.161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4432",
    "data-name": "Group 4432"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2590",
    "data-name": "Path 2590",
    d: "M134.773,909.5H363.487a1.051,1.051,0,0,0,0-2.1H134.773a1.051,1.051,0,0,0,0,2.1Z",
    transform: "translate(-133.775 -907.4)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4435",
    "data-name": "Group 4435",
    transform: "translate(679.859 77.148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4434",
    "data-name": "Group 4434"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2591",
    "data-name": "Path 2591",
    d: "M1105.95,865.2h142.675a1.051,1.051,0,0,0,0-2.1H1105.95a1.05,1.05,0,0,0,0,2.1Z",
    transform: "translate(-1104.9 -863.1)",
    fill: "#161616"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "tools",
    transform: "translate(178.746 578.895)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4437",
    "data-name": "Group 4437",
    transform: "translate(60.758 4.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4436",
    "data-name": "Group 4436"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2592",
    "data-name": "Path 2592",
    d: "M477.506,1040.878c.21-1.12,4.06-1.61,4.9-1.89a30.68,30.68,0,0,0,6.441-2.73,27.4,27.4,0,0,0,10.291-10.851,31.816,31.816,0,0,0,3.15-9.311,15.706,15.706,0,0,0,.14-6.511c-.56-3.01-2.59-5.181-3.57-7.981-2.03-5.671.84-11.761,4.9-15.682,4.62-4.48,11.061-6.161,17.222-7.281,11.341-2.03,22.542-3.29,33.044-8.471a50.5,50.5,0,0,0,12.881-9.1c4.2-4.2,7.911-9.731,13.932-11.341,2.45-.7,7.561-.98,9.1,1.75v2.45c.77,1.75.28,2.8-1.33,3.01-.42.14-.84.21-1.26.35a23.748,23.748,0,0,0-3.15,1.05c-4.06,1.96-6.231,6.091-8.751,9.521-14.142,19.462-45.925,4.9-58.806,25.973a16.608,16.608,0,0,0-1.47,14.632c1.33,3.85,2.17,7.351,1.19,11.481a27.708,27.708,0,0,1-5.391,10.361,44.053,44.053,0,0,1-13.651,11.761,19.109,19.109,0,0,1-10.921,2.17c-2.03-.14-8.471-.91-8.961-3.71-.14-.98-1.68-.56-1.54.42.56,3.36,6.651,4.34,9.241,4.691a22.3,22.3,0,0,0,15.962-4.13c8.821-5.951,18.552-16.172,17.152-27.723-.35-2.94-1.82-5.6-2.45-8.471a14.656,14.656,0,0,1,2.45-11.131c4.06-6.3,10.991-9.381,18.132-10.851,11.831-2.52,25.343-1.4,35.354-9.241,4.62-3.57,6.651-9.311,11.061-12.951,2.73-2.24,9.8-2.1,10.011-6.791.21-4.27-4.971-6.581-8.471-6.651-5.391-.14-9.8,3.15-13.441,6.861-4.831,4.9-9.1,9.591-15.192,13.021a70.674,70.674,0,0,1-19.392,7c-11.691,2.59-26.463,1.89-35,11.761-3.36,3.92-5.531,9.241-4.34,14.421.77,3.36,3.36,5.881,3.99,9.311.63,3.15-.21,6.581-1.12,9.661a26.3,26.3,0,0,1-12.881,15.892c-2.87,1.47-5.881,1.96-8.821,3.08-.98.35-2.03.77-2.17,1.89C475.826,1041.438,477.366,1041.858,477.506,1040.878Z",
    transform: "translate(-475.887 -947.694)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4439",
    "data-name": "Group 4439",
    transform: "translate(60.65 95.183)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4438",
    "data-name": "Group 4438"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2593",
    "data-name": "Path 2593",
    d: "M477.88,1078.659a.531.531,0,0,1-.14-.28.789.789,0,0,0-1.26-.14c-2.94,3.57,3.5,8.961,7.071,6.861,1.75-1.05,1.75-3.43.77-5.04s-3.36-3.78-5.321-2.52c-.84.56-.07,1.89.77,1.33,1.75-1.12,5.741,4.27,2.38,5.04-1.82.42-6.3-2.52-4.62-4.551a7.72,7.72,0,0,0-1.26-.14.532.532,0,0,1,.14.28c.63.77,1.96,0,1.47-.84Z",
    transform: "translate(-475.732 -1077.162)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4441",
    "data-name": "Group 4441",
    transform: "translate(61.878 96.19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4440",
    "data-name": "Group 4440"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2594",
    "data-name": "Path 2594",
    d: "M479.036,1081.54a2.309,2.309,0,0,1-.07-1.68l-1.47.21a3.482,3.482,0,0,1,.07,2.52c.49.07,1.05.14,1.54.21,0-.35.14-2.52.63-2.52-.21-.07-.35-.14-.56-.21a3.838,3.838,0,0,1,.28,1.75,7.229,7.229,0,0,1-.28,2.1h1.54a4.547,4.547,0,0,1-.14-2.73,1,1,0,0,1,.14-.42q.315-.315-.21-.42c-.07.14.14.63.21.84a5.3,5.3,0,0,1,.07,1.05,11.59,11.59,0,0,1-.21,2.24l1.47-.21a4.857,4.857,0,0,1-.56-1.96c0-.21.28-1.75.21-1.82.21.07.28,1.47.28,1.61a3.863,3.863,0,0,1-.35,2.17h1.33a2.918,2.918,0,0,1-.56-1.26,9.041,9.041,0,0,1,.21-1.61c.14.07.21,1.12.21,1.26a1.834,1.834,0,0,1-.28,1.47h1.12c-.28-.35-.77-1.61-.21-1.96-.21.14-.14.42-.21.63a2.748,2.748,0,0,1-.56.98c-.77.7.35,1.82,1.12,1.12a3.241,3.241,0,0,0,1.05-2.8c-.14-.77-.56-1.61-1.47-1.61-.98.07-1.47,1.05-1.61,1.96a3.72,3.72,0,0,0,.84,2.8.852.852,0,0,0,1.12,0c.98-1.26,1.33-5.32-.91-5.531-1.12-.14-1.68,1.05-1.82,1.96a4.7,4.7,0,0,0,.7,3.36.758.758,0,0,0,1.33,0,5.645,5.645,0,0,0,.49-3.71c-.14-.98-.28-2.38-1.54-2.45-1.19-.07-1.75,1.26-1.89,2.24a6.154,6.154,0,0,0,.7,3.85.818.818,0,0,0,1.47-.21,11.717,11.717,0,0,0,.14-4.13c-.14-.84-.42-1.96-1.4-1.96-2.31,0-2.03,4.27-1.54,5.6a.813.813,0,0,0,1.54,0,8.643,8.643,0,0,0,.28-3.29c-.07-.77-.14-1.89-.91-2.24-1.96-.91-2.52,2.87-2.52,3.99a.787.787,0,0,0,1.54.21,5.058,5.058,0,0,0-.28-3.78c-.28-.63-1.26-.42-1.47.21a4.417,4.417,0,0,0,.07,2.52.691.691,0,1,0,1.33-.35Z",
    transform: "translate(-477.486 -1078.599)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4443",
    "data-name": "Group 4443",
    transform: "translate(67.406 100.217)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4442",
    "data-name": "Group 4442"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2595",
    "data-name": "Path 2595",
    d: "M486.8,1085.716h0a.858.858,0,0,0-1.12-.07l-.07.07a.81.81,0,0,0,.35,1.33c1.33.49,3.29.07,4.69-.07a31.516,31.516,0,0,0,5.111-1.05.8.8,0,0,0-.42-1.54,34.837,34.837,0,0,1-4.69.98c-1.19.14-3.15.49-4.27.14.14.42.21.91.35,1.33l.07-.07h-1.12l.07.07c.7.63,1.82-.42,1.05-1.12Z",
    transform: "translate(-485.383 -1084.352)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4445",
    "data-name": "Group 4445",
    transform: "translate(52.457 93.798)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4444",
    "data-name": "Group 4444"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2596",
    "data-name": "Path 2596",
    d: "M468.77,1077.085a6.96,6.96,0,0,1-3.36-1.68c-.77-.7-1.89.42-1.12,1.12a9.046,9.046,0,0,0,4.06,2.1c1.05.21,1.47-1.33.42-1.54Z",
    transform: "translate(-464.03 -1075.183)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4447",
    "data-name": "Group 4447",
    transform: "translate(49.52 100.161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4446",
    "data-name": "Group 4446"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2597",
    "data-name": "Path 2597",
    d: "M467.3,1084.432a33.932,33.932,0,0,0-7.281,6.511c-.63.77.49,1.89,1.12,1.12a32.849,32.849,0,0,1,6.931-6.3c.84-.56.07-1.96-.77-1.33Z",
    transform: "translate(-459.834 -1084.272)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4449",
    "data-name": "Group 4449",
    transform: "translate(56.357 106.19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4448",
    "data-name": "Group 4448"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2598",
    "data-name": "Path 2598",
    d: "M471.7,1093.245a15.99,15.99,0,0,0-2.1,7.631c0,.98,1.54.98,1.61,0a14.339,14.339,0,0,1,1.89-6.791.818.818,0,0,0-1.4-.84Z",
    transform: "translate(-469.6 -1092.884)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4451",
    "data-name": "Group 4451",
    transform: "translate(64.374 111.664)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4450",
    "data-name": "Group 4450"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2599",
    "data-name": "Path 2599",
    d: "M481.085,1101.681a13.4,13.4,0,0,0,2.45,4.76c.63.77,1.75-.35,1.12-1.12a11.088,11.088,0,0,1-2.03-4.06.8.8,0,0,0-1.54.42Z",
    transform: "translate(-481.052 -1100.703)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4453",
    "data-name": "Group 4453",
    transform: "translate(178.079)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4452",
    "data-name": "Group 4452"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2600",
    "data-name": "Path 2600",
    d: "M645.031,946.24a4.54,4.54,0,0,1,3.99-3.43c.98-.07.98-1.61,0-1.61a6.052,6.052,0,0,0-5.531,4.55c-.21,1.05,1.26,1.47,1.54.49Z",
    transform: "translate(-643.471 -941.2)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4455",
    "data-name": "Group 4455",
    transform: "translate(179.43 5.876)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4454",
    "data-name": "Group 4454"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2601",
    "data-name": "Path 2601",
    d: "M646.52,952.258a5.147,5.147,0,0,1,4.48-.91.8.8,0,0,0,.42-1.54,6.782,6.782,0,0,0-5.671,1.05c-.84.63,0,1.96.77,1.4Z",
    transform: "translate(-645.4 -949.594)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4457",
    "data-name": "Group 4457",
    transform: "translate(182.685 12.739)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4456",
    "data-name": "Group 4456"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2602",
    "data-name": "Path 2602",
    d: "M650.785,961.009a3.135,3.135,0,0,1,2.1,1.12.792.792,0,0,0,1.12-1.12,4.375,4.375,0,0,0-3.22-1.61c-.98-.07-.98,1.54,0,1.61Z",
    transform: "translate(-650.05 -959.397)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4459",
    "data-name": "Group 4459",
    transform: "translate(129.469 55.479)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4458",
    "data-name": "Group 4458"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2603",
    "data-name": "Path 2603",
    d: "M575.411,1025.525c2.52-2.52,6.931-4.2,10.5-3.22,2.59.77,3.92,3.781,3.57,6.3-.42,3.43-5.6,4.69-8.4,3.99a.8.8,0,0,0-.42,1.54c2.8.7,7.211,0,9.241-2.31,1.89-2.17,1.4-5.531.14-7.911-3.08-5.881-12.111-3.29-15.822.49-.63.7.49,1.82,1.19,1.12Z",
    transform: "translate(-574.035 -1020.448)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4461",
    "data-name": "Group 4461",
    transform: "translate(129.379 51.814)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4460",
    "data-name": "Group 4460"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2604",
    "data-name": "Path 2604",
    d: "M575.372,1023.044c3.5-5.6,12.391-9.1,17.432-3.22.63.77,1.75-.35,1.12-1.12-5.671-6.651-15.892-2.87-19.882,3.57-.56.84.77,1.61,1.33.77Z",
    transform: "translate(-573.907 -1015.212)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4463",
    "data-name": "Group 4463",
    transform: "translate(148.209 42.413)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4462",
    "data-name": "Group 4462"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2605",
    "data-name": "Path 2605",
    d: "M601.781,1015.937q16.172-5.776,31.783-12.741c.91-.42.14-1.75-.77-1.33q-15.437,6.826-31.433,12.6c-.98.35-.56,1.82.42,1.47Z",
    transform: "translate(-600.803 -1001.784)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4465",
    "data-name": "Group 4465",
    transform: "translate(135.663 60.985)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4464",
    "data-name": "Group 4464"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2606",
    "data-name": "Path 2606",
    d: "M583.1,1036.564c6.161,6.791,17.852,1.19,17.572-7.491a.806.806,0,0,0-1.61,0c.21,7.351-9.661,12.181-14.912,6.371-.63-.77-1.75.35-1.05,1.12Z",
    transform: "translate(-582.882 -1028.312)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4467",
    "data-name": "Group 4467",
    transform: "translate(152.179 46.938)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4466",
    "data-name": "Group 4466"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2607",
    "data-name": "Path 2607",
    d: "M607.4,1023.756a301.348,301.348,0,0,0,30.1-14.072c.91-.49.07-1.82-.77-1.33a310.694,310.694,0,0,1-29.753,13.932c-.91.35-.49,1.89.42,1.47Z",
    transform: "translate(-606.475 -1008.248)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4469",
    "data-name": "Group 4469",
    transform: "translate(180.303 42.366)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4468",
    "data-name": "Group 4468"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2608",
    "data-name": "Path 2608",
    d: "M646.754,1002.9a13.031,13.031,0,0,1,1.82,4.83c.14.98,1.68.56,1.54-.42a14.3,14.3,0,0,0-2.03-5.181.769.769,0,1,0-1.33.77Z",
    transform: "translate(-646.648 -1001.717)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4471",
    "data-name": "Group 4471",
    transform: "translate(238.502 63.672)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4470",
    "data-name": "Group 4470"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2609",
    "data-name": "Path 2609",
    d: "M732.594,1035.055c-.77.49-1.89-.7-.56-1.26a2.939,2.939,0,0,1,1.12-.07,8.039,8.039,0,0,1,3.15.49c.42.14,1.4.49.42,1.33-.21.21-.84.07-1.05.07a12.893,12.893,0,0,1-3.29-.49.8.8,0,0,0-.42,1.54c1.82.49,5.321,1.33,6.651-.56,1.54-2.24-1.82-3.5-3.43-3.781-1.89-.28-5.111-.56-5.391,2.03a2.316,2.316,0,0,0,3.64,2.1c.77-.63,0-1.96-.84-1.4Z",
    transform: "translate(-729.78 -1032.15)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4473",
    "data-name": "Group 4473",
    transform: "translate(234.334 61.099)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4472",
    "data-name": "Group 4472"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2610",
    "data-name": "Path 2610",
    d: "M725.418,1033.113a4.914,4.914,0,0,1,5.531-2.94.8.8,0,0,0,.42-1.54,6.482,6.482,0,0,0-7.491,4.061c-.35.98,1.19,1.4,1.54.42Z",
    transform: "translate(-723.827 -1028.475)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4475",
    "data-name": "Group 4475",
    transform: "translate(231.228 65.335)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4474",
    "data-name": "Group 4474"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2611",
    "data-name": "Path 2611",
    d: "M723.037,1034.578c-2.24.91-4.34,1.54-3.43,4.411.84,2.87,3.92,1.54,6.021,2.24,1.89.63,3.36,2.17,5.391,2.45,2.66.28,4.9-.91,4.831-3.78a.806.806,0,0,0-1.61,0c-.77,1.68-1.82,2.38-3.15,2.17a1.417,1.417,0,0,1-1.47-.84c-.21-.14-.28-.42-.49-.56-.91-.56-2.1-.56-3.08-1.05a4.492,4.492,0,0,0-2.24-.91c-.35,0-.91.28-1.12.28-2.1-.42-.14-2.52.77-2.87s.56-1.89-.42-1.54Z",
    transform: "translate(-719.389 -1034.526)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4477",
    "data-name": "Group 4477",
    transform: "translate(241.201 59.556)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4476",
    "data-name": "Group 4476"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2612",
    "data-name": "Path 2612",
    d: "M735.151,1028.462a1.342,1.342,0,0,1,1.68-.7,1.969,1.969,0,0,1,1.61,1.19c.28.28.35.7.63.98.98,1.05,2.8,1.26,3.71,2.31.56.14.7.49.49,1.12.28.7.07.98-.56.84-.21.14-.63.14-.84.35a1.6,1.6,0,0,0-.49.7c-.77,1.05-.98,1.4-2.17,1.75a.8.8,0,0,0,.42,1.54,6.041,6.041,0,0,0,2.73-1.61c.49-.56.56-.91,1.33-1.19.42-.14.84,0,1.26-.21,2.03-1.12.56-3.43-.77-4.34-.77-.56-1.75-.91-2.52-1.47a8.079,8.079,0,0,1-1.89-1.89,3.294,3.294,0,0,0-2.31-1.47c-1.75-.35-4.41.28-3.71,2.66.21.84,1.75.42,1.4-.56Z",
    transform: "translate(-733.636 -1026.272)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4479",
    "data-name": "Group 4479",
    transform: "translate(200.984 97.588)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4478",
    "data-name": "Group 4478"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2613",
    "data-name": "Path 2613",
    d: "M676.267,1099.431c1.26,2.87,4.76,2.1,7,.98,4.971-2.31,9.171-6.021,14.7-7.141,2.31-.49,5.32-.91,6.511,1.75.35.84.28,1.82.7,2.66a5.885,5.885,0,0,0,3.15,2.8c3.22,1.33,6.861.63,9.871-.84,9.591-4.76,15.682-17.712,27.583-17.432,6.021.14,8.611,5.741,13.791,7.631a14.409,14.409,0,0,0,12.531-1.4c.84-.56.07-1.89-.77-1.33-5.6,3.43-11.411,2.03-16.172-2.1-2.94-2.59-5.811-4.48-9.871-4.411-9.1.14-15.192,7.631-21.422,13.161-3.71,3.22-8.821,7.071-14.071,5.531-4.27-1.26-2.52-6.37-6.581-7.631-3.43-1.05-7.841.49-10.921,1.96-2.24,1.05-12.951,8.891-14.632,4.971-.42-.91-1.82-.07-1.4.84Z",
    transform: "translate(-676.189 -1080.597)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4481",
    "data-name": "Group 4481",
    transform: "translate(200.61 102.133)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4480",
    "data-name": "Group 4480"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2614",
    "data-name": "Path 2614",
    d: "M676.106,1100.818c-1.19,1.89.14,3.78,2.03,4.62,3.15,1.33,6.931-.84,9.521-2.45,3.64-2.31,9.8-6.861,14-2.94,2.59,2.38,2.03,6.3,5.951,7.491,2.94.91,6.231-.14,8.891-1.47a60.381,60.381,0,0,0,11.761-7.841c3.99-3.29,8.051-9.591,13.651-9.521,5.321.07,9.521,3.99,14,6.37,3.43,1.82,7.421,3.01,11.131,1.33,2.94-1.33,5.11-3.99,4.76-7.281-.07-.98-1.68-.98-1.61,0,.35,3.361-2.31,5.671-5.391,6.371-2.87.63-5.671-.49-8.121-1.82-3.99-2.1-7.421-5.181-11.9-6.231a10.749,10.749,0,0,0-9.941,2.38c-4.06,3.43-7.491,7.281-11.831,10.361-3.71,2.59-8.4,6.161-13.161,6.091-5.32-.07-4.62-6.441-8.611-8.471-2.66-1.33-6.021-.7-8.681.42a39.6,39.6,0,0,0-5.25,3.08c-.91.56-1.82,1.12-2.73,1.61a9.581,9.581,0,0,1-2.66,1.05c-2.03.84-3.5,0-4.48-2.38.56-.84-.77-1.61-1.33-.77Z",
    transform: "translate(-675.655 -1087.089)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4483",
    "data-name": "Group 4483",
    transform: "translate(196.677 112.942)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4482",
    "data-name": "Group 4482"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2615",
    "data-name": "Path 2615",
    d: "M674.632,1104.539a3.011,3.011,0,0,0-4.2-1.68c-.91.49-.07,1.82.77,1.33a1.388,1.388,0,0,1,1.89.7c.35,1.05,1.89.63,1.54-.35Z",
    transform: "translate(-670.037 -1102.529)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4485",
    "data-name": "Group 4485",
    transform: "translate(195.024 117.384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4484",
    "data-name": "Group 4484"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2616",
    "data-name": "Path 2616",
    d: "M671.613,1108.962a3.2,3.2,0,0,0-3.92,2.52.8.8,0,1,0,1.54.42,1.6,1.6,0,0,1,1.96-1.4c.98.21,1.4-1.33.42-1.54Z",
    transform: "translate(-667.676 -1108.874)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4487",
    "data-name": "Group 4487",
    transform: "translate(196.6 121.115)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4486",
    "data-name": "Group 4486"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2617",
    "data-name": "Path 2617",
    d: "M670.958,1114.761c-.35.91-.63,1.75-.98,2.66-.35.98,1.19,1.33,1.54.42s.63-1.75.98-2.661c.35-.98-1.19-1.4-1.54-.42Z",
    transform: "translate(-669.927 -1114.203)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4489",
    "data-name": "Group 4489",
    transform: "translate(298.431 102.867)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4488",
    "data-name": "Group 4488"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2618",
    "data-name": "Path 2618",
    d: "M816.865,1090.911a2.157,2.157,0,0,1,2.38-1.12.8.8,0,0,0,.42-1.54,3.765,3.765,0,0,0-4.2,1.82c-.42.91.91,1.75,1.4.84Z",
    transform: "translate(-815.385 -1088.137)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4491",
    "data-name": "Group 4491",
    transform: "translate(299.704 106.081)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4490",
    "data-name": "Group 4490"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2619",
    "data-name": "Path 2619",
    d: "M818.181,1094.319a2.306,2.306,0,0,1,2.1.49.718.718,0,0,0,1.05-.28.772.772,0,0,0-.28-1.05,3.968,3.968,0,0,0-3.29-.63c-.98.14-.56,1.68.42,1.47Z",
    transform: "translate(-817.203 -1092.728)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4493",
    "data-name": "Group 4493",
    transform: "translate(299.142 109.106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4492",
    "data-name": "Group 4492"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2620",
    "data-name": "Path 2620",
    d: "M816.4,1097.785a12,12,0,0,0,.63,3.851.8.8,0,0,0,1.54-.42,14.136,14.136,0,0,1-.63-3.431.771.771,0,0,0-1.54,0Z",
    transform: "translate(-816.4 -1097.05)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4495",
    "data-name": "Group 4495",
    transform: "translate(144.452 83.24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4494",
    "data-name": "Group 4494"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2621",
    "data-name": "Path 2621",
    d: "M598.562,1087.333c-1.4-1.75-1.4-2.94.07-3.71a5.117,5.117,0,0,1,2.59-1.33c2.03.42,2.52-.14,1.4-1.75a2.669,2.669,0,0,1,.21-3.5c1.68-3.29,4.2-4.411,7.7-4.691,1.96-.14,1.54-.14,2.03-2.03a13.888,13.888,0,0,1,1.54-3.64c1.82-2.94,7.141-7.421,10.361-3.29.63.77,1.96,0,1.33-.77-5.251-6.931-13.721,2.03-14.842,7.771-.42,1.96-.49,5.951,2.52,5.881,2.73-.07,2.24-3.08.63-4.34-5.951-4.761-15.4,3.29-13.581,9.941.56,2.1,3.5,4.55,5.671,2.8,1.82-1.54.07-3.5-1.68-3.99-3.15-.84-7.771,1.05-8.891,4.27-.84,2.52,1.33,5.181,3.85,3.71.77-.49,0-1.82-.91-1.33Z",
    transform: "translate(-595.437 -1060.102)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4497",
    "data-name": "Group 4497",
    transform: "translate(215.67 2.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4496",
    "data-name": "Group 4496"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2622",
    "data-name": "Path 2622",
    d: "M699.15,946.387a.669.669,0,0,1-.7-.14,7.716,7.716,0,0,1,.14,1.26,2.522,2.522,0,0,1,3.01-.07,7.713,7.713,0,0,1-.14-1.26,2.6,2.6,0,0,1-3.01.7,7.714,7.714,0,0,1,.14,1.26,1.859,1.859,0,0,1,2.38-.56v-1.33a.972.972,0,0,1-.77.14.8.8,0,0,0-.42,1.54,2.733,2.733,0,0,0,1.96-.28.759.759,0,0,0,0-1.33,3.531,3.531,0,0,0-4.341.77.838.838,0,0,0,.14,1.26,4.181,4.181,0,0,0,4.9-.98.838.838,0,0,0-.14-1.26,4.1,4.1,0,0,0-4.9.28.838.838,0,0,0,.14,1.26,2.04,2.04,0,0,0,1.89.28.783.783,0,1,0-.28-1.54Z",
    transform: "translate(-697.167 -945.423)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4499",
    "data-name": "Group 4499",
    transform: "translate(233.548 19.696)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4498",
    "data-name": "Group 4498"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2623",
    "data-name": "Path 2623",
    d: "M724.451,971.831c-.21,0-.21-.07,0-.28a.532.532,0,0,1,.56-.42,2.552,2.552,0,0,1,1.05-.14c.35,0,2.17-.21,2.38.14.49.7-1.68.98-1.96.98a9.3,9.3,0,0,1-2.8-.21.8.8,0,0,0-.42,1.54c1.89.49,4.62.63,6.231-.7,1.47-1.19.7-2.87-.98-3.22-1.54-.28-4.13-.42-5.32.91-.98,1.05-.35,3.22,1.26,3.08.98-.21.98-1.75,0-1.68Z",
    transform: "translate(-722.703 -969.334)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4501",
    "data-name": "Group 4501",
    transform: "translate(233.523 21.303)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4500",
    "data-name": "Group 4500"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2624",
    "data-name": "Path 2624",
    d: "M722.9,972.309a10.683,10.683,0,0,0-.14,3.64.76.76,0,0,0,.56.56c1.89.63,4.2,1.05,5.741-.49a2.973,2.973,0,0,0,.35-4.13c-.63-.77-1.75.35-1.12,1.12s-.14,1.96-.91,2.31a5.666,5.666,0,0,1-3.71-.28l.56.56a7.939,7.939,0,0,1,.14-2.87c.28-1.05-1.26-1.47-1.47-.42Z",
    transform: "translate(-722.669 -971.63)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4503",
    "data-name": "Group 4503",
    transform: "translate(0 31.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4502",
    "data-name": "Group 4502"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2625",
    "data-name": "Path 2625",
    d: "M391.41,996.771a2.742,2.742,0,0,1,3.29,1.82c1.47,1.68.56,2.59-2.87,2.73-1.19-.77-.84-2.8-.56-3.85.56-2.17,1.75-2.17,3.57-2.94,1.26-.49,2.45-.98,3.71-1.54,2.03-.84,4.13-1.68,6.161-2.52,2.1-.84,4.55-2.38,6.791-2.8,1.54-.28,3.5-.07,3.57,2.1l-1.89,4.2a8.133,8.133,0,0,1-1.26.28c-1.61.63-3.36.98-4.971,1.68-4.2,1.82-8.051,4.41-12.531,5.671a.8.8,0,0,0,.42,1.54c5.251-1.54,9.661-4.831,14.842-6.651,2.94-.98,7-.98,7.351-4.9.14-2.24-1.26-6.161-3.92-6.091-2.24.07-5.391,2.03-7.491,2.87-2.87,1.19-5.811,2.38-8.681,3.5-2.87,1.19-7.911,1.96-7.841,5.881.07,2.31,1.68,6.161,4.27,6.581,5.881.98,4.13-10.781-2.31-9.241-1.05.42-.63,1.89.35,1.68Z",
    transform: "translate(-389.099 -985.499)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4505",
    "data-name": "Group 4505",
    transform: "translate(25.892 28.393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4504",
    "data-name": "Group 4504"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2626",
    "data-name": "Path 2626",
    d: "M427.285,988.648c2.24-.98,4.48-1.89,6.721-2.8l2.94-1.26c.35-.14,4.27-1.75,2.24-.91-4.06,1.68-8.051,3.36-12.111,5.041-.91.35-.49,1.89.42,1.54,3.5-1.47,7-2.87,10.431-4.34,1.19-.49,4.2-1.19,3.64-3.15-.63-2.1-3.36-.35-4.551.14-3.5,1.47-7.071,2.94-10.571,4.41-.84.35-.07,1.68.84,1.33Z",
    transform: "translate(-426.084 -981.758)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4507",
    "data-name": "Group 4507",
    transform: "translate(324.044 67.058)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4506",
    "data-name": "Group 4506"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2627",
    "data-name": "Path 2627",
    d: "M855.351,1038.466c-2.45,2.24-3.99,5.6-3.15,8.961.84,3.29,3.85,3.92,6.861,4.55,10.711,2.1,21.7,1.33,32.483,2.52,4.13.49,9.731,2.66,13.791,1.05,2.31-.91,4.41-3.57,3.64-6.161-.98-3.36-6.3-4.34-9.1-5.25a124.465,124.465,0,0,0-15.752-4.2,136.893,136.893,0,0,0-17.642-2.38c-3.15-.21-9.661-1.82-11.761,1.54-.56.84.84,1.68,1.33.77,1.05-1.75,4.761-.98,6.441-.91,2.38.07,4.76.21,7.141.49a128.672,128.672,0,0,1,27.233,5.46c2.1.63,4.13,1.33,6.161,2.1s5.671,1.68,3.78,5.391c-.91,1.75-3.5,2.17-5.181,2.1-4.27-.07-8.611-1.4-12.811-1.75-4.55-.35-9.1-.49-13.581-.63a114.471,114.471,0,0,1-13.932-1.19c-2.38-.42-5.391-.56-6.861-2.66-1.96-2.87-.35-6.441,1.96-8.541a.82.82,0,0,0-1.05-1.26Z",
    transform: "translate(-851.97 -1036.987)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4509",
    "data-name": "Group 4509",
    transform: "translate(372.756 76.756)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4508",
    "data-name": "Group 4508"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2628",
    "data-name": "Path 2628",
    d: "M924.666,1058.3c-2.66-.63-1.26-3.78.07-5.04.98-.91,2.66-1.47,3.08.28a5.153,5.153,0,0,1-.49,3.08c-.56,1.12-2.1,1.89-3.01.56a3.286,3.286,0,0,1,.28-3.29.891.891,0,0,1,.49-.63c.28-.28.35-.21.21.35a10.866,10.866,0,0,1-.28,1.47,9.479,9.479,0,0,1-1.33,2.66l1.47.21a3.951,3.951,0,0,1,.07-2.38c.21-.63,1.05-2.1,1.89-1.96a6.156,6.156,0,0,0-.7-.42c.35.42.84,3.29-.21,3.22-.7-.07,1.26-2.38,1.54-2.59-.35-.07-.7-.21-1.05-.28a1.5,1.5,0,0,1,.28,1.54c-1.4.07-1.75.07-.98-.07.98-.21.56-1.75-.42-1.54s-1.61.7-1.47,1.82a2.156,2.156,0,0,0,1.75,1.82c2.52.49,3.29-2.73,2.17-4.411a.731.731,0,0,0-1.05-.28c-1.33.91-3.57,3.78-2.24,5.461,1.54,1.89,3.43-1.26,3.64-2.52.28-1.75-.56-4.34-2.66-2.94a5.456,5.456,0,0,0-2.1,5.951.835.835,0,0,0,1.47.21c1.05-1.47,2.66-4.55,1.68-6.37-.84-1.54-2.52-.49-3.22.56-1.12,1.68-1.68,4.13-.21,5.811a3.15,3.15,0,0,0,4.55,0c2.45-2.38,2.03-9.311-2.66-7.421-3.36,1.33-5.741,7.631-1.05,8.821,1.05.07,1.47-1.4.49-1.68Z",
    transform: "translate(-921.551 -1050.84)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4511",
    "data-name": "Group 4511",
    transform: "translate(376.293 81.119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4510",
    "data-name": "Group 4510"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2629",
    "data-name": "Path 2629",
    d: "M927.161,1058.632q20.792,4.516,41.444,9.941a.8.8,0,0,0,.42-1.54q-20.582-5.461-41.444-9.941c-.98-.21-1.4,1.33-.42,1.54Z",
    transform: "translate(-926.603 -1057.072)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4513",
    "data-name": "Group 4513",
    transform: "translate(378.043 79.589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4512",
    "data-name": "Group 4512"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2630",
    "data-name": "Path 2630",
    d: "M929.661,1056.506c6.581,1.68,13.231,3.29,19.812,4.97,6.161,1.54,14.281,2.24,19.252,6.371.77.63,1.89-.49,1.12-1.12-4.76-3.92-11.481-4.691-17.292-6.161l-22.472-5.671c-.98-.14-1.4,1.4-.42,1.61Z",
    transform: "translate(-929.103 -1054.887)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4515",
    "data-name": "Group 4515",
    transform: "translate(367.03 74.829)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4514",
    "data-name": "Group 4514"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2631",
    "data-name": "Path 2631",
    d: "M918.572,1048.1a6.17,6.17,0,0,0-3.29,10.571c.7.7,1.82-.42,1.12-1.12a4.576,4.576,0,0,1,2.59-7.911c1.05-.14.56-1.68-.42-1.54Z",
    transform: "translate(-913.372 -1048.087)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4517",
    "data-name": "Group 4517",
    transform: "translate(450.15 66.193)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4516",
    "data-name": "Group 4516"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2632",
    "data-name": "Path 2632",
    d: "M1035.6,1040.826c-1.4-1.75-1.47-2.73-.07-3.081a2.9,2.9,0,0,1,1.33-.35,14.129,14.129,0,0,1,2.45-.07c.84.07,4.34,0,4.97.98-.07.91-.21,1.89-.28,2.8-.35,0-.7.07-.98.07a11.968,11.968,0,0,1-2.24,0,36.168,36.168,0,0,1-5.531-.7c-.98-.21-1.4,1.33-.42,1.54a36.28,36.28,0,0,0,7.281.84c1.47,0,3.29,0,4.2-1.26,2.52-3.29-2.59-5.321-4.97-5.6-2.94-.42-8.261-.77-9.171,3.22a2.744,2.744,0,0,0,4.48,2.73c.84-.7-.28-1.82-1.05-1.12Z",
    transform: "translate(-1032.103 -1035.751)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4519",
    "data-name": "Group 4519",
    transform: "translate(445.056 58.918)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4518",
    "data-name": "Group 4518"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2633",
    "data-name": "Path 2633",
    d: "M1026.348,1036.239a7.234,7.234,0,0,1,5.811-5.25c.7-.14.7-1.12.21-1.47-.14-1.82.42-2.59,1.61-2.24a2.311,2.311,0,0,0,.98,0,1.985,1.985,0,0,0,1.19-.49c-.35-.07-.7-.21-1.05-.28.7,1.4,1.33,2.8,2.03,4.271.42.91,1.82.14,1.33-.77-.7-1.4-1.33-2.8-2.03-4.271a.808.808,0,0,0-1.05-.28c-.98.63-2.31-.07-3.43.42a3.012,3.012,0,0,0-1.47,1.33,2.712,2.712,0,0,0,1.12,3.71l.21-1.47a8.741,8.741,0,0,0-6.931,6.371c-.35.98,1.19,1.4,1.47.42Z",
    transform: "translate(-1024.827 -1025.359)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4521",
    "data-name": "Group 4521",
    transform: "translate(441.173 69.788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4520",
    "data-name": "Group 4520"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2634",
    "data-name": "Path 2634",
    d: "M1023.775,1040.9a16.5,16.5,0,0,0-4.13,1.19.79.79,0,0,0-.28,1.05,5.948,5.948,0,0,1,.77,2.38.76.76,0,0,0,.56.56,3.481,3.481,0,0,0,2.38-.07,7.467,7.467,0,0,1,3.5-.28c.63.21,1.33,1.19,1.82,1.61,1.33,1.12,2.31,1.82,4.06,1.54-.35-.28-.63-.49-.98-.77a4.72,4.72,0,0,1-1.05,3.57.809.809,0,0,0,.7,1.19c2.03.07,3.64,1.47,5.321-.28,1.33-1.33,1.05-3.29.7-4.9-.28.35-.49.63-.77.98a32.345,32.345,0,0,0,6.861-.91c-.35-.21-.63-.35-.98-.56.84,2.38,3.36,4.83,5.811,2.45,1.96-1.96.49-4.69-1.82-5.321a.8.8,0,0,0-.42,1.54c-.7.35-1.4.63-2.03.98a.858.858,0,0,0-.98-.56,33.849,33.849,0,0,1-6.441.84.8.8,0,0,0-.77.98c.35,2.1-.28,3.29-2.94,3.43-.07,0-1.68-.21-1.54-.21a10.546,10.546,0,0,0,.7,1.19,6.469,6.469,0,0,0,1.26-4.34.8.8,0,0,0-.98-.77c-2.38.35-3.85-3.22-6.161-3.57a3.994,3.994,0,0,0-2.03.28c-2.45.7-2.1.42-3.08-1.68-.07.35-.21.7-.28,1.05a14.478,14.478,0,0,1,3.78-1.05c.91-.14.49-1.68-.56-1.54Z",
    transform: "translate(-1019.28 -1040.887)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4523",
    "data-name": "Group 4523",
    transform: "translate(457.091 61.08)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4522",
    "data-name": "Group 4522"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2635",
    "data-name": "Path 2635",
    d: "M1042.915,1031.775a8.864,8.864,0,0,1,7.421,0,.819.819,0,0,0,1.19-.7l2.94-.21c.14.63.21,1.19.35,1.82-.14.21-.77.35-.98.49a2.469,2.469,0,0,0-.84,1.19c-.63,1.89.14,4.97.35,6.931.07.98,1.68.98,1.61,0a27.248,27.248,0,0,1-.35-4.761c.07-1.05-.07-1.54.84-2.38.21-.21.63-.28.91-.49,1.12-.98.63-2.1-.14-3.22-1.61-2.31-6.091-3.22-6.161.63a10.537,10.537,0,0,0,1.19-.7,10.283,10.283,0,0,0-8.611-.14c-1.05.42-.63,1.96.28,1.54Z",
    transform: "translate(-1042.017 -1028.448)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4525",
    "data-name": "Group 4525",
    transform: "translate(394.543 110.283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4524",
    "data-name": "Group 4524"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2636",
    "data-name": "Path 2636",
    d: "M954.862,1102.979c-1.26-2.03,1.82-2.87,3.22-2.59a12.094,12.094,0,0,1,1.47.49c.98.35,1.47.42,1.68,1.47.14,1.05-.49,1.12-1.4,1.47a6.13,6.13,0,0,1-2.24.49,3.26,3.26,0,0,1-3.36-2.52c-.21-.98-1.75-.56-1.54.42a4.9,4.9,0,0,0,5.671,3.57c1.82-.21,6.161-1.68,4.76-4.27-1.12-2.1-5.041-3.15-7.211-2.66s-3.78,2.94-2.52,4.97c.63.84,2.03.07,1.47-.84Z",
    transform: "translate(-952.672 -1098.73)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4527",
    "data-name": "Group 4527",
    transform: "translate(394.312 113.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4526",
    "data-name": "Group 4526"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2637",
    "data-name": "Path 2637",
    d: "M953.363,1104.371a2.893,2.893,0,0,0-.7,3.57,4.373,4.373,0,0,0,4.13,2.38c1.54.07,3.85,0,5.041-1.26,1.26-1.4.77-3.36.21-4.9-.35-.98-1.89-.56-1.54.42.28.84.77,2.03.49,2.87-.42,1.26-2.1,1.26-3.22,1.26-1.05.07-2.38.07-3.15-.7a1.746,1.746,0,0,1-.14-2.59c.77-.56-.35-1.68-1.12-1.05Z",
    transform: "translate(-952.343 -1103.603)",
    fill: "#e8e8e8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shelves_x26_pics",
    transform: "translate(94.877)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4529",
    "data-name": "Group 4529",
    transform: "translate(455.888 132.931)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4528",
    "data-name": "Group 4528"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2638",
    "data-name": "Path 2638",
    d: "M920.5,304.963v9.8a.806.806,0,0,0,1.61,0v-9.8a.805.805,0,0,0-1.61,0Z",
    transform: "translate(-920.5 -304.175)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4531",
    "data-name": "Group 4531",
    transform: "translate(455.923 142.679)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4530",
    "data-name": "Group 4530"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2639",
    "data-name": "Path 2639",
    d: "M921.285,319.71H1067.25a.806.806,0,0,0,0-1.61H921.285a.808.808,0,0,0,0,1.61Z",
    transform: "translate(-920.55 -318.1)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4533",
    "data-name": "Group 4533",
    transform: "translate(601.503 131.907)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4532",
    "data-name": "Group 4532"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2640",
    "data-name": "Path 2640",
    d: "M1130.11,314.535V303.474a.806.806,0,0,0-1.61,0v11.061a.805.805,0,0,0,1.61,0Z",
    transform: "translate(-1128.5 -302.712)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4535",
    "data-name": "Group 4535",
    transform: "translate(457.507 131.408)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4534",
    "data-name": "Group 4534"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2641",
    "data-name": "Path 2641",
    d: "M1068.139,302H923.574a.806.806,0,0,0,0,1.61h144.565a.805.805,0,0,0,0-1.61Z",
    transform: "translate(-922.812 -302)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4537",
    "data-name": "Group 4537",
    transform: "translate(473.32 119.655)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4536",
    "data-name": "Group 4536"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2642",
    "data-name": "Path 2642",
    d: "M947.01,297.245V285.974a.806.806,0,0,0-1.61,0v11.271a.808.808,0,0,0,1.61,0Z",
    transform: "translate(-945.4 -285.212)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4539",
    "data-name": "Group 4539",
    transform: "translate(473.092 119.787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4538",
    "data-name": "Group 4538"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2643",
    "data-name": "Path 2643",
    d: "M945.863,287.01h120.2a.806.806,0,0,0,0-1.61h-120.2a.805.805,0,0,0,0,1.61Z",
    transform: "translate(-945.075 -285.4)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4541",
    "data-name": "Group 4541",
    transform: "translate(593.522 120.382)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4540",
    "data-name": "Group 4540"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2644",
    "data-name": "Path 2644",
    d: "M1117.1,286.985v11.061a.806.806,0,0,0,1.61,0V286.985a.808.808,0,0,0-1.61,0Z",
    transform: "translate(-1117.1 -286.25)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4543",
    "data-name": "Group 4543",
    transform: "translate(524.005 107.124)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4542",
    "data-name": "Group 4542"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2645",
    "data-name": "Path 2645",
    d: "M1019.41,279.835V268.074a.806.806,0,0,0-1.61,0v11.761a.808.808,0,0,0,1.61,0Z",
    transform: "translate(-1017.8 -267.312)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4545",
    "data-name": "Group 4545",
    transform: "translate(524.04 106.555)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4544",
    "data-name": "Group 4544"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2646",
    "data-name": "Path 2646",
    d: "M1018.585,268.11h81.839a.806.806,0,0,0,0-1.61h-81.839a.808.808,0,0,0,0,1.61Z",
    transform: "translate(-1017.85 -266.5)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4547",
    "data-name": "Group 4547",
    transform: "translate(606.334 106.818)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4546",
    "data-name": "Group 4546"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2647",
    "data-name": "Path 2647",
    d: "M1135.4,267.663v12.811a.806.806,0,0,0,1.61,0V267.663a.805.805,0,0,0-1.61,0Z",
    transform: "translate(-1135.4 -266.875)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4549",
    "data-name": "Group 4549",
    transform: "translate(594.091 119.577)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4548",
    "data-name": "Group 4548"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2648",
    "data-name": "Path 2648",
    d: "M1130.715,285.1h-12.041a.806.806,0,0,0,0,1.61h12.041a.808.808,0,0,0,0-1.61Z",
    transform: "translate(-1117.912 -285.1)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4551",
    "data-name": "Group 4551",
    transform: "translate(541.181 106.437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4550",
    "data-name": "Group 4550"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2649",
    "data-name": "Path 2649",
    d: "M1042.521,267.709c2.45,3.15,1.89,9.1,1.54,12.811-.07.98,1.47.98,1.61,0,.42-4.2.77-10.361-1.96-13.931-.7-.77-1.82.35-1.19,1.12Z",
    transform: "translate(-1042.335 -266.33)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4553",
    "data-name": "Group 4553",
    transform: "translate(554.352 106.707)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4552",
    "data-name": "Group 4552"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2650",
    "data-name": "Path 2650",
    d: "M1061.255,267.9a21.87,21.87,0,0,1,2.59,12.741c-.07.98,1.47.98,1.61,0a23.855,23.855,0,0,0-2.8-13.511.8.8,0,0,0-1.4.77Z",
    transform: "translate(-1061.148 -266.717)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4555",
    "data-name": "Group 4555",
    transform: "translate(497.322 120.289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4554",
    "data-name": "Group 4554"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2651",
    "data-name": "Path 2651",
    d: "M979.765,287.3a14.924,14.924,0,0,1,.63,10.011.8.8,0,0,0,1.54.42,16.686,16.686,0,0,0-.77-11.2c-.49-.91-1.82-.14-1.4.77Z",
    transform: "translate(-979.685 -286.117)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4557",
    "data-name": "Group 4557",
    transform: "translate(512.211 120.118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4556",
    "data-name": "Group 4556"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2652",
    "data-name": "Path 2652",
    d: "M1001.056,287.082a13.308,13.308,0,0,1,.91,10.711c-.35.98,1.19,1.4,1.54.42a15.028,15.028,0,0,0-1.05-11.9c-.49-.98-1.89-.14-1.4.77Z",
    transform: "translate(-1000.954 -285.873)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4559",
    "data-name": "Group 4559",
    transform: "translate(203.441 69.417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4558",
    "data-name": "Group 4558"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2653",
    "data-name": "Path 2653",
    d: "M559.9,214.185v9.451a.806.806,0,0,0,1.61,0v-9.451a.808.808,0,0,0-1.61,0Z",
    transform: "translate(-559.9 -213.45)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4561",
    "data-name": "Group 4561",
    transform: "translate(203.476 79.533)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4560",
    "data-name": "Group 4560"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2654",
    "data-name": "Path 2654",
    d: "M560.685,229.51h282.41a.806.806,0,0,0,0-1.61H560.685c-.98.07-.98,1.61,0,1.61Z",
    transform: "translate(-559.95 -227.9)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4563",
    "data-name": "Group 4563",
    transform: "translate(486.131 71.21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4562",
    "data-name": "Group 4562"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2655",
    "data-name": "Path 2655",
    d: "M965.31,224.825v-8.051a.806.806,0,0,0-1.61,0v8.051c.07.98,1.61.98,1.61,0Z",
    transform: "translate(-963.7 -216.012)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4565",
    "data-name": "Group 4565",
    transform: "translate(203.476 69.732)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4564",
    "data-name": "Group 4564"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2656",
    "data-name": "Path 2656",
    d: "M560.685,215.51h282.41a.806.806,0,0,0,0-1.61H560.685a.808.808,0,0,0,0,1.61Z",
    transform: "translate(-559.95 -213.9)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4567",
    "data-name": "Group 4567",
    transform: "translate(485.886 70.782)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4566",
    "data-name": "Group 4566"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2657",
    "data-name": "Path 2657",
    d: "M964.085,217.01a.806.806,0,0,0,0-1.61.806.806,0,0,0,0,1.61Z",
    transform: "translate(-963.35 -215.4)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4569",
    "data-name": "Group 4569",
    transform: "translate(215.903 52.965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4568",
    "data-name": "Group 4568"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2658",
    "data-name": "Path 2658",
    d: "M580.08,205.737c-.28-5.041-.49-10.081-.77-15.052-.07-.98-1.61-.98-1.61,0,.28,5.041.49,10.081.77,15.052a.805.805,0,0,0,1.61,0Z",
    transform: "translate(-577.7 -189.95)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4571",
    "data-name": "Group 4571",
    transform: "translate(216.148 53.21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4570",
    "data-name": "Group 4570"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2659",
    "data-name": "Path 2659",
    d: "M578.785,191.91H707.669a.806.806,0,0,0,0-1.61H578.785a.808.808,0,0,0,0,1.61Z",
    transform: "translate(-578.05 -190.3)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4573",
    "data-name": "Group 4573",
    transform: "translate(343.946 53.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4572",
    "data-name": "Group 4572"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2660",
    "data-name": "Path 2660",
    d: "M760.6,191.163v15.822a.806.806,0,0,0,1.61,0V191.163a.805.805,0,0,0-1.61,0Z",
    transform: "translate(-760.6 -190.375)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4575",
    "data-name": "Group 4575",
    transform: "translate(252.937 46.638)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4574",
    "data-name": "Group 4574"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2661",
    "data-name": "Path 2661",
    d: "M632.21,188.324v-6.651a.806.806,0,0,0-1.61,0v6.651c.07.98,1.61.98,1.61,0Z",
    transform: "translate(-630.6 -180.912)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4577",
    "data-name": "Group 4577",
    transform: "translate(253.339 46.209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4576",
    "data-name": "Group 4576"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2662",
    "data-name": "Path 2662",
    d: "M631.963,181.91h99.76a.806.806,0,0,0,0-1.61h-99.76a.805.805,0,0,0,0,1.61Z",
    transform: "translate(-631.175 -180.3)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4579",
    "data-name": "Group 4579",
    transform: "translate(353.047 46.944)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4578",
    "data-name": "Group 4578",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2663",
    "data-name": "Path 2663",
    d: "M773.6,182.085v5.6a.806.806,0,0,0,1.61,0v-5.6a.808.808,0,0,0-1.61,0Z",
    transform: "translate(-773.6 -181.35)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4581",
    "data-name": "Group 4581",
    transform: "translate(343.281 53.21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4580",
    "data-name": "Group 4580",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2664",
    "data-name": "Path 2664",
    d: "M760.385,191.91h9.8a.806.806,0,0,0,0-1.61h-9.8a.808.808,0,0,0,0,1.61Z",
    transform: "translate(-759.65 -190.3)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4583",
    "data-name": "Group 4583",
    transform: "translate(229.064 36.041)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4582",
    "data-name": "Group 4582"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2665",
    "data-name": "Path 2665",
    d: "M596.5,166.563v10.571a.806.806,0,0,0,1.61,0V166.563a.805.805,0,0,0-1.61,0Z",
    transform: "translate(-596.5 -165.775)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4585",
    "data-name": "Group 4585",
    transform: "translate(229.467 34.238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4584",
    "data-name": "Group 4584"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2666",
    "data-name": "Path 2666",
    d: "M597.863,164.81h89.889a.806.806,0,0,0,0-1.61H597.863a.805.805,0,0,0,0,1.61Z",
    transform: "translate(-597.075 -163.2)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4587",
    "data-name": "Group 4587",
    transform: "translate(318.674 33.94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4586",
    "data-name": "Group 4586",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2667",
    "data-name": "Path 2667",
    d: "M724.5,163.563v11.271a.806.806,0,0,0,1.61,0V163.563a.805.805,0,0,0-1.61,0Z",
    transform: "translate(-724.5 -162.775)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4589",
    "data-name": "Group 4589",
    transform: "translate(229.785 45.847)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4588",
    "data-name": "Group 4588"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2668",
    "data-name": "Path 2668",
    d: "M597.789,181.125l1.05,1.05c.7.7,1.82-.42,1.12-1.12l-1.05-1.05c-.77-.7-1.89.42-1.12,1.12Z",
    transform: "translate(-597.53 -179.783)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4591",
    "data-name": "Group 4591",
    transform: "translate(229.799 46.629)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4590",
    "data-name": "Group 4590"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2669",
    "data-name": "Path 2669",
    d: "M598.285,182.51h23.943a.806.806,0,0,0,0-1.61H598.285c-.98.07-.98,1.61,0,1.61Z",
    transform: "translate(-597.55 -180.9)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4593",
    "data-name": "Group 4593",
    transform: "translate(243.475 34.204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4592",
    "data-name": "Group 4592"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2670",
    "data-name": "Path 2670",
    d: "M617.165,164.376a19.885,19.885,0,0,1,1.54,11.2c-.14.98,1.33,1.4,1.54.42a21.036,21.036,0,0,0-1.68-12.391c-.49-.98-1.82-.21-1.4.77Z",
    transform: "translate(-617.085 -163.152)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4595",
    "data-name": "Group 4595",
    transform: "translate(253.136 35.129)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4594",
    "data-name": "Group 4594"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2671",
    "data-name": "Path 2671",
    d: "M630.965,165.682a15.687,15.687,0,0,1,1.05,9.8c-.21.98,1.33,1.4,1.54.42a17.472,17.472,0,0,0-1.26-10.991c-.42-.98-1.75-.14-1.33.77Z",
    transform: "translate(-630.884 -164.473)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4597",
    "data-name": "Group 4597",
    transform: "translate(278.889 47.191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4596",
    "data-name": "Group 4596"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2672",
    "data-name": "Path 2672",
    d: "M667.691,182.681a11.123,11.123,0,0,1,.21,5.251c-.21.98,1.33,1.4,1.54.42a12.822,12.822,0,0,0-.21-6.091.8.8,0,0,0-1.54.42Z",
    transform: "translate(-667.671 -181.703)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4599",
    "data-name": "Group 4599",
    transform: "translate(285.759 46.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4598",
    "data-name": "Group 4598",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2673",
    "data-name": "Path 2673",
    d: "M677.565,182.176a8.407,8.407,0,0,1,.56,4.34c-.14.98,1.33,1.4,1.54.42a9.318,9.318,0,0,0-.7-5.531c-.49-.98-1.82-.21-1.4.77Z",
    transform: "translate(-677.484 -180.952)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4601",
    "data-name": "Group 4601",
    transform: "translate(318.654 54.192)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4600",
    "data-name": "Group 4600"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2674",
    "data-name": "Path 2674",
    d: "M724.492,192.681a40.758,40.758,0,0,1,.77,15.122c-.14.98,1.4,1.4,1.54.42a42.219,42.219,0,0,0-.77-15.962c-.21-.98-1.75-.56-1.54.42Z",
    transform: "translate(-724.472 -191.703)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4603",
    "data-name": "Group 4603",
    transform: "translate(336.702 54.472)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4602",
    "data-name": "Group 4602",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2675",
    "data-name": "Path 2675",
    d: "M750.706,193.081a29.6,29.6,0,0,1-.42,14.842.8.8,0,0,0,1.54.42,32.141,32.141,0,0,0,.42-15.682c-.21-.98-1.75-.56-1.54.42Z",
    transform: "translate(-750.252 -192.103)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4605",
    "data-name": "Group 4605",
    transform: "translate(399.733 48.362)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4604",
    "data-name": "Group 4604"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2676",
    "data-name": "Path 2676",
    d: "M840.3,184.163a77.5,77.5,0,0,0,4.27,20.652.8.8,0,0,0,1.54-.42,77.145,77.145,0,0,1-4.2-20.232c-.14-1.05-1.75-1.05-1.61,0Z",
    transform: "translate(-840.288 -183.375)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4607",
    "data-name": "Group 4607",
    transform: "translate(400.101 46.702)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4606",
    "data-name": "Group 4606"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2677",
    "data-name": "Path 2677",
    d: "M841.574,183.522a153.756,153.756,0,0,1,31.083-.28c.98.07.98-1.47,0-1.61a159.032,159.032,0,0,0-31.083.28c-.98.14-1.05,1.68,0,1.61Z",
    transform: "translate(-840.812 -181.004)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4609",
    "data-name": "Group 4609",
    transform: "translate(428.884 47.541)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4608",
    "data-name": "Group 4608"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2678",
    "data-name": "Path 2678",
    d: "M884.5,183.181c1.54,7.421-.14,14.7-2.52,21.772-.35.98,1.19,1.4,1.54.42,2.45-7.351,4.13-14.912,2.52-22.612a.8.8,0,0,0-1.54.42Z",
    transform: "translate(-881.927 -182.203)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4611",
    "data-name": "Group 4611",
    transform: "translate(402.725 17.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4610",
    "data-name": "Group 4610"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2679",
    "data-name": "Path 2679",
    d: "M851.239,168.486a27.152,27.152,0,0,1-3.29-5.041c-.28-.56-3.64-8.4-.28-7.841.56.07,1.19-.35.98-.98a17.8,17.8,0,0,1,0-11.131c.21-2.03,1.12-2.38,2.8-1.05a2.472,2.472,0,0,1,2.66,1.54,15.772,15.772,0,0,1,2.17,4.831c1.96,6.021,2.52,12.671,2.87,18.972.07.98,1.61.98,1.61,0a104.3,104.3,0,0,0-2.1-16.172c-.84-3.78-2.24-8.541-5.32-11.2-2.31-2.03-4.481-1.19-5.741,1.33-2.03,4.06-1.75,9.031-.49,13.231l.98-.98c-8.261-1.4.35,13.441,2.03,15.542.63.91,1.75-.21,1.12-1.05Z",
    transform: "translate(-844.56 -139.277)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4613",
    "data-name": "Group 4613",
    transform: "translate(415.607)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4612",
    "data-name": "Group 4612"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2680",
    "data-name": "Path 2680",
    d: "M865.3,146.5a11.214,11.214,0,0,1-.28-6.441c.49-1.89,1.75-3.22,2.31-4.971.77-2.38.63-11.971,4.06-12.391.35-.07.7-.21.77-.56a14.268,14.268,0,0,1,1.19-3.29c.91-1.54,1.05-2.1,2.87-1.61,2.1.49,1.61,1.33,1.68,3.22v2.66a124.106,124.106,0,0,1-.7,12.531,132.812,132.812,0,0,1-5.181,25.063.8.8,0,0,0,1.54.42,132.536,132.536,0,0,0,5.461-28.143c.42-4.69,1.05-10.081.35-14.772-.28-1.68-.98-3.78-2.94-3.92-2.52-.14-4.34,3.22-5.181,5.181a4.4,4.4,0,0,1-1.4,2.03,6.762,6.762,0,0,0-1.96,2.45c-1.75,4.2-1.54,8.821-3.5,13.021a12.919,12.919,0,0,0-.77,9.941c.42.98,1.96.56,1.68-.42Z",
    transform: "translate(-862.962 -114.294)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4615",
    "data-name": "Group 4615",
    transform: "translate(407.549 19.398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4614",
    "data-name": "Group 4614"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2681",
    "data-name": "Path 2681",
    d: "M851.486,142.981a132.859,132.859,0,0,1,4.9,26.183c.07.98,1.68.98,1.61,0a137.01,137.01,0,0,0-4.9-26.6c-.35-.98-1.89-.56-1.61.42Z",
    transform: "translate(-851.452 -142.003)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4617",
    "data-name": "Group 4617",
    transform: "translate(405.13 32.646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4616",
    "data-name": "Group 4616"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2682",
    "data-name": "Path 2682",
    d: "M848.559,162.448a10.41,10.41,0,0,1,6.091,5.461c.42.91,1.82.14,1.33-.77a12.273,12.273,0,0,0-7.071-6.161c-.91-.35-1.33,1.19-.35,1.47Z",
    transform: "translate(-847.997 -160.926)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4619",
    "data-name": "Group 4619",
    transform: "translate(410.489 22.981)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4618",
    "data-name": "Group 4618"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2683",
    "data-name": "Path 2683",
    d: "M857.856,147.526a22.667,22.667,0,0,0-2.17,5.6.8.8,0,0,0,1.54.42,22.149,22.149,0,0,1,2.03-5.181c.42-.98-.98-1.75-1.4-.84Z",
    transform: "translate(-855.652 -147.12)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4621",
    "data-name": "Group 4621",
    transform: "translate(418.26 2.317)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4620",
    "data-name": "Group 4620"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2684",
    "data-name": "Path 2684",
    d: "M876.8,118.161c-2.73,14.842-6.091,29.613-10.011,44.175a.8.8,0,0,0,1.54.42c3.92-14.632,7.211-29.333,10.011-44.175.21-.98-1.33-1.4-1.54-.42Z",
    transform: "translate(-866.752 -117.603)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4623",
    "data-name": "Group 4623",
    transform: "translate(419.993 12.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4622",
    "data-name": "Group 4622"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2685",
    "data-name": "Path 2685",
    d: "M869.278,132.694a41.187,41.187,0,0,1,2.24,16.242c-.07.98,1.54.98,1.61,0a42.027,42.027,0,0,0-2.31-16.662c-.35-.91-1.89-.56-1.54.42Z",
    transform: "translate(-869.227 -131.746)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4625",
    "data-name": "Group 4625",
    transform: "translate(419.228 33.058)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4624",
    "data-name": "Group 4624"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2686",
    "data-name": "Path 2686",
    d: "M869.44,170.465a32.86,32.86,0,0,1,8.681-7.491c.84-.49.07-1.89-.77-1.33a35.182,35.182,0,0,0-9.031,7.7c-.63.77.49,1.89,1.12,1.12Z",
    transform: "translate(-868.134 -161.514)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4627",
    "data-name": "Group 4627",
    transform: "translate(0 66.686)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4626",
    "data-name": "Group 4626"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2687",
    "data-name": "Path 2687",
    d: "M269.3,210.285v70.637a.806.806,0,0,0,1.61,0V210.285c-.07-.98-1.61-.98-1.61,0Z",
    transform: "translate(-269.3 -209.55)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4629",
    "data-name": "Group 4629",
    transform: "translate(0.035 66.581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4628",
    "data-name": "Group 4628"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2688",
    "data-name": "Path 2688",
    d: "M270.085,211.01H372.716a.806.806,0,0,0,0-1.61H270.085c-.98.07-.98,1.61,0,1.61Z",
    transform: "translate(-269.35 -209.4)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4631",
    "data-name": "Group 4631",
    transform: "translate(103.471 67.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4630",
    "data-name": "Group 4630"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2689",
    "data-name": "Path 2689",
    d: "M417.1,210.985v66.157a.806.806,0,0,0,1.61,0V210.985c-.07-.98-1.61-.98-1.61,0Z",
    transform: "translate(-417.1 -210.25)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4633",
    "data-name": "Group 4633",
    transform: "translate(0.105 137.359)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4632",
    "data-name": "Group 4632"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2690",
    "data-name": "Path 2690",
    d: "M270.185,312.11h102.7a.806.806,0,0,0,0-1.61h-102.7c-.98.07-.98,1.61,0,1.61Z",
    transform: "translate(-269.45 -310.5)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4635",
    "data-name": "Group 4635",
    transform: "translate(103.751 134.243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4634",
    "data-name": "Group 4634"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2691",
    "data-name": "Path 2691",
    d: "M417.5,306.785v2.87a.806.806,0,0,0,1.61,0v-2.87a.808.808,0,0,0-1.61,0Z",
    transform: "translate(-417.5 -306.05)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4637",
    "data-name": "Group 4637",
    transform: "translate(4.55 73.564)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4636",
    "data-name": "Group 4636"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2692",
    "data-name": "Path 2692",
    d: "M275.8,220.163v58.106a.806.806,0,0,0,1.61,0V220.163a.805.805,0,0,0-1.61,0Z",
    transform: "translate(-275.8 -219.375)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4639",
    "data-name": "Group 4639",
    transform: "translate(4.936 131.618)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4638",
    "data-name": "Group 4638"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2693",
    "data-name": "Path 2693",
    d: "M277.085,303.91h92.41a.806.806,0,0,0,0-1.61h-92.41a.808.808,0,0,0,0,1.61Z",
    transform: "translate(-276.35 -302.3)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4641",
    "data-name": "Group 4641",
    transform: "translate(97.94 73.59)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4640",
    "data-name": "Group 4640"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2694",
    "data-name": "Path 2694",
    d: "M410.81,278.28V220.174a.806.806,0,0,0-1.61,0V278.28c.07.98,1.61.98,1.61,0Z",
    transform: "translate(-409.2 -219.412)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4643",
    "data-name": "Group 4643",
    transform: "translate(4.936 72.532)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4642",
    "data-name": "Group 4642"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2695",
    "data-name": "Path 2695",
    d: "M277.085,219.51h92.41a.806.806,0,0,0,0-1.61h-92.41c-.98.07-.98,1.61,0,1.61Z",
    transform: "translate(-276.35 -217.9)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4645",
    "data-name": "Group 4645",
    transform: "translate(21.156 88.112)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4644",
    "data-name": "Group 4644"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2696",
    "data-name": "Path 2696",
    d: "M311.967,268.54c-3.78-.21-8.261-1.75-10.221-5.321-2.38-4.27,2.03-6.161,4.971-7.911a18.348,18.348,0,0,0,4.69-3.64c1.19-1.47,1.26-2.87,1.75-4.621,2.31-8.611,13.511-4.27,19.672-3.57,6.441.7,12.461-.77,18.832-.98,7.141-.28,13.721,6.021,11.271,13.371a10.917,10.917,0,0,1-7.281,6.931c-2.87.77-5.881,0-8.821.35-5.461.56-9.871,4.41-15.192,5.531-6.581,1.33-13.511.35-20.092-.56-.98-.14-1.4,1.4-.42,1.54,6.091.84,12.321,1.68,18.482.91a28.367,28.367,0,0,0,8.261-2.24c3.36-1.54,6.371-3.57,10.151-3.71,5.181-.21,9.661.42,13.581-3.64a11.718,11.718,0,0,0,2.8-11.831,12.172,12.172,0,0,0-9.521-8.121,26.834,26.834,0,0,0-7.841.35,56.624,56.624,0,0,1-12.881.63c-5.671-.49-12.251-3.22-17.852-.98a7.314,7.314,0,0,0-4.2,3.71,8.995,8.995,0,0,0-.49,2.38,8.15,8.15,0,0,1-3.99,5.881c-3.29,2.24-9.031,3.99-7.981,9.031,1.12,5.321,7.7,7.841,12.391,8.121.98,0,.98-1.54-.07-1.61Z",
    transform: "translate(-299.519 -240.156)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4647",
    "data-name": "Group 4647",
    transform: "translate(40.055 98.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4646",
    "data-name": "Group 4646"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2697",
    "data-name": "Path 2697",
    d: "M328.885,262.767c-2.59-1.54,1.68-4.62,2.66-5.111a10.285,10.285,0,0,1,4.27-1.19,16.236,16.236,0,0,1,4.13.42,18.082,18.082,0,0,1,1.82.56c1.96.07,2.66.98,2.03,2.66-.07,2.31-1.4,2.87-3.43,3.57a15.808,15.808,0,0,1-3.15.7c-3.08.56-6.441,1.19-9.031-1.05-.77-.63-1.89.42-1.12,1.12,3.64,3.15,9.451,2.1,13.721.7,2.66-.91,8.4-4.55,4.76-7.631s-10.151-3.57-14.352-1.54c-2.66,1.33-7.071,5.671-3.08,8.051.84.63,1.61-.7.77-1.26Z",
    transform: "translate(-326.515 -254.754)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4649",
    "data-name": "Group 4649",
    transform: "translate(127.973 109.268)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4648",
    "data-name": "Group 4648"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2698",
    "data-name": "Path 2698",
    d: "M452.1,271.163v46.695a.806.806,0,0,0,1.61,0V271.163a.805.805,0,0,0-1.61,0Z",
    transform: "translate(-452.1 -270.375)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4651",
    "data-name": "Group 4651",
    transform: "translate(128.008 108.726)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4650",
    "data-name": "Group 4650"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2699",
    "data-name": "Path 2699",
    d: "M452.885,271.21h71.057a.806.806,0,0,0,0-1.61H452.885c-.98.07-.98,1.61,0,1.61Z",
    transform: "translate(-452.15 -269.6)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4653",
    "data-name": "Group 4653",
    transform: "translate(128.499 157.381)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4652",
    "data-name": "Group 4652"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2700",
    "data-name": "Path 2700",
    d: "M453.585,340.71h69.1a.806.806,0,0,0,0-1.61h-69.1c-.98.07-.98,1.61,0,1.61Z",
    transform: "translate(-452.85 -339.1)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4655",
    "data-name": "Group 4655",
    transform: "translate(199.521 109.758)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4654",
    "data-name": "Group 4654"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2701",
    "data-name": "Path 2701",
    d: "M554.3,271.863v46.695a.806.806,0,0,0,1.61,0V271.863a.805.805,0,0,0-1.61,0Z",
    transform: "translate(-554.3 -271.075)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4657",
    "data-name": "Group 4657",
    transform: "translate(132.174 112.979)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4656",
    "data-name": "Group 4656"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2702",
    "data-name": "Path 2702",
    d: "M458.1,276.463V317a.806.806,0,0,0,1.61,0V276.463a.805.805,0,0,0-1.61,0Z",
    transform: "translate(-458.1 -275.675)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4659",
    "data-name": "Group 4659",
    transform: "translate(132.699 153.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4658",
    "data-name": "Group 4658"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2703",
    "data-name": "Path 2703",
    d: "M459.585,335.81h62.167a.806.806,0,0,0,0-1.61H459.585c-.98.07-.98,1.61,0,1.61Z",
    transform: "translate(-458.85 -334.2)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4661",
    "data-name": "Group 4661",
    transform: "translate(194.831 114.405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4660",
    "data-name": "Group 4660"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2704",
    "data-name": "Path 2704",
    d: "M549.21,317.328V278.474a.806.806,0,0,0-1.61,0v38.854a.805.805,0,0,0,1.61,0Z",
    transform: "translate(-547.6 -277.712)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4663",
    "data-name": "Group 4663",
    transform: "translate(132.436 112.926)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4662",
    "data-name": "Group 4662"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2705",
    "data-name": "Path 2705",
    d: "M459.263,277.21h61.956a.806.806,0,0,0,0-1.61H459.263a.805.805,0,0,0,0,1.61Z",
    transform: "translate(-458.475 -275.6)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4665",
    "data-name": "Group 4665",
    transform: "translate(194.674 113.403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4664",
    "data-name": "Group 4664"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2706",
    "data-name": "Path 2706",
    d: "M547.393,277.274c.14.56.21,1.19.35,1.75a.82.82,0,0,0,.98.56.858.858,0,0,0,.56-.98c-.14-.56-.21-1.19-.35-1.75a.82.82,0,0,0-.98-.56.8.8,0,0,0-.56.98Z",
    transform: "translate(-547.376 -276.281)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4667",
    "data-name": "Group 4667",
    transform: "translate(132.785 131.674)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4666",
    "data-name": "Group 4666"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2707",
    "data-name": "Path 2707",
    d: "M460.182,311.7A21.761,21.761,0,0,0,469,303.654a7.713,7.713,0,0,1-1.26.14c3.43,2.94,6.791,6.231,10.5,8.961,3.01,2.24,5.6.84,8.891,1.82a30.594,30.594,0,0,1,3.01,1.54c.28.14.91-.42,1.12-.35,1.61.63,1.47,2.87,1.75,4.06a3.852,3.852,0,0,0,1.12,2.1,11.887,11.887,0,0,0,3.64,1.26c-.84.49-.07,1.89.77,1.33,2.24-1.33.14-2.8-1.12-3.43-1.61-.84-1.68,2.24-2.94-2.17-.21-.63.14-1.4,0-2.03-.21-1.12-.7-2.45-1.82-2.87-1.19-.42-2.45,0-3.64-.42a12.5,12.5,0,0,0-4.551-.84c-6.091,0-11.131-6.371-15.542-10.151a.832.832,0,0,0-1.26.14,20.756,20.756,0,0,1-8.261,7.491.83.83,0,0,0,.77,1.47Z",
    transform: "translate(-458.973 -302.38)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4669",
    "data-name": "Group 4669",
    transform: "translate(157.865 120.067)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4668",
    "data-name": "Group 4668"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2708",
    "data-name": "Path 2708",
    d: "M496.269,308.622l1.26-4.621c.21-.84.28-2.52.84-3.08,1.47-1.75,6.161-1.26,8.261-1.54a.828.828,0,0,0,.77-.77c.14-1.47-.14-4.55.84-5.671a3.248,3.248,0,0,1,2.17-.91c1.4-.21,1.47-.49,1.89,1.33.21.91,1.47.63,1.54-.21.21-2.17.49-4.41.7-6.581l-.77.77c2.52,0,4.2-.63,4.9,2.1.56,2.24.35,4.76,1.12,7,.21.63.77,1.05,1.05,1.54.84,1.61.07,4.27-.21,6.091-.07.28.28.7.56.77a58.362,58.362,0,0,0,10.5.56c.98-.07,1.05-1.61,0-1.61-2.31.07-5.461.49-7.7-.21-3.29-1.05-.21-3.5-1.19-5.811-.49-1.05-1.26-1.61-1.61-2.8a71.026,71.026,0,0,1-1.33-8.611.759.759,0,0,0-.77-.56h-5.251a.735.735,0,0,0-.77.77c-.21,2.17-.49,4.41-.7,6.581.49-.07,1.05-.14,1.54-.21a6.664,6.664,0,0,0-1.19-2.59.8.8,0,0,0-.91-.35c-1.61.42-3.15.91-4.76,1.33a.759.759,0,0,0-.56.77c-.21,2.17-.35,4.341-.56,6.511l.77-.77c-2.94.35-5.881.63-8.751.98-.35.07-.7.21-.77.56-.7,3.01-1.54,5.951-2.31,8.891-.42.91,1.12,1.33,1.4.35Z",
    transform: "translate(-494.797 -285.8)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4671",
    "data-name": "Group 4671",
    transform: "translate(147.185 120.726)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4670",
    "data-name": "Group 4670"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2709",
    "data-name": "Path 2709",
    d: "M482.1,292.873c-2.94-2.24,1.05-6.091,3.71-3.85,1.26,1.05,2.1,3.57,0,4.2-1.68.49-4.13-.07-4.13-2.17a.806.806,0,0,0-1.61,0c0,3.15,3.36,4.48,6.091,3.71,2.94-.84,2.94-4.2,1.26-6.3a4.542,4.542,0,0,0-6.581-.56,4.147,4.147,0,0,0,.42,6.371c.91.56,1.68-.77.84-1.4Z",
    transform: "translate(-479.543 -286.741)",
    fill: "#e8e8e8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "color",
    transform: "translate(103.031 31.184)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_108",
    "data-name": "Ellipse 108",
    cx: 3.99,
    cy: 3.99,
    r: 3.99,
    transform: "translate(263.545 112.545)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_109",
    "data-name": "Ellipse 109",
    cx: 5.321,
    cy: 5.321,
    r: 5.321,
    transform: "translate(514.662 167.431)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_110",
    "data-name": "Ellipse 110",
    cx: 8.051,
    cy: 8.051,
    r: 8.051,
    transform: "translate(504.861 355.051)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_111",
    "data-name": "Ellipse 111",
    cx: 3.43,
    cy: 3.43,
    r: 3.43,
    transform: "translate(16.069 271.392)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_112",
    "data-name": "Ellipse 112",
    cx: 7.141,
    cy: 7.141,
    r: 7.141,
    transform: "translate(37.002 147.059)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_113",
    "data-name": "Ellipse 113",
    cx: 6.021,
    cy: 6.021,
    r: 6.021,
    transform: "translate(504.861 150.979)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_114",
    "data-name": "Ellipse 114",
    cx: 2.03,
    cy: 2.03,
    r: 2.03,
    transform: "translate(535.734 161.34)",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_115",
    "data-name": "Ellipse 115",
    cx: 7.911,
    cy: 7.911,
    r: 7.911,
    transform: "translate(330.823 57.729)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_116",
    "data-name": "Ellipse 116",
    cx: 3.22,
    cy: 3.22,
    r: 3.22,
    transform: "translate(356.935 73.061)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_117",
    "data-name": "Ellipse 117",
    cx: 5.461,
    cy: 5.461,
    r: 5.461,
    transform: "translate(518.442 382.773)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_118",
    "data-name": "Ellipse 118",
    cx: 4.971,
    cy: 4.971,
    r: 4.971,
    transform: "translate(345.664 355.051)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_119",
    "data-name": "Ellipse 119",
    cx: 5.671,
    cy: 5.671,
    r: 5.671,
    transform: "translate(12.359 250.53)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4673",
    "data-name": "Group 4673",
    transform: "translate(466.495 236.737)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4672",
    "data-name": "Group 4672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2710",
    "data-name": "Path 2710",
    d: "M947.3,497.98a4.117,4.117,0,0,0,3.01,3.99c3.08,1.05,5.811-1.12,8.681-1.68,4.76-.91,8.541,1.61,11.131,5.321,1.33,1.89,2.73,3.78,5.181,3.99,3.29.28,6.161-2.31,8.891-3.71,2.31-1.12,5.181-2.31,7.771-1.61,2.17.56,3.5,2.38,4.9,3.99a15.548,15.548,0,0,0,16.1,5.32,1.053,1.053,0,0,0-.56-2.03,13.505,13.505,0,0,1-10.5-1.47c-2.59-1.61-3.92-4.27-6.231-6.161-4.34-3.5-9.871-1.4-14.141,1.05-2.17,1.26-3.64,2.45-6.231,1.96-2.52-.42-2.87-1.68-4.2-3.5a12.074,12.074,0,0,0-5.25-4.27,12.719,12.719,0,0,0-6.231-.98c-2.17.21-10.081,4.341-10.291-.07,0-1.47-2.1-1.47-2.03-.14Z",
    transform: "translate(-947.297 -496.999)",
    fill: "#636363"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4675",
    "data-name": "Group 4675",
    transform: "translate(495.911 256.116)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4674",
    "data-name": "Group 4674"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2711",
    "data-name": "Path 2711",
    d: "M990.845,529.454a16.468,16.468,0,0,1,17.922,0c1.75,1.19,3.29,3.36,5.531,3.71,2.73.42,4.48-1.96,6.581-3.22,2.24-1.26,4.271-1.89,6.581-.56a33.847,33.847,0,0,1,3.43,2.87,12.887,12.887,0,0,0,5.881,2.45,13.791,13.791,0,0,0,11.691-3.57c.98-.91-.49-2.38-1.47-1.47a11.7,11.7,0,0,1-8.541,3.15c-3.64-.14-5.811-1.96-8.4-4.2-3.5-3.08-7.421-2.38-11.131.14-2.03,1.4-2.94,2.94-6.511.98-.91-.49-1.68-1.47-2.59-2.1a18.044,18.044,0,0,0-6.721-2.66,18.582,18.582,0,0,0-13.3,2.66c-1.12.7-.07,2.52,1.05,1.82Z",
    transform: "translate(-989.316 -524.68)",
    fill: "#636363"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4677",
    "data-name": "Group 4677",
    transform: "translate(0 317.194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4676",
    "data-name": "Group 4676"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2712",
    "data-name": "Path 2712",
    d: "M283.224,641.8a4.052,4.052,0,0,1,3.43-5.32,11.287,11.287,0,0,1,3.71.49c1.68.28,3.5.63,5.111-.07,2.66-1.19,2.94-4.13,3.5-6.651a5.825,5.825,0,0,1,.98-2.66c.49-.49,3.22-.63,4.27-.98a9.066,9.066,0,0,0,3.57-2.45c2.87-3.08,5.951-12.461,11.621-9.8,1.19.56,2.31-1.26,1.05-1.82-4.48-2.03-8.4,1.33-10.781,5.041-1.68,2.59-3.22,6.3-6.441,7.211-2.1.56-3.99.07-5.321,2.1-1.05,1.61-.98,3.71-1.47,5.461-1.33,4.69-5.951,2.17-9.311,2.17a6.16,6.16,0,0,0-5.951,7.981c.35,1.12,2.38.56,2.03-.7Z",
    transform: "translate(-280.946 -611.925)",
    fill: "#2d2d2d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4679",
    "data-name": "Group 4679",
    transform: "translate(24.12 322.832)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4678",
    "data-name": "Group 4678"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2713",
    "data-name": "Path 2713",
    d: "M317.57,642.956a8.57,8.57,0,0,1,6.161-8.331c2.1-.56,4.48.28,6.161-1.33,1.82-1.75,2.45-4.62,4.2-6.511a16,16,0,0,1,9.171-4.76c1.33-.21.77-2.24-.56-2.03a17.663,17.663,0,0,0-8.611,3.92c-3.08,2.59-4.41,7.561-8.4,8.331-2.87.56-5.181.98-7.351,3.22a10.526,10.526,0,0,0-2.94,7.491c.07,1.33,2.17,1.33,2.17,0Z",
    transform: "translate(-315.4 -619.978)",
    fill: "#2d2d2d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4681",
    "data-name": "Group 4681",
    transform: "translate(230.982 169.893)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4680",
    "data-name": "Group 4680"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2714",
    "data-name": "Path 2714",
    d: "M613.276,410.326a4.975,4.975,0,0,1,2.52-6.231,4.513,4.513,0,0,1,5.811,1.54,4.4,4.4,0,0,1-6.021,6.161c-1.12-.7-2.24,1.12-1.05,1.82a6.789,6.789,0,0,0,8.261-.98,6.656,6.656,0,0,0-7.561-10.571,7.043,7.043,0,0,0-3.99,8.821c.42,1.26,2.45.7,2.03-.56Z",
    transform: "translate(-610.886 -401.517)",
    fill: "#424242"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4683",
    "data-name": "Group 4683",
    transform: "translate(217.863 263.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4682",
    "data-name": "Group 4682"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2715",
    "data-name": "Path 2715",
    d: "M594.354,545.806c-1.96-4.13,4.76-3.85,6.581-3.01,1.75.77,3.29,1.89,4.97,2.8a1.085,1.085,0,0,0,1.61-.91,7.708,7.708,0,0,1,12.671-6.231c1.05.84,2.52-.63,1.47-1.47-6.721-5.391-16.242-1.05-16.242,7.7.56-.28,1.05-.63,1.61-.91-3.43-1.75-7.421-5.251-11.551-3.36-2.66,1.19-4.13,3.78-2.87,6.511.56,1.19,2.31.14,1.75-1.12Z",
    transform: "translate(-592.147 -534.618)",
    fill: "#424242"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4685",
    "data-name": "Group 4685",
    transform: "translate(313.075 489.313)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4684",
    "data-name": "Group 4684"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2716",
    "data-name": "Path 2716",
    d: "M729.655,884.888c4.97-3.36,11.481-2.52,12.111-9.941.21-2.8.14-5.391,3.29-6.511,1.54-.56,3.15-1.05,4.62-1.75a27.507,27.507,0,0,0,8.961-7.071c.84-1.05-.63-2.52-1.47-1.47a25.816,25.816,0,0,1-10.711,7.631c-2.38.84-4.9,1.33-6.021,3.85-1.47,3.36.42,7.281-3.08,9.731-2.59,1.82-6.091,1.89-8.681,3.71-1.19.77-.14,2.59.98,1.82Z",
    transform: "translate(-728.149 -857.784)",
    fill: "#424242"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4687",
    "data-name": "Group 4687",
    transform: "translate(319.488 470.152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4686",
    "data-name": "Group 4686"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2717",
    "data-name": "Path 2717",
    d: "M739.753,862.187a7.139,7.139,0,0,1,1.61-6.791c1.54-1.68,3.71-2.03,5.741-2.66,2.45-.77,4.271-1.75,5.181-4.27.7-1.89.84-3.71,1.82-5.531a16.951,16.951,0,0,1,3.5-4.2,47.534,47.534,0,0,1,9.871-6.371c1.19-.63.14-2.45-1.05-1.82-7.351,3.85-13.511,7.981-15.962,16.242-1.47,4.9-7.491,3.64-10.711,7.071a9.227,9.227,0,0,0-2.1,8.821c.42,1.33,2.45.77,2.1-.49Z",
    transform: "translate(-737.309 -830.413)",
    fill: "#424242"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4689",
    "data-name": "Group 4689",
    transform: "translate(419.708 58.771)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4688",
    "data-name": "Group 4688"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2718",
    "data-name": "Path 2718",
    d: "M885.18,256.8c-5.04-4.06-2.31-13.091,4.691-11.9,3.01.49,5.741,2.87,5.741,6.161a7.258,7.258,0,0,1-6.721,6.931c-1.33.07-1.33,2.17,0,2.1a9.4,9.4,0,0,0,8.751-7.981c.56-4.2-2.38-7.841-6.371-8.961-9.1-2.59-14.7,9.521-7.561,15.262,1.05.7,2.52-.77,1.47-1.61Z",
    transform: "translate(-880.466 -242.788)",
    fill: "#424242"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4691",
    "data-name": "Group 4691",
    transform: "translate(447.173 2.327)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4690",
    "data-name": "Group 4690"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2719",
    "data-name": "Path 2719",
    d: "M922.36,184.381c.77-3.01,2.24-3.99,4.48-2.94.98.35,1.96.77,2.87,1.19a15.584,15.584,0,0,0,3.08.91,5.9,5.9,0,0,0,4.341-.91c3.71-2.87.84-9.731,6.791-10.081,4.2-.28,7.7,1.54,11.131-1.96,1.82-1.89,3.01-3.99,5.531-5.251a11.583,11.583,0,0,1,9.521-.14c1.26.49,1.82-1.54.56-2.03a13.48,13.48,0,0,0-14.841,3.08c-1.19,1.26-2.03,3.08-3.641,3.99-1.68.91-3.78.56-5.6.35-2.24-.21-4.691-.49-6.581.91-1.96,1.47-2.17,3.71-2.66,5.951-.63,2.8-2.45,4.62-5.531,3.71-1.54-.42-3.01-1.26-4.55-1.75-2.24-.7-4.761-.7-6.441,1.19a3.741,3.741,0,0,0-.42,4.83c.91,1.12,2.73.07,1.96-1.05Z",
    transform: "translate(-919.698 -162.163)",
    fill: "#424242"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4693",
    "data-name": "Group 4693",
    transform: "translate(479.422)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4692",
    "data-name": "Group 4692"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2720",
    "data-name": "Path 2720",
    d: "M967.749,183.314a7.715,7.715,0,0,1,7.211-6.861c2.73-.07,5.181,1.68,7.981,1.12,3.71-.77,5.04-4.41,6.861-7.211,5.25-8.121,16.872-3.15,23.313-9.731.98-.98-.56-2.45-1.47-1.47-3.64,3.71-9.171,3.36-14,4.2-4.13.7-7.351,2.38-9.661,5.951-1.54,2.45-2.73,6.091-6.161,6.3-2.73.14-5.181-1.54-8.051-1.12a9.655,9.655,0,0,0-7.981,8.261c-.28,1.33,1.75,1.89,1.96.56Z",
    transform: "translate(-965.762 -158.838)",
    fill: "#424242"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4695",
    "data-name": "Group 4695",
    transform: "translate(609.645 209.331)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4694",
    "data-name": "Group 4694"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2721",
    "data-name": "Path 2721",
    d: "M1157.953,473.567c-3.71-.42-4.76-5.111-3.64-8.121a8.847,8.847,0,0,1,9.311-5.391,7.967,7.967,0,0,1,6.651,8.191c-.28,4.27-4.83,7-8.751,6.021a1.053,1.053,0,0,0-.56,2.03,9.363,9.363,0,0,0,11.271-6.861c1.12-5.321-3.08-10.711-8.331-11.481-5.111-.77-10.781,2.8-11.9,7.981-.98,4.34,1.26,9.241,5.951,9.8,1.33.07,1.33-2.03,0-2.17Z",
    transform: "translate(-1151.776 -457.851)",
    fill: "#424242"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4697",
    "data-name": "Group 4697",
    transform: "translate(633.16 232.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4696",
    "data-name": "Group 4696"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2722",
    "data-name": "Path 2722",
    d: "M1187.63,500.479c-1.12-3.99,3.92-8.681,7.631-5.951,2.73,2.03,2.66,6.861-.28,8.681-1.12.7-.07,2.52,1.05,1.82,4.34-2.73,4.411-10.081-.21-12.671-5.391-3.01-11.761,3.08-10.221,8.611a1.044,1.044,0,1,0,2.03-.49Z",
    transform: "translate(-1185.366 -491.561)",
    fill: "#424242"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "robot",
    transform: "translate(78.63 286.317)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "head_1_",
    transform: "translate(212.592 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2723",
    "data-name": "Path 2723",
    d: "M457.248,374.766a23.936,23.936,0,0,0-4.9,2.17,90.829,90.829,0,0,0-22.752,16.172c-28.423,26.253-30.663,28.493-34.864,33.884A156.768,156.768,0,0,0,384.3,442.6c1.61,5.251,3.43,10.641,5.531,16.172a248.381,248.381,0,0,0,33.183,59.856,298.4,298.4,0,0,0,59.926-44.875c21.632-21,23.732-29.683,24.433-33.324C513.184,408.23,474.75,370.636,457.248,374.766Z",
    transform: "translate(-382.9 -364.346)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2724",
    "data-name": "Path 2724",
    d: "M501.444,549.532c.84,3.99,5.181,4.2,9.1,9.451,4.2,5.6,4.48,12.391,3.92,17.432a27.069,27.069,0,0,0,8.821.91c2.8-.14,6.511-.35,10.081-2.73a14.732,14.732,0,0,0,5.181-6.091,48.45,48.45,0,0,0-.63-9.171c-1.12-6.791-1.61-11.831-5.531-16.172a20.435,20.435,0,0,0-2.73-2.52c-3.71-3.151-7.351-6.3-10.711-7C511.245,532.17,499.974,542.6,501.444,549.532Z",
    transform: "translate(-417.995 -412.048)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2725",
    "data-name": "Path 2725",
    d: "M470.343,371.762c3.71,9.171,7.351,18.482,10.921,28,7.911,20.862,15.052,41.3,21.562,61.256-6.441,4.34-13.161,9.241-19.882,14.632A306.061,306.061,0,0,0,442.2,514.788q23.207-5.461,46.345-10.851a15.613,15.613,0,0,1,1.33-7.141,17.518,17.518,0,0,1,6.3-7.141c2.52-1.82,4.41-3.29,7.281-3.43a10.977,10.977,0,0,1,6.931,2.17c13.441-11.481,26.953-23.032,40.394-34.514.42-1.26.91-2.52,1.33-3.71-.49-4.2-1.26-9.871-2.66-16.452a212.3,212.3,0,0,0-11.271-36.334,218.484,218.484,0,0,0-17.922-34.794,128.675,128.675,0,0,0-30.453,3.08A116.584,116.584,0,0,0,470.343,371.762Z",
    transform: "translate(-400.266 -360.783)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4699",
    "data-name": "Group 4699",
    transform: "translate(68.51 9.39)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4698",
    "data-name": "Group 4698"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2726",
    "data-name": "Path 2726",
    d: "M480.259,374.669q18.272,44.42,32.833,90.239c.42,1.26,2.45.77,2.03-.56q-14.491-45.785-32.833-90.24c-.56-1.19-2.59-.7-2.03.56Z",
    transform: "translate(-480.162 -373.429)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4701",
    "data-name": "Group 4701",
    transform: "translate(0.444 10.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4700",
    "data-name": "Group 4700"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2727",
    "data-name": "Path 2727",
    d: "M384.87,442.935c16.382-27.583,42.495-47.395,67.7-66.507,1.05-.84,0-2.66-1.05-1.82-25.483,19.322-51.805,39.344-68.4,67.277-.77,1.12,1.05,2.17,1.75,1.05Z",
    transform: "translate(-382.934 -374.391)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4703",
    "data-name": "Group 4703",
    transform: "translate(0.17 76.287)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4702",
    "data-name": "Group 4702"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2728",
    "data-name": "Path 2728",
    d: "M382.583,470.256a261.341,261.341,0,0,0,39.484,77.288c.77,1.05,2.59,0,1.82-1.05a259.819,259.819,0,0,1-39.274-76.8,1.056,1.056,0,0,0-2.03.56Z",
    transform: "translate(-382.542 -468.985)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4705",
    "data-name": "Group 4705",
    transform: "translate(40.248 99.872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4704",
    "data-name": "Group 4704"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2729",
    "data-name": "Path 2729",
    d: "M441.548,558.278A243.239,243.239,0,0,1,502.1,504.653c1.12-.7.07-2.52-1.05-1.82a245.588,245.588,0,0,0-61.046,53.976c-.77,1.05.7,2.52,1.54,1.47Z",
    transform: "translate(-439.791 -502.675)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4707",
    "data-name": "Group 4707",
    transform: "translate(68.177 0.759)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4706",
    "data-name": "Group 4706"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2730",
    "data-name": "Path 2730",
    d: "M480.956,371.881a153.089,153.089,0,0,1,49.5-8.681,1.051,1.051,0,0,0,0-2.1,158.122,158.122,0,0,0-50.055,8.751c-1.26.49-.7,2.52.56,2.03Z",
    transform: "translate(-479.685 -361.1)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4709",
    "data-name": "Group 4709",
    transform: "translate(118.896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4708",
    "data-name": "Group 4708"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2731",
    "data-name": "Path 2731",
    d: "M552.32,361.545a228.454,228.454,0,0,1,32.063,88.909c.21,1.33,2.24.77,2.03-.56a229.882,229.882,0,0,0-32.273-89.4c-.77-1.12-2.59-.07-1.82,1.05Z",
    transform: "translate(-552.134 -360.016)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4711",
    "data-name": "Group 4711",
    transform: "translate(102.01 89.649)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4710",
    "data-name": "Group 4710"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2732",
    "data-name": "Path 2732",
    d: "M529.334,499.5a191.537,191.537,0,0,1,29.543-5.741c4.691-.56,9.381-.7,14.141-1.12,2.52-.28,4.831-.77,6.231-3.01.7-1.12-1.12-2.24-1.82-1.05-1.96,3.15-9.381,2.24-12.6,2.52-3.85.35-7.631.77-11.481,1.33a212.7,212.7,0,0,0-24.573,5.111c-1.33.28-.77,2.31.56,1.96Z",
    transform: "translate(-528.014 -488.072)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4713",
    "data-name": "Group 4713",
    transform: "translate(42.208 141.607)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4712",
    "data-name": "Group 4712"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2733",
    "data-name": "Path 2733",
    d: "M443.928,575.669a169.507,169.507,0,0,0,22.892-5.251c7.7-2.31,15.262-5.181,23.242-6.021,1.33-.14,1.33-2.24,0-2.1-7.841.84-15.122,3.43-22.612,5.741a167.823,167.823,0,0,1-24.153,5.6c-1.26.21-.7,2.24.63,2.03Z",
    transform: "translate(-442.591 -562.29)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4715",
    "data-name": "Group 4715",
    transform: "translate(87.81 124.718)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4714",
    "data-name": "Group 4714"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2734",
    "data-name": "Path 2734",
    d: "M510.649,555.482c-3.01-5.6,2.73-10.781,7.141-13.371,4.62-2.66,9.8-2.52,13.582,1.4,6.371,6.511,7.841,17.992,7.7,26.673a1.051,1.051,0,0,0,2.1,0c.14-10.291-2.17-27.933-13.861-31.573-8.961-2.8-23.733,8.191-18.482,17.992.63,1.12,2.45.07,1.82-1.12Z",
    transform: "translate(-507.729 -538.166)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4717",
    "data-name": "Group 4717",
    transform: "translate(88.063 141.743)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4716",
    "data-name": "Group 4716"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2735",
    "data-name": "Path 2735",
    d: "M508.377,564.315a26.038,26.038,0,0,1,6.511,19.182c-.07,1.33,2.03,1.33,2.1,0a28.329,28.329,0,0,0-7.141-20.652c-.91-1.05-2.38.42-1.47,1.47Z",
    transform: "translate(-508.091 -562.484)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4719",
    "data-name": "Group 4719",
    transform: "translate(94.171 154.085)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4718",
    "data-name": "Group 4718"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2736",
    "data-name": "Path 2736",
    d: "M517.295,590.255c7.771,5.251,25.063,1.61,26.883-8.821.21-1.33-1.82-1.89-2.03-.56-1.61,9.031-17.082,12.041-23.8,7.561-1.12-.77-2.17,1.05-1.05,1.82Z",
    transform: "translate(-516.816 -580.114)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4721",
    "data-name": "Group 4721",
    transform: "translate(108.999 91.238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4720",
    "data-name": "Group 4720"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2737",
    "data-name": "Path 2737",
    d: "M579.163,490.593c-13.861,11.341-27.3,23.1-40.814,34.864-1.05.91.49,2.38,1.47,1.47,13.441-11.761,26.953-23.522,40.814-34.864,1.05-.84-.49-2.31-1.47-1.47Z",
    transform: "translate(-537.997 -490.342)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4723",
    "data-name": "Group 4723",
    transform: "translate(89.254 129.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4722",
    "data-name": "Group 4722"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2738",
    "data-name": "Path 2738",
    d: "M511.9,559.482c3.29-8.051,11.761-12.671,20.3-12.391,1.33.07,1.33-2.03,0-2.1a22.934,22.934,0,0,0-22.332,13.931c-.49,1.26,1.54,1.82,2.03.56Z",
    transform: "translate(-509.792 -544.967)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4725",
    "data-name": "Group 4725",
    transform: "translate(93.103 139.081)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4724",
    "data-name": "Group 4724"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2739",
    "data-name": "Path 2739",
    d: "M517.257,570.246c4.9-6.931,13.371-10.221,21.772-9.311,1.33.14,1.33-1.96,0-2.1A25.263,25.263,0,0,0,515.507,569.2c-.84,1.05.98,2.1,1.75,1.05Z",
    transform: "translate(-515.29 -558.682)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4727",
    "data-name": "Group 4727",
    transform: "translate(96.289 147.771)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4726",
    "data-name": "Group 4726"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2740",
    "data-name": "Path 2740",
    d: "M521.563,581.11c2.31-2.94,5.741-4.27,9.171-5.6,3.99-1.54,7.911-2.8,12.181-2.17,1.33.21,1.33-1.89,0-2.1-4.9-.63-9.451.91-13.931,2.73-3.36,1.33-6.581,2.8-8.891,5.671-.84.98.63,2.52,1.47,1.47Z",
    transform: "translate(-519.842 -571.095)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4729",
    "data-name": "Group 4729",
    transform: "translate(19.329 77.781)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4728",
    "data-name": "Group 4728"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2741",
    "data-name": "Path 2741",
    d: "M416.974,482.447A6.37,6.37,0,0,1,412,475.027c-.14-.77.21-1.12.98-1.19.63-.56,1.19-.42,1.68.35a6.99,6.99,0,0,1,1.26,2.1c.56,1.26,1.33,3.29,1.05,4.76-.49,2.38-1.96.63-2.66-.7-.7-1.26-1.54-3.29-1.33-4.76.07-.77-.21-.7.42-.49.56.21.98,1.19,1.26,1.75a8.525,8.525,0,0,1,.84,4.76c.63-.28,1.19-.49,1.82-.77a6.645,6.645,0,0,1-2.45-5.321c-.56.28-1.05.63-1.61.91a2.887,2.887,0,0,1,1.68,3.92c.49-.21,1.05-.42,1.54-.63a4.177,4.177,0,0,1-1.47-5.111h-1.82a10.558,10.558,0,0,1,1.82,7.771c.63-.28,1.19-.49,1.82-.77a8.411,8.411,0,0,1-1.96-2.45c-.35-.63-1.4-3.01-.98-3.64.28-.42.56-.21.98.28a5.941,5.941,0,0,1,.77,1.82,8.719,8.719,0,0,1,.35,3.78,16.151,16.151,0,0,1,1.33-.98,3.434,3.434,0,0,1-1.82-.7c-1.12-.77-2.17,1.05-1.05,1.82a5.522,5.522,0,0,0,2.31.91,1.063,1.063,0,0,0,1.33-.98,12.548,12.548,0,0,0-1.61-7.071c-.7-1.19-2.17-2.8-3.71-1.82-1.47.91-1.12,3.5-.84,4.9a10.748,10.748,0,0,0,3.36,5.671c.7.7,1.68.14,1.82-.77a12.429,12.429,0,0,0-2.17-8.821c-.42-.56-1.47-.77-1.82,0a6.3,6.3,0,0,0,2.24,7.981,1.066,1.066,0,0,0,1.54-.63,4.819,4.819,0,0,0-2.66-6.3,1.128,1.128,0,0,0-1.61.91,8.432,8.432,0,0,0,3.08,6.791,1.077,1.077,0,0,0,1.82-.77c.21-2.87-.7-6.231-2.94-8.191-1.75-1.54-3.64-.84-3.78,1.54a12.35,12.35,0,0,0,3.08,8.4c1.33,1.47,3.99,2.87,4.971.21s-.07-6.441-1.33-8.891c-1.05-2.03-3.57-4.55-5.951-3.01-2.31,1.4-1.75,5.461-1.12,7.631a7.493,7.493,0,0,0,6.021,5.251c1.26.21,1.82-1.82.49-2.03Z",
    transform: "translate(-409.91 -471.121)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4731",
    "data-name": "Group 4731",
    transform: "translate(53.983 53.349)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4730",
    "data-name": "Group 4730"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2742",
    "data-name": "Path 2742",
    d: "M466.474,447.547a6.37,6.37,0,0,1-4.971-7.421c-.14-.77.21-1.12.98-1.19.63-.56,1.19-.42,1.68.35a6.989,6.989,0,0,1,1.26,2.1c.56,1.26,1.33,3.29,1.05,4.76-.49,2.38-1.96.63-2.66-.7-.7-1.26-1.54-3.29-1.33-4.76.07-.77-.21-.7.42-.49.56.21.98,1.19,1.26,1.75a8.525,8.525,0,0,1,.84,4.76c.63-.28,1.19-.49,1.82-.77a6.645,6.645,0,0,1-2.45-5.321c-.56.28-1.05.63-1.61.91a2.887,2.887,0,0,1,1.68,3.92c.49-.21,1.05-.42,1.54-.63a4.177,4.177,0,0,1-1.47-5.111h-1.82a10.558,10.558,0,0,1,1.82,7.771c.63-.28,1.19-.49,1.82-.77a8.411,8.411,0,0,1-1.96-2.45c-.35-.63-1.4-3.01-.98-3.64.28-.42.56-.21.98.28a5.941,5.941,0,0,1,.77,1.82,8.719,8.719,0,0,1,.35,3.78,16.131,16.131,0,0,1,1.33-.98,3.434,3.434,0,0,1-1.82-.7c-1.12-.77-2.17,1.05-1.05,1.82a5.522,5.522,0,0,0,2.31.91,1.063,1.063,0,0,0,1.33-.98,12.548,12.548,0,0,0-1.61-7.071c-.7-1.19-2.17-2.8-3.71-1.82-1.47.91-1.12,3.5-.84,4.9a10.748,10.748,0,0,0,3.36,5.671c.7.7,1.68.14,1.82-.77a12.428,12.428,0,0,0-2.17-8.821c-.42-.56-1.47-.77-1.82,0a6.3,6.3,0,0,0,2.24,7.981,1.066,1.066,0,0,0,1.54-.63,4.819,4.819,0,0,0-2.66-6.3,1.128,1.128,0,0,0-1.61.91,8.432,8.432,0,0,0,3.08,6.791,1.077,1.077,0,0,0,1.82-.77c.21-2.87-.7-6.231-2.94-8.191-1.75-1.54-3.64-.84-3.78,1.54a12.35,12.35,0,0,0,3.08,8.4c1.33,1.47,3.99,2.87,4.971.21s-.07-6.441-1.33-8.891c-1.05-2.03-3.57-4.55-5.951-3.01-2.31,1.4-1.75,5.461-1.12,7.631a7.493,7.493,0,0,0,6.021,5.251c1.19.21,1.82-1.82.49-2.03Z",
    transform: "translate(-459.41 -436.221)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4733",
    "data-name": "Group 4733",
    transform: "translate(40.038 78.074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4732",
    "data-name": "Group 4732"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2743",
    "data-name": "Path 2743",
    d: "M441.247,488.873q7.141-7.981,14.7-15.542c.98-.98-.56-2.45-1.47-1.47q-7.561,7.666-14.7,15.542c-.91.98.56,2.52,1.47,1.47Z",
    transform: "translate(-439.491 -471.538)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4735",
    "data-name": "Group 4735",
    transform: "translate(40.764 78.66)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4734",
    "data-name": "Group 4734"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2744",
    "data-name": "Path 2744",
    d: "M441.209,489.334a143.683,143.683,0,0,0,14.072,4.62,1.063,1.063,0,0,0,1.33-.98,183.6,183.6,0,0,1,.42-19.6c.07-1.33-2.03-1.33-2.1,0a182.817,182.817,0,0,0-.42,19.6,16.136,16.136,0,0,1,1.33-.98q-7.141-2-14.072-4.62c-1.26-.56-1.75,1.47-.56,1.96Z",
    transform: "translate(-440.529 -472.375)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4737",
    "data-name": "Group 4737",
    transform: "translate(42.107 79.836)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4736",
    "data-name": "Group 4736"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2745",
    "data-name": "Path 2745",
    d: "M444.234,488.3c4.27-2.38,7.141-7,10.151-10.781.84-1.05-.56-2.52-1.47-1.47-1.96,2.24-3.85,4.55-5.811,6.791-1.4,1.61-3.22,2.87-4.48,4.621-.7.98.84,2.1,1.68,1.26,3.99-4.06,7.911-8.191,11.621-12.461l-1.47-1.47a142.067,142.067,0,0,0-8.681,11.551c-.63.98.91,2.17,1.68,1.26,2.45-3.01,4.971-5.951,7.421-8.961l-1.68-1.26c-2.45,3.29-4.76,6.651-7.071,10.011-.63.98.91,2.24,1.68,1.26,2.31-3.01,4.69-5.951,7-8.961l-1.68-1.26c-1.89,2.94-3.78,5.881-5.741,8.821a1.063,1.063,0,0,0,1.68,1.26,3.465,3.465,0,0,0,.98-1.61c.35-.77-.63-1.47-1.26-1.26-1.54.35-3.08.7-4.621.98a1.056,1.056,0,0,0-.28,1.89,14.152,14.152,0,0,0,5.111,1.33,1.037,1.037,0,0,0,.28-2.03,26.336,26.336,0,0,0-4.691-.84,1.037,1.037,0,0,0-.28,2.03c1.82.49,3.64.98,5.531,1.4,1.12.28,1.89-1.33.84-1.89-.35-.14-.63-.35-.98-.49-.35.63-.7,1.19-1.05,1.82.77.35,1.54.77,2.31,1.12a1.1,1.1,0,0,0,1.47-1.47,12.59,12.59,0,0,1-1.61-4.971c-.56.35-1.19.7-1.75,1.05,1.47,1.4,1.47,3.78,2.59,5.461a1.045,1.045,0,0,0,1.89-.84c-.63-2.1-1.19-4.2-1.82-6.3-.49.42-1.05.77-1.54,1.19,1.33.77,2.1,4.271,2.73,5.6a1.055,1.055,0,0,0,2.03-.56c-.84-3.57-1.54-7-.28-10.641h-2.03a49.1,49.1,0,0,1,.63,9.591,1.051,1.051,0,0,0,2.1,0c.21-4.27-.35-9.8,1.12-13.791-.7-.07-1.4-.21-2.03-.28,0,5.741-1.54,11.131-.49,16.8a16.15,16.15,0,0,0,.98-1.33c-2.94,0-5.321-2.17-8.191-2.8-1.12-.21-1.96,1.4-.84,1.89a49.614,49.614,0,0,0,8.121,3.08c.21-.7.35-1.33.56-2.03a49.092,49.092,0,0,1-9.871-3.64v1.82a14.487,14.487,0,0,0,3.85-4.41,53.118,53.118,0,0,1,6.231-7.981c.91-.98-.56-2.45-1.47-1.47-1.61,1.75-3.15,3.64-4.621,5.531-1.61,2.17-2.8,4.971-5.041,6.581a1.051,1.051,0,0,0,0,1.82,55.972,55.972,0,0,0,10.361,3.85,1.053,1.053,0,0,0,.56-2.03,41.466,41.466,0,0,1-7.631-2.8l-.84,1.89c3.08.7,5.461,2.87,8.751,2.87a1.063,1.063,0,0,0,.98-1.33c-.98-5.391.49-10.781.56-16.242a1.037,1.037,0,0,0-2.03-.28c-1.54,4.27-.91,9.871-1.19,14.351h2.1a54.606,54.606,0,0,0-.7-10.151c-.21-1.12-1.75-.91-2.03,0-1.33,3.92-.63,7.771.28,11.691.7-.21,1.33-.35,2.03-.56-.91-2.1-1.54-5.671-3.64-6.861a1.063,1.063,0,0,0-1.54,1.19c.63,2.1,1.19,4.2,1.82,6.3l1.89-.84c-1.26-1.89-1.19-4.27-2.94-5.881-.84-.77-1.89,0-1.75,1.05a13.738,13.738,0,0,0,1.89,5.461l1.47-1.47c-.77-.35-1.54-.77-2.31-1.12-1.19-.56-2.24,1.19-1.05,1.82.35.14.63.35.98.49l.84-1.89c-1.82-.49-3.64-.98-5.531-1.4-.07.7-.21,1.4-.28,2.03a20.478,20.478,0,0,1,4.13.77c.07-.7.21-1.4.28-2.03a9.94,9.94,0,0,1-3.99-1.05,17.588,17.588,0,0,1-.28,1.89c1.54-.35,3.08-.7,4.62-.98l-1.26-1.26a6.15,6.15,0,0,0-.42.7l1.68,1.26c1.89-2.94,3.78-5.881,5.741-8.821.63-.98-.91-2.24-1.68-1.26-2.31,3.01-4.69,5.951-7,8.961l1.68,1.26c2.31-3.36,4.691-6.721,7.071-10.011.7-.98-.91-2.17-1.68-1.26-2.45,3.01-4.971,5.951-7.421,8.961l1.68,1.26a127.917,127.917,0,0,1,8.331-11.131c.84-1.05-.56-2.52-1.47-1.47-3.78,4.27-7.631,8.4-11.621,12.461l1.68,1.26c1.33-1.82,3.36-3.29,4.9-5.041,1.68-1.96,3.43-3.99,5.111-5.951l-1.47-1.47c-2.87,3.57-5.671,8.121-9.731,10.431-1.61.7-.56,2.52.63,1.82Z",
    transform: "translate(-442.446 -474.055)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4739",
    "data-name": "Group 4739",
    transform: "translate(58.966 16.83)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4738",
    "data-name": "Group 4738"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2746",
    "data-name": "Path 2746",
    d: "M467.839,390.6c1.19-1.19,5.181-5.741,7.211-4.41.7.49,1.33,2.38,1.68,3.15.77,1.54,1.4,3.08,2.03,4.691.35.91,1.89.56,1.54-.42a55.419,55.419,0,0,0-2.59-5.881c-.56-1.12-1.19-2.94-2.45-3.5-2.66-1.12-6.861,3.57-8.471,5.181-.77.77.35,1.89,1.05,1.19Z",
    transform: "translate(-466.529 -384.056)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4741",
    "data-name": "Group 4741",
    transform: "translate(90.017 94.19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4740",
    "data-name": "Group 4740"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2747",
    "data-name": "Path 2747",
    d: "M512.715,497.668a.866.866,0,0,1,.28-1.4,1.514,1.514,0,0,1,1.89.56,1.928,1.928,0,0,1,0,2.03c-.63.77-1.75-.21-2.31-.63-.77-.63-1.61.77-.77,1.33,1.26.98,3.29,1.75,4.411.14a3.4,3.4,0,0,0-.49-4.34,3.183,3.183,0,0,0-4.13-.07,2.477,2.477,0,0,0,.28,3.71c.84.7,1.61-.7.84-1.33Z",
    transform: "translate(-510.881 -494.56)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4743",
    "data-name": "Group 4743",
    transform: "translate(36.363 139.297)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4742",
    "data-name": "Group 4742"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2748",
    "data-name": "Path 2748",
    d: "M434.493,561.728a44.77,44.77,0,0,0,2.87,3.5c.49.49.98.98,1.68.84.91-.21,1.68-1.33,2.31-1.89,1.19-1.12,2.45-2.31,3.64-3.43.98-.91-.49-2.38-1.47-1.47-.7.63-1.4,1.33-2.1,1.96-.63.56-2.03,1.47-2.38,2.17-.21.49,0,.63-.28.35a5.524,5.524,0,0,1-.84-1.05c-.63-.84-1.33-1.61-1.96-2.45-.84-1.05-2.31.42-1.47,1.47Z",
    transform: "translate(-434.242 -558.991)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4745",
    "data-name": "Group 4745",
    transform: "translate(48.856 133.624)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4744",
    "data-name": "Group 4744"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2749",
    "data-name": "Path 2749",
    d: "M453.846,555.236c1.12-.84,2.24-1.75,3.29-2.59a1.04,1.04,0,1,0-1.47-1.47c-1.12.84-2.24,1.75-3.29,2.59a1.04,1.04,0,1,0,1.47,1.47Z",
    transform: "translate(-452.087 -550.887)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4747",
    "data-name": "Group 4747",
    transform: "translate(40.824 151.038)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4746",
    "data-name": "Group 4746"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2750",
    "data-name": "Path 2750",
    d: "M441.934,580.619c4.34-.91,8.681-1.89,12.951-2.8,1.33-.28.77-2.31-.56-2.03-4.34.91-8.681,1.89-12.951,2.8a1.053,1.053,0,0,0,.56,2.03Z",
    transform: "translate(-440.614 -575.762)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4749",
    "data-name": "Group 4749",
    transform: "translate(20.483 96.404)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4748",
    "data-name": "Group 4748"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2751",
    "data-name": "Path 2751",
    d: "M412.638,498.126l-1.05,3.15c-.21.63.77.91.98.28l1.05-3.15a.511.511,0,1,0-.98-.28Z",
    transform: "translate(-411.558 -497.721)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4751",
    "data-name": "Group 4751",
    transform: "translate(23.65 96.404)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4750",
    "data-name": "Group 4750"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2752",
    "data-name": "Path 2752",
    d: "M416.585,498.126c-.14.77-.35,1.61-.49,2.38-.14.63.91.91.98.28.14-.77.35-1.61.49-2.38.14-.7-.84-.98-.98-.28Z",
    transform: "translate(-416.082 -497.721)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4753",
    "data-name": "Group 4753",
    transform: "translate(26.669 95.194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4752",
    "data-name": "Group 4752"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2753",
    "data-name": "Path 2753",
    d: "M420.4,496.628a15.643,15.643,0,0,1,.14,2.59c-.07.7.98.7,1.05,0a13.162,13.162,0,0,0-.14-2.87c-.14-.63-1.12-.35-1.05.28Z",
    transform: "translate(-420.395 -495.993)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4755",
    "data-name": "Group 4755",
    transform: "translate(66.992 61.426)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4754",
    "data-name": "Group 4754"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2754",
    "data-name": "Path 2754",
    d: "M478.628,449.678a23.9,23.9,0,0,0,3.71-.91c.63-.21.35-1.19-.28-.98a31.909,31.909,0,0,1-3.71.91c-.63.07-.35,1.05.28.98Z",
    transform: "translate(-477.993 -447.758)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4757",
    "data-name": "Group 4757",
    transform: "translate(68.082 63.972)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4756",
    "data-name": "Group 4756"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2755",
    "data-name": "Path 2755",
    d: "M480.075,452.519a21.364,21.364,0,0,0,3.01-.07c.63-.07.7-1.12,0-1.05a14.432,14.432,0,0,1-3.01.07c-.7-.07-.7.98,0,1.05Z",
    transform: "translate(-479.55 -451.395)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4759",
    "data-name": "Group 4759",
    transform: "translate(67.782 67.308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4758",
    "data-name": "Group 4758"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2756",
    "data-name": "Path 2756",
    d: "M479.526,457.168c1.05.21,2.1.42,3.22.63.63.14.91-.91.28-.98-1.05-.21-2.1-.42-3.22-.63a.511.511,0,1,0-.28.98Z",
    transform: "translate(-479.121 -456.16)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2757",
    "data-name": "Path 2757",
    d: "M423.824,408.2a100.2,100.2,0,0,0-14.352,34.514c-3.01,14.492-8.051,38.574,5.811,50.545,14.072,12.251,38.154,3.64,40.674,2.73-10.221,11.271-20.512,22.542-30.733,33.814A207.552,207.552,0,0,1,384.2,451.955,192.5,192.5,0,0,1,423.824,408.2Z",
    transform: "translate(-382.87 -374.468)",
    fill: "#6d6d6d",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2758",
    "data-name": "Path 2758",
    d: "M382.3,454.244c11.061-12.391,22.122-24.853,33.113-37.244-.35,3.01-3.71,38.574,22.192,59.086a59.164,59.164,0,0,0,29.4,11.971q-22.157,21.212-44.385,42.354A255.942,255.942,0,0,1,397.7,491.138,243.314,243.314,0,0,1,382.3,454.244Z",
    transform: "translate(-382.3 -377.107)",
    fill: "#6d6d6d",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2759",
    "data-name": "Path 2759",
    d: "M515.149,546.1a37.1,37.1,0,0,1,7.071,9.241,38.508,38.508,0,0,1,4.41,16.8c-3.15.7-6.3,1.47-9.521,2.17a72.312,72.312,0,0,0-4.411-11.9c-.91-2.03-1.96-3.85-2.94-5.6a10.991,10.991,0,0,1,1.19-6.581A10.664,10.664,0,0,1,515.149,546.1Z",
    transform: "translate(-420.499 -415.827)",
    fill: "#6d6d6d",
    opacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "leg_right_1_",
    transform: "translate(76.518 199.56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2760",
    "data-name": "Path 2760",
    d: "M205.6,648.1a81.8,81.8,0,0,0-6.091,10.081c-5.531,10.781-7.141,20.092-8.261,26.6a104.975,104.975,0,0,0-.63,31.5c.42,2.8.84,5.11,1.19,6.721,2.59,1.26,6.791,3.29,11.9,5.811,23.032,11.131,30.453,14.141,45.855,21.7,13.231,6.511,10.081,5.461,25.973,13.441,17.222,8.611,26.673,13.371,39.134,18.342a303.58,303.58,0,0,0,38.854,12.531c18.2,4.76,24.713,4.971,52.576,10.711,14.912,3.08,27.023,5.811,34.584,7.631,1.75-6.511,3.5-13.021,5.181-19.6-2.87-.49-7.071-1.26-12.251-2.17-24.573-4.13-27.863-3.85-39.134-6.091-9.871-1.96-18.622-4.69-36.054-10.081-8.751-2.73-17.012-5.251-27.513-9.171-4.971-1.82-13.161-4.971-41.3-17.712-16.592-7.561-24.923-11.341-37.034-17.152-12.461-6.021-27.793-13.651-45.295-22.962.07-2.87.14-7.351.28-12.811.49-16.242.98-20.442.63-27.513A98.614,98.614,0,0,0,205.6,648.1Z",
    transform: "translate(-188.47 -645.98)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4761",
    "data-name": "Group 4761"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4760",
    "data-name": "Group 4760"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2761",
    "data-name": "Path 2761",
    d: "M203.731,645.582a111.019,111.019,0,0,0-14,77.008c.21,1.33,2.24.77,2.03-.56a108.517,108.517,0,0,1,13.791-75.4c.7-1.12-1.12-2.24-1.82-1.05Z",
    transform: "translate(-187.93 -645.072)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4763",
    "data-name": "Group 4763",
    transform: "translate(15.6 1.106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4762",
    "data-name": "Group 4762"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2762",
    "data-name": "Path 2762",
    d: "M210.344,648.226c4.34,8.121,2.66,19.182,2.66,28.073,0,9.8,0,19.532.07,29.333a1.051,1.051,0,0,0,2.1,0c0-10.711,0-21.352-.07-32.063,0-8.611,1.26-18.482-2.94-26.393-.63-1.19-2.45-.14-1.82,1.05Z",
    transform: "translate(-210.213 -646.652)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4765",
    "data-name": "Group 4765",
    transform: "translate(2.635 60.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4764",
    "data-name": "Group 4764"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2763",
    "data-name": "Path 2763",
    d: "M193.8,749.251A15.019,15.019,0,0,1,208.01,733.5c1.33-.07,1.33-2.17,0-2.1A17.259,17.259,0,0,0,191.7,749.251a1.052,1.052,0,0,0,2.1,0Z",
    transform: "translate(-191.693 -731.398)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4767",
    "data-name": "Group 4767",
    transform: "translate(3.224 77.582)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4766",
    "data-name": "Group 4766"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2764",
    "data-name": "Path 2764",
    d: "M193.211,758c31.923,12.321,61.677,29.263,92.34,44.175a443.3,443.3,0,0,0,45.225,19.322c16.942,5.951,34.3,9.521,51.875,13.021,21.072,4.2,42.144,8.331,63.217,12.531,1.33.28,1.89-1.75.56-2.03-18.552-3.71-37.174-7.351-55.726-11.061-17.992-3.57-36.054-6.861-53.556-12.531-32.2-10.5-62.1-26.883-92.2-42.144-16.732-8.471-33.6-16.592-51.105-23.312-1.33-.49-1.82,1.54-.63,2.03Z",
    transform: "translate(-192.535 -755.892)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4769",
    "data-name": "Group 4769",
    transform: "translate(17.59 61.241)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4768",
    "data-name": "Group 4768"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2765",
    "data-name": "Path 2765",
    d: "M213.577,734.545c60.066,31.083,121.393,61.536,187.76,76.588A376.376,376.376,0,0,0,457.2,819.6c1.33.07,1.33-2.03,0-2.1-67.277-5.041-130.984-29.823-191.19-58.946-17.222-8.331-34.3-17.082-51.315-25.9-1.26-.56-2.31,1.26-1.12,1.89Z",
    transform: "translate(-213.055 -732.549)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4771",
    "data-name": "Group 4771",
    transform: "translate(27.407 72.907)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4770",
    "data-name": "Group 4770"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2766",
    "data-name": "Path 2766",
    d: "M229.124,765.236A18.553,18.553,0,0,1,239.2,751.164c1.19-.63.14-2.45-1.05-1.82a20.164,20.164,0,0,0-11.061,15.332c-.21,1.33,1.82,1.89,2.03.56Z",
    transform: "translate(-227.078 -749.213)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4773",
    "data-name": "Group 4773",
    transform: "translate(53.669 86.228)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4772",
    "data-name": "Group 4772"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2767",
    "data-name": "Path 2767",
    d: "M266.7,783.194c1.82-5.251,4.06-11.131,9.871-12.881a1.054,1.054,0,0,0-.56-2.03c-6.651,1.96-9.241,8.331-11.341,14.352-.49,1.26,1.54,1.82,2.03.56Z",
    transform: "translate(-264.592 -768.242)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4775",
    "data-name": "Group 4775",
    transform: "translate(95.253 105.363)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4774",
    "data-name": "Group 4774"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2768",
    "data-name": "Path 2768",
    d: "M326.1,811.834a19.061,19.061,0,0,1,9.451-14.282,1.051,1.051,0,0,0-1.05-1.82A21.164,21.164,0,0,0,324,811.764c-.14,1.4,1.96,1.4,2.1.07Z",
    transform: "translate(-323.99 -795.575)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4777",
    "data-name": "Group 4777",
    transform: "translate(128.876 119.627)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4776",
    "data-name": "Group 4776"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2769",
    "data-name": "Path 2769",
    d: "M374.036,833.977c2.03-6.721,5.461-13.021,12.111-16.1,1.19-.56.14-2.38-1.05-1.82-7.071,3.36-10.851,10.151-13.021,17.362a1.019,1.019,0,0,0,1.96.56Z",
    transform: "translate(-372.019 -815.949)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4779",
    "data-name": "Group 4779",
    transform: "translate(164.33 131.232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4778",
    "data-name": "Group 4778"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2770",
    "data-name": "Path 2770",
    d: "M424.719,850.5a27.416,27.416,0,0,1,3.64-8.891c.91-1.4,4.971-7.421,7.071-7,1.33.28,1.89-1.75.56-2.03-3.08-.56-6.161,3.57-7.841,5.741a29.109,29.109,0,0,0-5.461,11.621c-.28,1.33,1.75,1.89,2.03.56Z",
    transform: "translate(-422.662 -832.526)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4781",
    "data-name": "Group 4781",
    transform: "translate(197.64 140.028)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4780",
    "data-name": "Group 4780"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2771",
    "data-name": "Path 2771",
    d: "M472.313,861.269a28.316,28.316,0,0,1,8.891-14.421c1.05-.91-.49-2.38-1.47-1.47a30.782,30.782,0,0,0-9.451,15.332,1.056,1.056,0,0,0,2.03.56Z",
    transform: "translate(-470.242 -845.091)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4783",
    "data-name": "Group 4783",
    transform: "translate(227.197 143.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4782",
    "data-name": "Group 4782"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2772",
    "data-name": "Path 2772",
    d: "M514.519,868.2a28.427,28.427,0,0,1,9.521-15.752c1.05-.84-.49-2.38-1.47-1.47a29.979,29.979,0,0,0-10.081,16.662c-.28,1.26,1.75,1.82,2.03.56Z",
    transform: "translate(-512.462 -850.702)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2773",
    "data-name": "Path 2773",
    d: "M203.881,650.9c-1.19,8.681-2.1,18.132-2.66,28.213-.56,11.061-.63,21.352-.28,30.873a462.153,462.153,0,0,0,66.437,41.374c68.187,34.794,132.524,46.2,177.959,49.775v12.531c-2.59-.21-6.441-.56-11.061-1.19-18.132-2.31-30.383-5.741-40.744-8.471-29.473-7.561-26.673-4.2-48.935-10.5a334.293,334.293,0,0,1-40.744-14.562c-12.181-5.25-11.061-5.671-42.844-21.562-13.091-6.581-14-6.861-36.684-18.062-14.071-7-25.483-12.671-32.763-16.312a104.4,104.4,0,0,1-1.89-12.741,98.2,98.2,0,0,1,7.491-46.345A80.558,80.558,0,0,1,203.881,650.9Z",
    transform: "translate(-188.36 -646.82)",
    fill: "#6d6d6d",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2774",
    "data-name": "Path 2774",
    d: "M197.849,682.9l2.94,45.995q28.983,17.222,57.966,34.374-17.852-7.351-36.684-16.032c-9.521-4.41-18.762-8.891-27.653-13.371a77.7,77.7,0,0,1-2.31-28.843A72.754,72.754,0,0,1,197.849,682.9Z",
    transform: "translate(-189.049 -656.417)",
    fill: "#6d6d6d",
    opacity: 0.14
  })), /*#__PURE__*/React.createElement("g", {
    id: "leg_left",
    transform: "translate(0 228.224)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2775",
    "data-name": "Path 2775",
    d: "M96.3,689a81.8,81.8,0,0,0-6.091,10.081c-5.531,10.781-7.141,20.092-8.261,26.6a104.975,104.975,0,0,0-.63,31.5c.42,2.8.84,5.111,1.19,6.721,2.59,1.26,6.791,3.29,11.9,5.811,23.032,11.131,30.453,14.141,45.855,21.7,13.231,6.511,10.081,5.461,25.973,13.441,17.222,8.611,26.673,13.371,39.134,18.342a303.587,303.587,0,0,0,38.854,12.531c18.2,4.76,24.713,4.971,52.576,10.711,14.912,3.08,27.023,5.811,34.584,7.631,1.75-6.511,3.5-13.021,5.181-19.6-2.87-.49-7.071-1.26-12.251-2.17-24.573-4.13-27.863-3.85-39.134-6.091-9.871-1.96-18.622-4.691-36.054-10.081-8.751-2.73-17.012-5.251-27.513-9.171-4.971-1.82-13.161-4.971-41.3-17.712-16.592-7.561-24.923-11.341-37.034-17.152-12.461-6.021-27.793-13.651-45.295-22.962.07-2.87.14-7.351.28-12.811.49-16.242.98-20.442.63-27.513A98.613,98.613,0,0,0,96.3,689Z",
    transform: "translate(-79.17 -686.911)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4785",
    "data-name": "Group 4785"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4784",
    "data-name": "Group 4784"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2776",
    "data-name": "Path 2776",
    d: "M94.431,686.495a111.019,111.019,0,0,0-14,77.008c.21,1.33,2.24.77,2.03-.56a108.518,108.518,0,0,1,13.791-75.4c.7-1.12-1.12-2.17-1.82-1.05Z",
    transform: "translate(-78.63 -686.016)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4787",
    "data-name": "Group 4787",
    transform: "translate(15.6 1.075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4786",
    "data-name": "Group 4786"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2777",
    "data-name": "Path 2777",
    d: "M101.044,689.126c4.34,8.121,2.66,19.182,2.66,28.073,0,9.8,0,19.532.07,29.333a1.051,1.051,0,0,0,2.1,0c0-10.711,0-21.352-.07-32.063,0-8.611,1.26-18.482-2.94-26.393-.63-1.19-2.45-.14-1.82,1.05Z",
    transform: "translate(-100.913 -687.552)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4789",
    "data-name": "Group 4789",
    transform: "translate(2.635 60.403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4788",
    "data-name": "Group 4788"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2778",
    "data-name": "Path 2778",
    d: "M84.5,790.151A15.019,15.019,0,0,1,98.71,774.4c1.33-.07,1.33-2.17,0-2.1A17.259,17.259,0,0,0,82.4,790.151a1.051,1.051,0,0,0,2.1,0Z",
    transform: "translate(-82.393 -772.298)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4791",
    "data-name": "Group 4791",
    transform: "translate(3.224 77.551)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4790",
    "data-name": "Group 4790"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2779",
    "data-name": "Path 2779",
    d: "M83.911,798.9c31.923,12.321,61.676,29.263,92.34,44.175a443.256,443.256,0,0,0,45.225,19.322c16.942,5.951,34.3,9.521,51.875,13.021,21.072,4.2,42.144,8.331,63.217,12.531,1.33.28,1.89-1.75.56-2.03-18.552-3.71-37.174-7.351-55.726-11.061-17.992-3.57-36.054-6.861-53.556-12.531-32.2-10.5-62.1-26.883-92.2-42.144-16.732-8.471-33.6-16.592-51.105-23.312-1.33-.49-1.82,1.54-.63,2.03Z",
    transform: "translate(-83.235 -796.792)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4793",
    "data-name": "Group 4793",
    transform: "translate(17.59 61.21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4792",
    "data-name": "Group 4792"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2780",
    "data-name": "Path 2780",
    d: "M104.277,775.445c60.066,31.083,121.393,61.537,187.76,76.588A376.393,376.393,0,0,0,347.9,860.5c1.33.07,1.33-2.03,0-2.1-67.277-5.041-130.984-29.823-191.19-58.946-17.222-8.331-34.3-17.082-51.315-25.9-1.26-.56-2.31,1.26-1.12,1.89Z",
    transform: "translate(-103.755 -773.449)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4795",
    "data-name": "Group 4795",
    transform: "translate(27.407 72.876)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4794",
    "data-name": "Group 4794"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2781",
    "data-name": "Path 2781",
    d: "M119.824,806.136A18.554,18.554,0,0,1,129.9,792.064c1.19-.63.14-2.45-1.05-1.82a20.164,20.164,0,0,0-11.061,15.332c-.21,1.33,1.82,1.89,2.03.56Z",
    transform: "translate(-117.778 -790.113)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4797",
    "data-name": "Group 4797",
    transform: "translate(53.669 86.198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4796",
    "data-name": "Group 4796"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2782",
    "data-name": "Path 2782",
    d: "M157.4,824.094c1.82-5.25,4.06-11.131,9.871-12.881a1.054,1.054,0,0,0-.56-2.03c-6.651,1.96-9.241,8.331-11.341,14.351-.49,1.26,1.54,1.82,2.03.56Z",
    transform: "translate(-155.292 -809.142)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4799",
    "data-name": "Group 4799",
    transform: "translate(95.253 105.332)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4798",
    "data-name": "Group 4798"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2783",
    "data-name": "Path 2783",
    d: "M216.8,852.734a19.061,19.061,0,0,1,9.451-14.281,1.051,1.051,0,0,0-1.05-1.82,21.164,21.164,0,0,0-10.5,16.032c-.14,1.4,1.96,1.4,2.1.07Z",
    transform: "translate(-214.69 -836.475)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4801",
    "data-name": "Group 4801",
    transform: "translate(128.876 119.596)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4800",
    "data-name": "Group 4800"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2784",
    "data-name": "Path 2784",
    d: "M264.736,874.876c2.03-6.721,5.461-13.021,12.111-16.1,1.19-.56.14-2.38-1.05-1.82-7.071,3.36-10.851,10.151-13.021,17.362a1.019,1.019,0,1,0,1.96.56Z",
    transform: "translate(-262.719 -856.849)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4803",
    "data-name": "Group 4803",
    transform: "translate(164.33 131.271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4802",
    "data-name": "Group 4802"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2785",
    "data-name": "Path 2785",
    d: "M315.419,891.5a27.417,27.417,0,0,1,3.64-8.891c.91-1.4,4.971-7.421,7.071-7,1.33.28,1.89-1.75.56-2.03-3.08-.56-6.161,3.57-7.841,5.741a29.109,29.109,0,0,0-5.461,11.621c-.28,1.26,1.75,1.82,2.03.56Z",
    transform: "translate(-313.362 -873.526)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4805",
    "data-name": "Group 4805",
    transform: "translate(197.64 139.997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4804",
    "data-name": "Group 4804"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2786",
    "data-name": "Path 2786",
    d: "M363.013,902.169a28.316,28.316,0,0,1,8.891-14.422c1.05-.91-.49-2.38-1.47-1.47a30.782,30.782,0,0,0-9.451,15.332,1.054,1.054,0,0,0,2.03.56Z",
    transform: "translate(-360.942 -885.991)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4807",
    "data-name": "Group 4807",
    transform: "translate(227.197 143.925)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4806",
    "data-name": "Group 4806"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2787",
    "data-name": "Path 2787",
    d: "M405.219,909.1a28.428,28.428,0,0,1,9.521-15.752c1.05-.84-.49-2.38-1.47-1.47a29.98,29.98,0,0,0-10.081,16.662c-.28,1.26,1.75,1.89,2.03.56Z",
    transform: "translate(-403.162 -891.602)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2788",
    "data-name": "Path 2788",
    d: "M93.93,690.9a227.657,227.657,0,0,0-4.06,28.563,218.894,218.894,0,0,0-.28,30.873,462.148,462.148,0,0,0,66.437,41.374c68.187,34.794,132.524,46.2,177.959,49.775v12.531c-2.59-.21-6.441-.56-11.061-1.19-18.132-2.31-30.383-5.741-40.744-8.471-29.473-7.561-26.673-4.2-48.935-10.5A334.276,334.276,0,0,1,192.5,819.293c-12.181-5.25-11.061-5.671-42.844-21.562-4.27-2.17-15.122-7.491-36.684-18.062-7.211-3.5-23.873-11.691-30.873-15.122a102.769,102.769,0,0,1-2.03-13.091,105.12,105.12,0,0,1,7.281-46.625A98.821,98.821,0,0,1,93.93,690.9Z",
    transform: "translate(-78.969 -687.481)",
    fill: "#6d6d6d",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2789",
    "data-name": "Path 2789",
    d: "M85.649,723.4l2.94,45.995q28.983,17.222,57.966,34.374-17.852-7.351-36.684-16.032c-9.521-4.41-18.762-8.891-27.653-13.371a77.949,77.949,0,0,1,3.43-50.965Z",
    transform: "translate(-78.879 -697.228)",
    fill: "#6d6d6d",
    opacity: 0.14
  })), /*#__PURE__*/React.createElement("g", {
    id: "torso_1_",
    transform: "translate(225.047 139.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2790",
    "data-name": "Path 2790",
    d: "M452.659,589.553q19.007-5.04,38.994-9.521A1138.289,1138.289,0,0,1,604.085,560.5a109.152,109.152,0,0,1,5.391,12.881,114.927,114.927,0,0,1,4.55,17.432c7.911,43.195,9.521,59.366,9.521,59.366,5.251,52.786,8.821,107.111,9.521,117.822a54.392,54.392,0,0,1-7.911,9.941,56.787,56.787,0,0,1-8.681,7.071c-9.451,6.3-19.532,10.291-24.923,12.461-9.381,3.71-12.671,4.831-32.343,12.041-13.861,5.111-17.362,6.441-24.083,8.331a184.931,184.931,0,0,1-20.3,4.55c-16.382,2.73-31.293,2.94-34.444,2.52C459.939,821.977,448.668,723.057,452.659,589.553Z",
    transform: "translate(-415.618 -559.155)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2791",
    "data-name": "Path 2791",
    d: "M401.9,628.993c1.19,3.78,2.87,9.241,4.621,15.962,3.22,12.041,6.371,26.463,10.081,53,1.54,11.061,1.05,8.961,5.041,42.495,4.41,37.034,5.531,44.175,5.461,57.616a224.423,224.423,0,0,1-2.94,35.354c14,1.68,28.073,3.36,42.074,5.041-1.33-23.312-2.73-42.144-3.78-54.676-4.69-57.546-7.491-63.287-9.661-99.69-.49-8.611-1.47-16.8-3.36-33.254-1.47-12.461-2.59-20.512-5.881-30.313a110.323,110.323,0,0,0-7.561-17.222C424.582,611.841,413.241,620.452,401.9,628.993Z",
    transform: "translate(-400.633 -571.992)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4809",
    "data-name": "Group 4809",
    transform: "translate(35.277 29.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4808",
    "data-name": "Group 4808"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2792",
    "data-name": "Path 2792",
    d: "M450.564,602.306c5.881,13.581,8.331,28.213,10.291,42.844,2.17,15.612,4.06,31.293,5.881,46.975q5.356,46.2,9.1,92.55c1.4,17.5,2.66,35.074,3.71,52.576.07,1.33,2.17,1.33,2.1,0q-5.776-94.93-18.342-189.23c-2.17-15.962-4.551-31.923-10.991-46.765-.42-1.26-2.24-.21-1.75,1.05Z",
    transform: "translate(-450.481 -600.687)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4811",
    "data-name": "Group 4811",
    transform: "translate(34.91)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4810",
    "data-name": "Group 4810"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2793",
    "data-name": "Path 2793",
    d: "M451.247,590.517a1544.942,1544.942,0,0,1,153.386-29.893c1.33-.21.77-2.24-.56-2.03a1544.948,1544.948,0,0,0-153.386,29.893,1.054,1.054,0,0,0,.56,2.03Z",
    transform: "translate(-449.957 -558.578)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4813",
    "data-name": "Group 4813",
    transform: "translate(187.915 0.868)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4812",
    "data-name": "Group 4812"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2794",
    "data-name": "Path 2794",
    d: "M668.644,561.416c5.881,11.691,8.051,24.713,10.361,37.454q3.57,19.952,6.441,39.974Q691.326,679.8,694.2,721.1q1.575,23.313,2.24,46.625c.07,1.33,2.17,1.33,2.1,0A1139.235,1139.235,0,0,0,681.665,602.37c-2.52-14.282-4.76-28.913-11.271-42.074-.56-1.12-2.38-.07-1.75,1.12Z",
    transform: "translate(-668.513 -559.819)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4815",
    "data-name": "Group 4815",
    transform: "translate(64.396 208.298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4814",
    "data-name": "Group 4814"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2795",
    "data-name": "Path 2795",
    d: "M493.073,915.191c23.522,0,46.555-5.391,68.747-12.741,11.411-3.78,22.612-8.051,33.744-12.461,8.891-3.5,17.852-7.141,26.183-11.9,9.241-5.251,17.572-11.831,23.943-20.442.77-1.12-1.05-2.17-1.82-1.05-11.691,15.962-30.453,24.153-48.375,31.223-20.652,8.121-41.584,15.962-63.287,20.792a179.9,179.9,0,0,1-39.134,4.48,1.052,1.052,0,0,0,0,2.1Z",
    transform: "translate(-492.075 -856.116)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4817",
    "data-name": "Group 4817",
    transform: "translate(0 29.698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4816",
    "data-name": "Group 4816"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2796",
    "data-name": "Path 2796",
    d: "M434.471,601.21,416.2,615.071c-5.181,3.92-11.411,7.561-15.822,12.391-.91.98.56,2.52,1.47,1.47,2.31-2.59,5.391-4.55,8.191-6.581,2.8-2.1,5.531-4.2,8.331-6.3,5.741-4.341,11.411-8.681,17.152-13.021,1.05-.77.07-2.66-1.05-1.82Z",
    transform: "translate(-400.091 -600.999)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4819",
    "data-name": "Group 4819",
    transform: "translate(0.72 56.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4818",
    "data-name": "Group 4818"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2797",
    "data-name": "Path 2797",
    d: "M401.176,640.441c7,25.273,11.481,51.175,14.912,77.148,3.43,25.763,6.651,51.736,8.471,77.708,1.05,15.4,1.19,30.873-.91,46.135-.21,1.33,1.82,1.89,2.03.56,3.64-26.463.7-53.066-2.17-79.458-2.87-26.253-5.811-52.576-10.431-78.548-2.66-14.842-5.811-29.543-9.871-44.035-.42-1.4-2.45-.84-2.03.49Z",
    transform: "translate(-401.119 -639.135)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4821",
    "data-name": "Group 4821",
    transform: "translate(22.278 259.212)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4820",
    "data-name": "Group 4820"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2798",
    "data-name": "Path 2798",
    d: "M432.674,930.913c7.211,2.03,14.632,2.52,22.052,3.43a88.078,88.078,0,0,1,11.971,2.31c3.08.84,5.951,1.4,9.031.7,1.33-.28.77-2.31-.56-2.03-3.78.84-7.281-.56-10.851-1.47a74.134,74.134,0,0,0-9.591-1.61c-7.211-.91-14.492-1.33-21.492-3.36a1.053,1.053,0,0,0-.56,2.03Z",
    transform: "translate(-431.914 -928.842)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4823",
    "data-name": "Group 4823",
    transform: "translate(63.267 66.882)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4822",
    "data-name": "Group 4822"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2799",
    "data-name": "Path 2799",
    d: "M490.489,655.434a941.158,941.158,0,0,1,18.2,148.136c.07,1.33,2.17,1.33,2.1,0a940.032,940.032,0,0,0-18.272-148.7c-.28-1.33-2.31-.77-2.03.56Z",
    transform: "translate(-490.462 -654.114)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4825",
    "data-name": "Group 4825",
    transform: "translate(64.403 45.24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4824",
    "data-name": "Group 4824"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2800",
    "data-name": "Path 2800",
    d: "M493.356,646.442A319.832,319.832,0,0,1,604.6,625.3a1.051,1.051,0,0,0,0-2.1,321.078,321.078,0,0,0-111.8,21.212c-1.26.49-.7,2.52.56,2.03Z",
    transform: "translate(-492.085 -623.2)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4827",
    "data-name": "Group 4827",
    transform: "translate(176.959 45.67)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4826",
    "data-name": "Group 4826"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2801",
    "data-name": "Path 2801",
    d: "M652.889,625.134a1097.522,1097.522,0,0,1,21.772,126.923c.14,1.33,2.24,1.33,2.1,0a1094.736,1094.736,0,0,0-21.842-127.483c-.28-1.33-2.31-.77-2.03.56Z",
    transform: "translate(-652.862 -623.814)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4829",
    "data-name": "Group 4829",
    transform: "translate(80.664 175.097)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4828",
    "data-name": "Group 4828"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2802",
    "data-name": "Path 2802",
    d: "M516.634,851.542c22.4-3.71,44.875-8.331,66.647-14.772,18.832-5.6,37.244-13.3,52.225-26.323,1.05-.91-.49-2.38-1.47-1.47-15.262,13.3-34.3,20.932-53.556,26.463a565.175,565.175,0,0,1-64.407,14.141c-1.33.21-.77,2.24.56,1.96Z",
    transform: "translate(-515.314 -808.691)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4831",
    "data-name": "Group 4831",
    transform: "translate(79.884 180.721)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4830",
    "data-name": "Group 4830"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2803",
    "data-name": "Path 2803",
    d: "M516.09,822.308c6.861-5.461,16.382-4.13,22.682,1.47s8.751,13.931,9.1,22.122c.07,1.33,2.17,1.33,2.1,0-.42-9.591-3.57-19.252-11.621-25.133-7.141-5.251-16.8-5.531-23.8,0-1.05.91.49,2.38,1.54,1.54Z",
    transform: "translate(-514.198 -816.724)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4833",
    "data-name": "Group 4833",
    transform: "translate(79.056 167.089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4832",
    "data-name": "Group 4832"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2804",
    "data-name": "Path 2804",
    d: "M514.545,803.306c9.8-6.651,22.542-4.48,31.153,3.08,9.171,7.981,13.021,19.882,14.211,31.643.14,1.33,2.24,1.33,2.1,0-1.33-12.881-5.671-25.973-16.172-34.234-9.241-7.281-22.332-9.1-32.343-2.31-1.12.7-.07,2.52,1.05,1.82Z",
    transform: "translate(-513.016 -797.252)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4835",
    "data-name": "Group 4835",
    transform: "translate(78.878 154.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4834",
    "data-name": "Group 4834"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2805",
    "data-name": "Path 2805",
    d: "M514.049,784.343c13.371-5.111,28.913-5.251,39.624,5.391,10.221,10.151,17.782,24.5,17.782,39.134a1.052,1.052,0,0,0,2.1,0c0-15.4-8.051-31.013-19.252-41.444-11.2-10.5-27.233-10.291-40.884-5.111-1.19.49-.63,2.52.63,2.03Z",
    transform: "translate(-512.763 -778.841)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4837",
    "data-name": "Group 4837",
    transform: "translate(81.552 181.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4836",
    "data-name": "Group 4836"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2806",
    "data-name": "Path 2806",
    d: "M532.626,818.581a63.553,63.553,0,0,0-10.781,11.341,66.029,66.029,0,0,0-4.48,7c-.63,1.19-1.12,1.89-.49,3.15.56,1.19,2.38.14,1.82-1.05-.28-.63,2.59-4.55,2.94-5.11a62.293,62.293,0,0,1,4.06-5.531,59.562,59.562,0,0,1,8.471-8.331c.98-.84-.49-2.38-1.54-1.47Z",
    transform: "translate(-516.581 -818.302)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4839",
    "data-name": "Group 4839",
    transform: "translate(95.706 193.159)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4838",
    "data-name": "Group 4838"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2807",
    "data-name": "Path 2807",
    d: "M550.311,834.707a36.879,36.879,0,0,0-8.681,9.381c-2.31,3.36-4.831,6.931-4.831,11.131a1.051,1.051,0,0,0,2.1,0c0-3.71,2.52-7.071,4.55-10.081a34.9,34.9,0,0,1,7.981-8.681c1.05-.77,0-2.59-1.12-1.75Z",
    transform: "translate(-536.8 -834.49)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4841",
    "data-name": "Group 4841",
    transform: "translate(125.119 168.777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4840",
    "data-name": "Group 4840"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2808",
    "data-name": "Path 2808",
    d: "M579.574,801.649c6.161,1.19,12.321,2.59,18.552,3.64,5.6.91,9.941-.56,15.4-1.26a31.436,31.436,0,0,1,28.283,11.621c.84,1.05,2.31-.42,1.47-1.47a33.57,33.57,0,0,0-25.273-12.461c-5.671-.14-10.991,2.38-16.592,1.96-7.071-.56-14.281-2.59-21.282-3.99-1.33-.28-1.89,1.75-.56,1.96Z",
    transform: "translate(-578.814 -799.662)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4843",
    "data-name": "Group 4843",
    transform: "translate(135.709 179.78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4842",
    "data-name": "Group 4842"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2809",
    "data-name": "Path 2809",
    d: "M595.732,823.725c5.6-4.831,13.091-5.881,20.232-6.161,3.78-.14,7.631-.14,11.061,1.75,3.08,1.75,5.531,4.481,7.841,7.141.91.98,2.38-.49,1.47-1.47-2.66-3.01-5.531-6.161-9.171-7.981-3.5-1.68-7.351-1.75-11.131-1.54-7.771.35-15.612,1.54-21.7,6.791-1.12.91.42,2.38,1.4,1.47Z",
    transform: "translate(-593.941 -815.379)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4845",
    "data-name": "Group 4845",
    transform: "translate(107.646 91.777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4844",
    "data-name": "Group 4844"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2810",
    "data-name": "Path 2810",
    d: "M554.377,691.653c5.32,3.08,7.981,9.241,10.431,14.632a61.939,61.939,0,0,1,5.6,19.322c1.12,11.061-2.59,23.032-12.391,29.193-1.12.7-.07,2.52,1.05,1.82,10.431-6.511,14.562-19.182,13.441-31.013a66.741,66.741,0,0,0-5.881-20.372c-2.59-5.811-5.461-12.111-11.131-15.4a1.069,1.069,0,0,0-1.12,1.82Z",
    transform: "translate(-553.855 -689.675)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4847",
    "data-name": "Group 4847",
    transform: "translate(106.892 82.149)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4846",
    "data-name": "Group 4846"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2811",
    "data-name": "Path 2811",
    d: "M554.894,686.127c1.12-5.11,5.6-10.711,11.131-7.071,3.36,2.24,5.741,6.3,7.771,9.731a60.305,60.305,0,0,1,6.441,47.045c-2.17,7.841-5.881,17.082-12.321,22.332-1.05.84.42,2.31,1.47,1.47,7.561-6.161,11.761-17.5,13.721-26.813a62.094,62.094,0,0,0-.77-29.123c-2.38-8.751-6.721-18.552-13.441-24.923s-14.352-1.19-16.1,6.791c-.21,1.33,1.82,1.89,2.1.56Z",
    transform: "translate(-552.778 -675.921)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4849",
    "data-name": "Group 4849",
    transform: "translate(100.008 75.803)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4848",
    "data-name": "Group 4848"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2812",
    "data-name": "Path 2812",
    d: "M555.444,687.959c-.77,3.08-5.811.63-7.071-.14-1.96-1.26-2.73-3.22-3.08-5.461a12.413,12.413,0,0,1,2.52-10.081c4.62-5.391,13.861-4.48,15.332,3.15.28,1.33,2.31.77,2.03-.56-2.17-11.551-17.5-9.731-21.212-.14-1.68,4.34-1.54,11.061,2.38,14.281,2.87,2.31,9.871,4.76,11.131-.42.28-1.33-1.75-1.89-2.03-.63Z",
    transform: "translate(-542.944 -666.857)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4851",
    "data-name": "Group 4851",
    transform: "translate(134.896 65.364)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4850",
    "data-name": "Group 4850"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2813",
    "data-name": "Path 2813",
    d: "M600.845,670.466c-6.091-1.89-9.451-13.791-1.68-16.032,2.52-.7,4.831-.63,6.511,1.75a11.78,11.78,0,0,1,1.47,4.06c.63,3.08-.35,13.861-6.091,9.661-1.12-.77-2.17,1.05-1.05,1.82,4.761,3.5,8.821-1.89,9.381-6.3.63-4.69-.7-13.021-6.721-13.441-12.531-.98-12.951,17.292-2.38,20.512a1.053,1.053,0,0,0,.56-2.03Z",
    transform: "translate(-592.779 -651.946)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4853",
    "data-name": "Group 4853",
    transform: "translate(140.591 72.603)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4852",
    "data-name": "Group 4852"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2814",
    "data-name": "Path 2814",
    d: "M603.914,666.706a2.163,2.163,0,0,1-1.05-1.54c0-.56.49-1.05,1.05-.63a1.907,1.907,0,0,1,.63,1.68c-.07.28-.14.35-.35.42-.14,0-.21-.14-.14,0-.07-1.33-2.17-1.33-2.1,0a2.342,2.342,0,0,0,3.57,1.75c1.75-1.05,1.33-3.64.28-4.97a2.652,2.652,0,0,0-4.481.21c-1.05,1.82.07,3.78,1.61,4.9,1.05.77,2.1-1.05.98-1.82Z",
    transform: "translate(-600.914 -662.286)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4855",
    "data-name": "Group 4855",
    transform: "translate(142.016 74.117)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4854",
    "data-name": "Group 4854"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2815",
    "data-name": "Path 2815",
    d: "M603.685,666.445c.42.07.84.21,1.26.28a.973.973,0,0,0,1.26-.7,1,1,0,0,0-.7-1.26c-.42-.07-.84-.21-1.26-.28a.973.973,0,0,0-1.26.7,1.032,1.032,0,0,0,.7,1.26Z",
    transform: "translate(-602.949 -664.449)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4857",
    "data-name": "Group 4857",
    transform: "translate(70.958 64.432)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4856",
    "data-name": "Group 4856"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2816",
    "data-name": "Path 2816",
    d: "M501.834,651.374c-1.05,4.06-.28,14.281,6.371,12.251,1.26-.42.77-2.45-.56-2.03-4.69,1.4-4.41-7.211-3.78-9.661a1.053,1.053,0,0,0-2.03-.56Z",
    transform: "translate(-501.448 -650.614)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4859",
    "data-name": "Group 4859",
    transform: "translate(75.379 71.203)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4858",
    "data-name": "Group 4858"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2817",
    "data-name": "Path 2817",
    d: "M507.789,665.686a3.327,3.327,0,0,0,2.31,3.43,4.273,4.273,0,0,0,4.41-1.33,6.094,6.094,0,0,0,1.96-4.69,3.085,3.085,0,0,0-3.22-2.8c-1.33.14-1.33,2.24,0,2.1,2.31-.21.56,3.15-.21,3.92-.91.91-3.43,1.4-3.15-.63.21-1.33-1.89-1.26-2.1,0Z",
    transform: "translate(-507.764 -660.286)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4861",
    "data-name": "Group 4861",
    transform: "translate(77.062 61.911)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4860",
    "data-name": "Group 4860"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2818",
    "data-name": "Path 2818",
    d: "M511.1,647.774c-1.4,4.13-1.96,10.851,3.78,11.761,1.33.21,1.89-1.82.56-2.03-4.48-.7-3.36-6.161-2.31-9.171a1.053,1.053,0,0,0-2.03-.56Z",
    transform: "translate(-510.168 -647.014)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4863",
    "data-name": "Group 4863",
    transform: "translate(83.663 59.697)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4862",
    "data-name": "Group 4862"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2819",
    "data-name": "Path 2819",
    d: "M520.019,644.585c-1.26,4.481.14,12.461,6.371,11.691,1.33-.14,1.33-2.24,0-2.1-4.76.56-5.25-5.811-4.34-9.1.35-1.26-1.68-1.75-2.03-.49Z",
    transform: "translate(-519.597 -643.85)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4865",
    "data-name": "Group 4865",
    transform: "translate(89.428 58.174)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4864",
    "data-name": "Group 4864"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2820",
    "data-name": "Path 2820",
    d: "M527.949,642.673c-.42,3.99.07,9.241,5.041,9.731,1.33.14,1.33-1.96,0-2.1-3.57-.42-3.22-5.111-2.94-7.631.14-1.33-1.96-1.33-2.1,0Z",
    transform: "translate(-527.832 -641.675)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4867",
    "data-name": "Group 4867",
    transform: "translate(88.349 65.821)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4866",
    "data-name": "Group 4866"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2821",
    "data-name": "Path 2821",
    d: "M531.758,654.7c2.17,0,1.4,3.36.49,4.341-1.26,1.4-3.99,1.05-3.85-1.19.07-1.33-2.03-1.33-2.1,0-.21,4.06,4.97,5.32,7.421,2.66,2.17-2.31,2.17-7.981-2.03-7.911-1.26,0-1.26,2.1.07,2.1Z",
    transform: "translate(-526.291 -652.599)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4869",
    "data-name": "Group 4869",
    transform: "translate(97.931 56.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4868",
    "data-name": "Group 4868"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2822",
    "data-name": "Path 2822",
    d: "M540.273,640.574a8.653,8.653,0,0,0,.84,6.581c1.05,1.75,2.94,3.43,5.111,2.66,1.26-.49.7-2.52-.56-2.03-1.61.56-2.8-1.47-3.22-2.73a6.787,6.787,0,0,1-.14-3.92,1.053,1.053,0,0,0-2.03-.56Z",
    transform: "translate(-539.977 -639.814)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4871",
    "data-name": "Group 4871",
    transform: "translate(103.071 56.381)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4870",
    "data-name": "Group 4870"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2823",
    "data-name": "Path 2823",
    d: "M547.586,639.874a6.256,6.256,0,0,0,3.92,7.631c1.26.49,1.82-1.54.56-2.03a4.14,4.14,0,0,1-2.45-5.041,1.053,1.053,0,0,0-2.03-.56Z",
    transform: "translate(-547.32 -639.114)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4873",
    "data-name": "Group 4873",
    transform: "translate(101.657 61.825)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4872",
    "data-name": "Group 4872"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2824",
    "data-name": "Path 2824",
    d: "M551.251,648.927c2.45.14,2.73,3.22.84,4.48-1.61,1.05-4.69.21-4.69-1.96a1.051,1.051,0,0,0-2.1,0c0,4.06,5.531,5.881,8.471,3.36a4.45,4.45,0,0,0-2.52-7.911c-1.4-.14-1.33,1.96,0,2.03Z",
    transform: "translate(-545.3 -646.89)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4875",
    "data-name": "Group 4875",
    transform: "translate(81.97 114.993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4874",
    "data-name": "Group 4874"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2825",
    "data-name": "Path 2825",
    d: "M517.194,723.861l1.26,9.871c.14,1.33,2.24,1.33,2.1,0l-1.26-9.871c-.21-1.33-2.31-1.4-2.1,0Z",
    transform: "translate(-517.179 -722.837)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4877",
    "data-name": "Group 4877",
    transform: "translate(82.037 110.663)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4876",
    "data-name": "Group 4876"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2826",
    "data-name": "Path 2826",
    d: "M518.273,722.636c3.29.35,6.441-.42,9.591-1.12,1.75-.42,3.5-.84,5.25-1.33,1.26-.35,4.62-1.96,5.811-1.19,1.12.77,2.17-1.05,1.05-1.82-2.31-1.47-5.741.56-8.051,1.12-4.34,1.12-9.1,2.66-13.651,2.17-1.33-.07-1.33,2.03,0,2.17Z",
    transform: "translate(-517.275 -716.651)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4879",
    "data-name": "Group 4879",
    transform: "translate(103.111 111.406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4878",
    "data-name": "Group 4878"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2827",
    "data-name": "Path 2827",
    d: "M547.393,719.034c.49,2.59,1.05,5.181,1.54,7.771.28,1.33,2.31.77,2.03-.56-.49-2.59-1.05-5.181-1.54-7.771-.28-1.33-2.24-.77-2.03.56Z",
    transform: "translate(-547.378 -717.714)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4881",
    "data-name": "Group 4881",
    transform: "translate(83.585 119.671)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4880",
    "data-name": "Group 4880"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2828",
    "data-name": "Path 2828",
    d: "M520.756,736.856a203.447,203.447,0,0,0,20.442-5.251c1.26-.42.77-2.45-.56-2.03a203.447,203.447,0,0,1-20.442,5.251c-1.26.28-.7,2.31.56,2.03Z",
    transform: "translate(-519.485 -729.519)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4883",
    "data-name": "Group 4883",
    transform: "translate(86.255 132.399)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4882",
    "data-name": "Group 4882"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2829",
    "data-name": "Path 2829",
    d: "M523.3,748.75a58.307,58.307,0,0,0,.77,7.841c.21,1.33,2.24.77,2.03-.56a51.254,51.254,0,0,1-.7-7.281,1.05,1.05,0,0,0-2.1,0Z",
    transform: "translate(-523.3 -747.7)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4885",
    "data-name": "Group 4885",
    transform: "translate(86.102 127.738)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4884",
    "data-name": "Group 4884"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2830",
    "data-name": "Path 2830",
    d: "M524.635,747.383c2.31-1.68,6.861-1.12,9.591-1.75,3.36-.7,6.651-1.68,9.941-2.52a1.053,1.053,0,0,0-.56-2.03c-3.71.98-7.421,2.1-11.2,2.73-2.87.49-6.441-.07-8.891,1.68-1.05.84,0,2.66,1.12,1.89Z",
    transform: "translate(-523.081 -741.042)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4887",
    "data-name": "Group 4887",
    transform: "translate(87.595 136.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4886",
    "data-name": "Group 4886"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2831",
    "data-name": "Path 2831",
    d: "M526.534,759.609c7.071-1.54,14.141-3.15,21.212-4.691,1.33-.28.77-2.31-.56-2.03-7.071,1.61-14.142,3.15-21.212,4.691a1.053,1.053,0,0,0,.56,2.03Z",
    transform: "translate(-525.214 -752.862)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4889",
    "data-name": "Group 4889",
    transform: "translate(106.781 127.578)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4888",
    "data-name": "Group 4888"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2832",
    "data-name": "Path 2832",
    d: "M552.676,742.134c.77,2.59,1.61,5.251,2.38,7.841.42,1.26,2.45.77,2.03-.56-.77-2.59-1.61-5.251-2.38-7.841a1.053,1.053,0,0,0-2.03.56Z",
    transform: "translate(-552.619 -740.814)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4891",
    "data-name": "Group 4891",
    transform: "translate(162.273 150.281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4890",
    "data-name": "Group 4890"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2833",
    "data-name": "Path 2833",
    d: "M633.156,783.784a258.1,258.1,0,0,1,27.723-8.471,1.053,1.053,0,0,0-.56-2.03,253.348,253.348,0,0,0-27.723,8.471c-1.26.49-.7,2.52.56,2.03Z",
    transform: "translate(-631.885 -773.242)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4893",
    "data-name": "Group 4893",
    transform: "translate(179.145 156.315)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4892",
    "data-name": "Group 4892"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2834",
    "data-name": "Path 2834",
    d: "M657.256,786.369a74.6,74.6,0,0,1,8.821-2.45c1.33-.28.77-2.31-.56-2.03a63.262,63.262,0,0,0-8.821,2.45c-1.26.42-.7,2.45.56,2.03Z",
    transform: "translate(-655.985 -781.862)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2835",
    "data-name": "Path 2835",
    d: "M556.037,686.26c.42,1.12,1.33,1.19,3.15,2.8a22.272,22.272,0,0,1,3.43,4.27c1.89,2.66,2.8,5.041,4.27,8.821,2.45,6.511,3.71,9.731,4.13,11.271,1.12,3.99,5.32,21.772-4.55,33.184a24.594,24.594,0,0,1-7,5.531c3.15,2.17,6.231,4.41,9.381,6.581a26.8,26.8,0,0,0,8.121-10.011,64.7,64.7,0,0,0,6.091-16.1c2.38-11.2.49-20.3-.63-25.623A75.57,75.57,0,0,0,572.7,684.86c-1.68-2.59-3.85-5.671-7.421-6.3a9.169,9.169,0,0,0-6.441,1.68C557.3,681.71,555.337,684.3,556.037,686.26Z",
    transform: "translate(-446.819 -594.535)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2836",
    "data-name": "Path 2836",
    d: "M533.942,821.6a74.585,74.585,0,0,0-5.671,5.32,53.975,53.975,0,0,0-4.9,5.741c-1.54,2.1-2.87,4.2-3.78,5.741-.49.84-.91,1.47-1.19,1.96.21,4.2.49,8.471.7,12.671,4.06-.63,8.051-1.33,12.111-1.96a7.672,7.672,0,0,1,.42-3.15,17.191,17.191,0,0,1,1.89-3.641c.63-.98,1.26-2.17,1.75-2.8a64.264,64.264,0,0,1,9.451-10.431,16.067,16.067,0,0,0-2.1-3.29A19.787,19.787,0,0,0,533.942,821.6Z",
    transform: "translate(-435.575 -637.465)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2837",
    "data-name": "Path 2837",
    d: "M513.3,784.926a54.8,54.8,0,0,1,13.3-3.22,34,34,0,0,1,10.011-.14,32.216,32.216,0,0,1,11.691,4.27,39.739,39.739,0,0,1,6.231,4.62c6.091,5.531,9.171,11.551,11.691,16.8a49.489,49.489,0,0,1,4.2,10.921,48.994,48.994,0,0,1,1.4,11.481c-3.43.91-6.791,1.89-10.221,2.8a67.31,67.31,0,0,0-1.96-10.711,45.253,45.253,0,0,0-4.41-11.481,35.745,35.745,0,0,0-6.3-8.4c-1.82-1.82-9.1-8.891-20.3-9.1a28.952,28.952,0,0,0-14.282,3.57C514.07,792.557,513.65,788.776,513.3,784.926Z",
    transform: "translate(-434.045 -625.364)",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2838",
    "data-name": "Path 2838",
    d: "M522.686,645.88q-.105.63-.21,1.68a10.647,10.647,0,0,0,.21,3.64c.21.77.77,2.45,2.17,3.01a5.194,5.194,0,0,0,2.1.42c.35,0,.7-.14.91.07a.959.959,0,0,1,.14,1.05,1.779,1.779,0,0,1-.77.84,3.089,3.089,0,0,0,.84.77,2.673,2.673,0,0,0,2.31,0,3.168,3.168,0,0,0,1.26-1.75,6.875,6.875,0,0,0,.35-2.38,8.094,8.094,0,0,1-1.19-.07s-.35-.07-.84-.21a6.735,6.735,0,0,1-1.75-.98c-1.47-1.19-1.75-3.36-1.89-4.69a9.378,9.378,0,0,1-.07-2.38C525.066,645.18,523.876,645.53,522.686,645.88Z",
    transform: "translate(-436.78 -584.468)",
    fill: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2839",
    "data-name": "Path 2839",
    d: "M504.735,585.7c-3.5,14.492-6.931,28.983-10.431,43.475a279.154,279.154,0,0,1,35.354-9.451c6.441-1.26,12.6-2.24,18.552-3.01a100.754,100.754,0,0,0-17.152,41.094c-9.871,58.456,38.994,103.541,44.1,108.161,9.661-3.85,19.322-7.631,28.983-11.481.91,14.912,1.82,29.893,2.73,44.8-14.982,6.441-27.933,11.341-37.734,14.842-21.772,7.771-36.334,12.811-56.286,15.472a192.7,192.7,0,0,1-25.273,1.68,1753.14,1753.14,0,0,0-18.2-176.909c-3.08-20.022-6.511-39.554-10.081-58.6Q481.982,590.741,504.735,585.7Z",
    transform: "translate(-417.849 -566.713)",
    fill: "#6d6d6d",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2840",
    "data-name": "Path 2840",
    d: "M582.584,567A130.7,130.7,0,0,0,566.2,595.843c-16.032,39.134-8.261,75.118-4.971,89.4,12.531,54.326,50.055,86.109,63.007,96.12a217.143,217.143,0,0,1-24.923,14.982c-2.87,1.47-11.341,5.741-33.813,14.211-16.732,6.371-25.133,9.521-32.063,11.411a168.117,168.117,0,0,1-50.2,5.671A1408.93,1408.93,0,0,0,466.861,663.82c-3.92-24.5-8.331-48.165-13.161-70.847,21.632-6.091,45.225-11.831,70.5-16.732C544.57,572.321,564.1,569.31,582.584,567Z",
    transform: "translate(-416.17 -561.104)",
    opacity: 0.12,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hand",
    transform: "translate(74.33 194.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2841",
    "data-name": "Path 2841",
    d: "M354.194,639.058c-2.52.49-3.78,3.15-6.091,7.771-2.87,5.811-6.651,11.341-9.1,17.922-.77,2.1-4.9,11.971-13.161,31.783-3.99,9.521-8.611,18.972-17.922,37.874C300.148,750.23,297,755.9,293.008,762.131c-7.421,11.691-12.531,17.222-14.212,18.972a74.044,74.044,0,0,1-19.6,15.542c-4.55,2.45-10.781,5.741-19.6,6.441a41.868,41.868,0,0,1-9.8-.35c.7-1.82,1.61-4.34,2.73-7.421,2.1-5.951,2.31-7.141,2.38-8.471.07-1.4.35-7.491-3.36-9.451a5.828,5.828,0,0,0-5.741.35c-2.38,1.61-.14,5.671-2.38,7.421a4.353,4.353,0,0,1-3.64.56c-1.89-.56-2.66-2.38-3.85-4.691-2.03-3.78-4.41-8.051-8.331-9.871-.63-.28-3.85-1.75-5.741-.21a4.044,4.044,0,0,0-1.26,3.08c-2.1-1.47-4.55-1.47-5.741-.35-1.26,1.19-.91,3.36-.84,4.131a7.8,7.8,0,0,0,1.05,2.8,4.654,4.654,0,0,0-4.55,3.15,4.97,4.97,0,0,0,1.05,4.48c-.21.07-3.5,1.12-3.99,3.781-.35,1.96,1.05,3.64,2.1,4.83,2.24,2.52,4.691,3.29,7.491,4.48,3.01,1.26,5.6,2.87,10.781,6.021,7.491,4.551,6.861,5.321,10.221,6.371,3.78,1.12,5.671.49,10.011,2.38a31.9,31.9,0,0,1,5.181,3.08c3.22,2.03,8.891,3.01,21.142-1.4A101.877,101.877,0,0,0,283.627,801.2C301.9,785.444,311,767.172,318.42,751.98c5.251-10.781,3.43-9.311,11.131-25.973,7.561-16.312,11.411-22.332,19.252-38.434,3.5-7.211,8.681-18.2,14.422-32.063a11.79,11.79,0,0,0,.84-8.331C362.595,642.209,357.834,638.288,354.194,639.058Z",
    transform: "translate(-185.62 -637.714)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4895",
    "data-name": "Group 4895",
    transform: "translate(43.524)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4894",
    "data-name": "Group 4894"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2842",
    "data-name": "Path 2842",
    d: "M375.176,637.194c-5.461-.35-8.891,5.741-11.341,9.731-3.5,5.741-6.091,11.971-8.681,18.132-6.231,14.982-12.741,29.753-19.532,44.455-6.441,13.932-12.951,27.793-20.162,41.3-6.581,12.391-14.211,24.573-24.713,34.023-11.621,10.571-26.813,17.572-42.774,16.242-1.33-.14-1.33,1.96,0,2.1,26.953,2.17,48.585-17.432,62.027-38.784,7.841-12.461,14.142-25.9,20.442-39.134,6.791-14.142,13.3-28.353,19.532-42.775,3.36-7.771,6.511-15.682,9.941-23.452a102.117,102.117,0,0,1,5.391-10.711c2.1-3.43,5.18-9.521,9.8-9.241,1.4.35,1.4-1.75.07-1.89Z",
    transform: "translate(-246.975 -637.179)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4897",
    "data-name": "Group 4897",
    transform: "translate(40.538 0.989)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4896",
    "data-name": "Group 4896"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2843",
    "data-name": "Path 2843",
    d: "M246.694,802.765c-5.321,3.5-5.111,10.851-.56,14.982,6.021,5.461,14.842,3.78,21.842,1.61,16.8-5.181,31.783-15.752,43.685-28.633,12.811-13.931,21.072-30.593,28.213-47.955,3.85-9.241,7.421-18.552,11.761-27.583,4.13-8.751,8.891-17.222,13.441-25.763a239.407,239.407,0,0,0,13.511-28.773c2.52-6.861,6.581-18.412-2.87-21.982-1.26-.49-1.82,1.54-.56,2.03,9.521,3.57,1.68,19.042-.91,25.133-3.15,7.491-6.861,14.772-10.711,21.982-7.491,14.072-14.842,28-20.932,42.7-6.161,14.982-11.971,30.243-20.862,43.895a111.351,111.351,0,0,1-33.674,33.254,83.451,83.451,0,0,1-24.153,10.571c-4.9,1.26-10.5,1.89-14.982-1.05-4.34-2.8-6.091-9.451-1.19-12.671,1.12-.7.07-2.52-1.05-1.75Z",
    transform: "translate(-242.711 -638.592)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4899",
    "data-name": "Group 4899",
    transform: "translate(51.569 164.918)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4898",
    "data-name": "Group 4898"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2844",
    "data-name": "Path 2844",
    d: "M259.82,873.276a14.456,14.456,0,0,0,4.831,17.992c1.12.77,2.17-1.05,1.05-1.82a12.251,12.251,0,0,1-4.06-15.122c.56-1.19-1.26-2.24-1.82-1.05Z",
    transform: "translate(-258.467 -872.752)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4901",
    "data-name": "Group 4901",
    transform: "translate(66.923 161.084)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4900",
    "data-name": "Group 4900"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2845",
    "data-name": "Path 2845",
    d: "M280.47,868.273c-.63,6.091,2.94,16.242,10.781,14.562,1.33-.28.77-2.31-.56-2.03-6.441,1.33-8.611-8.051-8.121-12.531.14-1.33-1.96-1.33-2.1,0Z",
    transform: "translate(-280.399 -867.275)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4903",
    "data-name": "Group 4903",
    transform: "translate(82.322 151.904)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4902",
    "data-name": "Group 4902"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2846",
    "data-name": "Path 2846",
    d: "M302.469,855.169a14.583,14.583,0,0,0,3.92,11.551c1.68,1.82,5.741,5.111,7.841,2.03.77-1.12-1.05-2.17-1.82-1.05-.7,1.05-3.64-1.61-3.99-1.96a14.5,14.5,0,0,1-2.38-3.08,13.38,13.38,0,0,1-1.47-7.561c.14-1.26-1.96-1.26-2.1.07Z",
    transform: "translate(-302.395 -854.162)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4905",
    "data-name": "Group 4905",
    transform: "translate(97.939 136.258)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4904",
    "data-name": "Group 4904"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2847",
    "data-name": "Path 2847",
    d: "M324.841,832.574a12.429,12.429,0,0,0,11.551,14.492c1.33.07,1.33-2.03,0-2.1a10.222,10.222,0,0,1-9.521-11.831c.21-1.33-1.82-1.89-2.03-.56Z",
    transform: "translate(-324.703 -831.814)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4907",
    "data-name": "Group 4907",
    transform: "translate(110.831 115.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4906",
    "data-name": "Group 4906"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2848",
    "data-name": "Path 2848",
    d: "M343.176,804.134a12.494,12.494,0,0,0,15.962,8.121c1.26-.42.7-2.45-.56-2.03a10.353,10.353,0,0,1-13.371-6.651,1.053,1.053,0,0,0-2.03.56Z",
    transform: "translate(-343.119 -802.814)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4909",
    "data-name": "Group 4909",
    transform: "translate(124.919 88.373)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4908",
    "data-name": "Group 4908"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2849",
    "data-name": "Path 2849",
    d: "M363.283,764.734A11.683,11.683,0,0,0,377,773.205c1.33-.28.77-2.31-.56-2.03a9.534,9.534,0,0,1-11.131-7,1.053,1.053,0,0,0-2.03.56Z",
    transform: "translate(-363.242 -763.414)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4911",
    "data-name": "Group 4911",
    transform: "translate(144.736 46.141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4910",
    "data-name": "Group 4910",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2850",
    "data-name": "Path 2850",
    d: "M391.655,704.706a15.161,15.161,0,0,0,14.282,8.821c1.33-.07,1.33-2.17,0-2.1a13.1,13.1,0,0,1-12.461-7.771c-.56-1.26-2.38-.21-1.82,1.05Z",
    transform: "translate(-391.549 -703.087)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4913",
    "data-name": "Group 4913",
    transform: "translate(136.244 65.461)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4912",
    "data-name": "Group 4912"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2851",
    "data-name": "Path 2851",
    d: "M379.476,731.956a13,13,0,0,0,13.161,8.891c1.33-.07,1.33-2.17,0-2.1a10.927,10.927,0,0,1-11.131-7.351c-.42-1.26-2.45-.7-2.03.56Z",
    transform: "translate(-379.419 -730.685)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4915",
    "data-name": "Group 4915",
    transform: "translate(153.134 23.923)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4914",
    "data-name": "Group 4914"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2852",
    "data-name": "Path 2852",
    d: "M403.653,672.926c1.89,3.71,5.321,5.881,9.241,7.071,2.38.77,7.7,2.8,9.451.21.77-1.12-1.05-2.17-1.82-1.05-.63.98-7.071-1.12-8.121-1.54a12.514,12.514,0,0,1-6.931-5.741c-.63-1.19-2.38-.14-1.82,1.05Z",
    transform: "translate(-403.544 -671.352)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4917",
    "data-name": "Group 4917",
    transform: "translate(162.186 7.518)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4916",
    "data-name": "Group 4916"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2853",
    "data-name": "Path 2853",
    d: "M416.633,649.516a15.63,15.63,0,0,0,13.161,7.981c1.33.07,1.33-2.03,0-2.1a13.431,13.431,0,0,1-11.341-7,1.07,1.07,0,0,0-1.82,1.12Z",
    transform: "translate(-416.475 -647.919)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4919",
    "data-name": "Group 4919",
    transform: "translate(34.687 138.213)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4918",
    "data-name": "Group 4918"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2854",
    "data-name": "Path 2854",
    d: "M245.727,861.624c-1.12-1.82,2.03-5.881,2.73-7.7a22.5,22.5,0,0,0,1.33-5.6c.35-3.64-.28-7.771-2.59-10.711-1.89-2.45-5.041-3.85-7.981-2.45a4.965,4.965,0,0,0-2.31,2.17c-1.05,2.1.35,5.881-2.03,7.141-1.19.63-.14,2.45,1.05,1.82,2.24-1.19,2.17-3.08,2.45-5.391.42-3.43,3.08-5.32,6.021-3.08,1.89,1.4,2.73,4.06,3.08,6.3a19.474,19.474,0,0,1-2.45,11.971c-1.19,2.24-2.66,4.13-1.19,6.581.77,1.12,2.59.07,1.89-1.05Z",
    transform: "translate(-234.352 -834.605)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4921",
    "data-name": "Group 4921",
    transform: "translate(0 149.881)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4920",
    "data-name": "Group 4920"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2855",
    "data-name": "Path 2855",
    d: "M226.526,878.664a53.207,53.207,0,0,1-14.422-5.25c-4.41-2.38-8.051-6.231-12.6-8.191-4.55-2.03-10.5-1.96-12.181-7.771-1.54-5.32,4.41-3.92,7.141-3.15a22.85,22.85,0,0,1,8.191,4.48c1.05.84,2.52-.63,1.47-1.47-3.99-3.36-10.711-7.141-16.172-5.741s-2.66,7.631-.21,10.5c1.89,2.24,4.27,3.15,7,3.85,4.34,1.12,7.211,3.22,10.711,5.741a53.868,53.868,0,0,0,20.512,8.961c1.33.35,1.89-1.68.56-1.96Z",
    transform: "translate(-184.805 -851.272)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4923",
    "data-name": "Group 4923",
    transform: "translate(3.017 142.338)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4922",
    "data-name": "Group 4922"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2856",
    "data-name": "Path 2856",
    d: "M192.535,847.64c-1.89-1.4-1.82-2.94.07-4.48a5.076,5.076,0,0,1,3.5-.42,11.786,11.786,0,0,1,3.92,1.82c2.45,1.54,4.76,3.15,7.141,4.76,1.12.77,2.17-1.05,1.05-1.82-4.2-2.8-10.151-8.611-15.752-6.581-3.71,1.4-4.761,6.581-.98,8.471,1.19.7,2.31-1.12,1.05-1.75Z",
    transform: "translate(-189.115 -840.498)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4925",
    "data-name": "Group 4925",
    transform: "translate(6.208 134.592)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4924",
    "data-name": "Group 4924"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2857",
    "data-name": "Path 2857",
    d: "M197.472,836.761a8.137,8.137,0,0,1-1.75-2.87c.91-2.24,2.38-2.94,4.27-2.03a14.836,14.836,0,0,1,4.62,3.08c2.31,2.03,4.62,4.06,6.861,6.161.98.91,2.52-.56,1.47-1.47-3.99-3.5-9.731-10.851-15.752-10.151-5.321.63-3.64,5.951-1.26,8.821.98.98,2.45-.56,1.54-1.54Z",
    transform: "translate(-193.672 -829.433)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4927",
    "data-name": "Group 4927",
    transform: "translate(13.541 131.697)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4926",
    "data-name": "Group 4926"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2858",
    "data-name": "Path 2858",
    d: "M206.634,829.92c-1.89-3.08,3.01-2.59,4.41-1.96a15.246,15.246,0,0,1,3.43,2.59,31.181,31.181,0,0,1,5.181,6.511c1.75,2.8,3.22,6.231,7.071,5.951,1.33-.07,1.33-2.17,0-2.1-3.57.28-6.371-6.791-8.471-9.311-1.96-2.31-4.41-4.83-7.281-5.951-3.5-1.33-8.681,1.26-6.161,5.391a1.07,1.07,0,0,0,1.82-1.12Z",
    transform: "translate(-204.147 -825.298)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2859",
    "data-name": "Path 2859",
    d: "M359.788,643.8c-1.89-.21-4.34,2.8-11.341,19.182-4.06,9.521-6.091,14.282-7.841,19.532-4.76,14.561-12.6,29.333-28.423,58.946-14.211,26.6-21.282,39.9-28,46.835-6.231,6.441-28.073,28.773-48.655,23.8-8.821-2.1-17.642-9.311-20.582-11.691-7.771-6.3-17.572-17.082-22.332-15.962a4.607,4.607,0,0,0-2.87,1.75,4.374,4.374,0,0,0,0,3.57c-.35.21-3.08,1.54-3.57,4.27-.56,3.22,2.38,5.6,2.87,6.021,2.17,1.82,3.92,1.33,7.421,2.45.84.28,1.96.7,7.421,4.271,8.821,5.741,9.381,6.861,13.161,8.541a32.684,32.684,0,0,0,9.241,2.45,30.674,30.674,0,0,0,9.591,3.92c5.741,1.26,14,1.12,28.423-6.721a114.286,114.286,0,0,0,34.794-29.823c6.3-8.191,11.481-18.832,21.632-39.764,8.4-17.362,13.511-28.773,20.582-44.385,5.111-11.271,12.881-28,22.682-48.655C362.728,645.686,361.118,643.936,359.788,643.8Z",
    transform: "translate(-185.193 -639.161)",
    fill: "#6d6d6d",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2860",
    "data-name": "Path 2860",
    d: "M368.366,671.293c-1.05-.56-9.451,12.741-10.361,14.212a262.013,262.013,0,0,0-22.262,45.085c-11.9,29.473-18.272,45.365-31.573,61.326-9.1,10.991-23.732,28.563-47.885,32.343-16.662,2.59-30.663-2.52-38.084-5.951,5.181,2.73,10.361,5.531,15.542,8.261a7.475,7.475,0,0,1,4.13-.49c2.52.42,3.5,2.03,5.951,3.36a13.721,13.721,0,0,0,6.721,1.54,103.8,103.8,0,0,0,33.884-14.771C301.579,804.657,310.82,790.515,344,723.8,368.436,674.723,368.856,671.573,368.366,671.293Z",
    transform: "translate(-194.821 -647.406)",
    fill: "#6d6d6d",
    opacity: 0.13
  }))), /*#__PURE__*/React.createElement("g", {
    id: "girl",
    transform: "translate(441.314 284.258)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "leg_right",
    transform: "translate(134.488 241.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2861",
    "data-name": "Path 2861",
    d: "M962.09,887.373c8.611-5.671,17.292-11.341,25.9-17.012,2.52-4.13,5.041-8.331,7.561-12.461a92.6,92.6,0,0,0,28.213,13.091c18.622,5.041,33.534,2.52,34.444,6.581.77,3.71-11.271,9.171-12.811,9.8-6.861,3.08-21.352,7.981-42.914,3.57-11.481,6.581-22.962,13.091-34.444,19.672-2.87-7.071-5.671-14.211-8.541-21.282C960.34,888.7,961.25,888,962.09,887.373Z",
    transform: "translate(-839.997 -748.58)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2862",
    "data-name": "Path 2862",
    d: "M818.973,713.685c-2.24,6.091-5.531,15.4-9.171,26.883-10.081,32.273-20.932,67.907-21,111.942a274.476,274.476,0,0,0,3.78,45.225,139.346,139.346,0,0,0,24.783,3.78c54.536,3.36,97.03-26.323,115.652-41.444-3.57-12.041-7.141-24.013-10.781-36.054-19.882,2.17-39.834,4.27-59.716,6.441C888.14,767.03,887.3,716.625,866.3,704.584,862.8,702.483,849.286,696.183,818.973,713.685Z",
    transform: "translate(-788.8 -701.744)",
    fill: "#4c4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2863",
    "data-name": "Path 2863",
    d: "M879.475,705.1c-.21,8.4-.7,17.082-1.68,26.113-5.6,52.505-24.013,95.56-42.494,127.483a245.719,245.719,0,0,0,104.1-22.4c-.98-3.57-2.03-7.141-3.01-10.711-19.882,2.03-39.694,3.99-59.576,6.021,2.1-5.181,4.9-12.461,7.7-21.422a249.193,249.193,0,0,0,10.711-51.175c.63-6.371,1.61-18.972-1.33-32.133-1.19-5.25-3.01-10.711-7.351-15.752A32.3,32.3,0,0,0,879.475,705.1Z",
    transform: "translate(-802.747 -702.751)",
    fill: "#6d6d6d",
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2864",
    "data-name": "Path 2864",
    d: "M901.884,737.1a261.513,261.513,0,0,1-16.732,74.278A264.311,264.311,0,0,1,863.1,855.552q40.009-6.406,79.948-12.741c-.35-2.31-.7-4.691-.98-7-19.042,1.68-38.154,3.36-57.2,5.041,6.3-17.292,10.571-31.783,13.371-42.144,2.38-8.891,3.71-13.791,4.691-20.442A123.032,123.032,0,0,0,901.884,737.1Z",
    transform: "translate(-811.084 -712.349)",
    fill: "#6d6d6d",
    opacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "leg__left",
    transform: "translate(116.566 226.512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2865",
    "data-name": "Path 2865",
    d: "M1017.89,904.773c8.611-5.671,17.292-11.341,25.9-17.012,2.52-4.13,5.041-8.331,7.561-12.461a92.6,92.6,0,0,0,28.213,13.091c18.622,5.041,33.533,2.52,34.443,6.581.77,3.71-11.271,9.171-12.811,9.8-6.861,3.08-21.352,7.981-42.915,3.57-11.481,6.581-22.963,13.091-34.444,19.672-2.87-7.071-5.671-14.211-8.541-21.282C1016.21,906.033,1017.05,905.4,1017.89,904.773Z",
    transform: "translate(-838.811 -739.016)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2866",
    "data-name": "Path 2866",
    d: "M867.01,698.851c-6.091,9.451-7.561,21.492-7.561,21.492a51.351,51.351,0,0,0,.56,15.612c2.66,3.78,5.391,7.561,8.051,11.271-.21,9.731-.63,23.032-1.61,38.714-1.75,28.493-4.27,47.185-3.22,74.768,1.12,30.173,5.041,35.214,7.561,37.664,12.041,11.971,34.164,7.631,53.836,3.78a171.27,171.27,0,0,0,58.666-23.662c.77-6.091,2.1-23.1-8.611-38.224a47.121,47.121,0,0,0-9.171-9.661q-21.527,9.976-43.055,19.882c1.4-22.332,2.38-45.715,2.66-69.937.49-34.654-.35-67.487-2.17-98.43C898.093,678.059,875.761,685.34,867.01,698.851Z",
    transform: "translate(-791.962 -680.74)",
    fill: "#4c4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2867",
    "data-name": "Path 2867",
    d: "M923.1,681.939c-.21,7.981-.42,15.962-.7,24.012q-2.835,85.689-10.5,167.038a75.369,75.369,0,0,0,28.7,1.33c29.123-4.27,46.555-24.643,51.385-30.733a29.474,29.474,0,0,0-4.41-6.791,27.04,27.04,0,0,0-6.791-5.741c-14.211,6.511-28.423,13.091-42.564,19.6,1.75-25.273,2.45-47.045,2.73-64.267.35-24.923-.21-44.245-.7-59.156-.56-18.2-1.33-33.744-2.03-45.645a27.058,27.058,0,0,0-10.851-.7A31.751,31.751,0,0,0,923.1,681.939Z",
    transform: "translate(-807.799 -680.63)",
    fill: "#6d6d6d",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2868",
    "data-name": "Path 2868",
    d: "M944.114,727.9c-2.73,8.121-5.251,16.732-7.421,25.693A354.9,354.9,0,0,0,928.922,878a82.04,82.04,0,0,0,29.753-10.5,84.479,84.479,0,0,0,24.012-21.282c-13.3,6.231-26.6,12.391-39.9,18.622,1.26-21.632,2.1-44.315,2.38-67.977C945.374,772.915,944.954,749.882,944.114,727.9Z",
    transform: "translate(-812.22 -694.807)",
    fill: "#6d6d6d",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2869",
    "data-name": "Path 2869",
    d: "M763.2,927.3",
    transform: "translate(-763.2 -754.613)",
    fill: "#6d6d6d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hand_right",
    transform: "translate(0 121.761)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2870",
    "data-name": "Path 2870",
    d: "M751.5,531c-2.31,0-4.06,1.89-6.371,4.41-5.251,5.741-7,11.9-8.051,15.192-1.47,4.62-4.761,11.131-11.341,24.083a156.152,156.152,0,0,1-13.021,21.842c-5.041,7-13.441,18.482-25.693,25.413A65.912,65.912,0,0,1,674,627.47c-3.85,1.19-6.231,1.96-9.661,1.96a27.146,27.146,0,0,1-9.941-1.96c-3.92-1.54-4.76-3.01-8.051-3.29-.91-.07-4.9-.42-6.091,1.68-1.05,1.82.56,4.481,1.68,6.371a15.827,15.827,0,0,0,3.85,4.41c2.8,6.931,5.531,13.861,8.331,20.722a25.11,25.11,0,0,0,6.371-1.4,27.727,27.727,0,0,0,11.9-8.541,123.212,123.212,0,0,0,18.832-6.091c7.071-2.94,25.833-10.991,42.074-29.333,6.161-7,1.05-3.08,21.842-35.984,5.04-7.981,8.051-12.531,8.541-19.672C764.517,544.371,757.586,531,751.5,531Z",
    transform: "translate(-609.657 -531)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4929",
    "data-name": "Group 4929",
    transform: "translate(28.292 0.888)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4928",
    "data-name": "Group 4928"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2871",
    "data-name": "Path 2871",
    d: "M747.014,532.431c-4.34,2.73-6.931,7-8.961,11.621-2.73,6.161-5.041,12.531-7.771,18.762-5.6,12.671-12.111,25.133-20.722,36.054-7.631,9.731-16.942,18.412-27.863,24.363-6.721,3.64-13.861,6.231-21.562,4.9-6.091-1.05-12.181-4.27-18.412-4.34-4.41,0-5.741,4.69-3.64,8.051,2.8,4.48,9.241,5.25,13.861,6.231,1.33.28,1.89-1.75.56-2.03a66.279,66.279,0,0,1-7.351-1.82,12.307,12.307,0,0,1-3.57-1.82,3.773,3.773,0,0,1-1.12-.98c-1.61-1.75-1.26-2.24.28-3.92,1.75-1.89,1.47-1.75,3.64-1.33.77.14,1.61.35,2.38.49,1.4.35,2.73.7,4.13,1.12,2.87.84,5.811,1.75,8.751,2.31,10.711,1.89,20.792-3.08,29.473-8.961,18.622-12.6,31.223-31.923,40.674-52.015,2.87-6.091,5.461-12.321,7.981-18.622,2.38-6.021,4.69-12.6,10.361-16.242,1.05-.77,0-2.52-1.12-1.82Z",
    transform: "translate(-637.108 -532.269)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4931",
    "data-name": "Group 4931",
    transform: "translate(44.441 26.147)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4930",
    "data-name": "Group 4930"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2872",
    "data-name": "Path 2872",
    d: "M769.4,568.875Q758.8,588.2,748.192,607.449c-5.951,10.781-12.531,20.372-22.332,28.073a112.578,112.578,0,0,1-31.083,16.872c-5.251,1.96-10.921,3.01-16.032,5.251-2.66,1.19-4.481,3.08-6.651,4.97a20.363,20.363,0,0,1-10.921,4.971c-1.33.14-1.33,2.24,0,2.1a21.611,21.611,0,0,0,11.481-4.83c2.31-1.89,4.2-4.13,7-5.391a67.565,67.565,0,0,1,7.281-2.31,140.377,140.377,0,0,0,25.553-10.571,95.517,95.517,0,0,0,21.982-16.1c7.281-7.351,12.181-16.1,17.082-25.063,6.511-11.831,13.021-23.733,19.532-35.564.77-1.12-.98-2.17-1.68-.98Z",
    transform: "translate(-660.175 -568.349)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2873",
    "data-name": "Path 2873",
    d: "M615.44,664.762a5.548,5.548,0,0,0-.63,4.48,5.812,5.812,0,0,0,4.9,3.85,18.9,18.9,0,0,0-.84,4.27c-.21,3.29.77,4.411,1.47,9.381.49,3.43.28,4.27,1.05,7a9.512,9.512,0,0,0,2.31,4.481,7.209,7.209,0,0,0,3.22,1.89,4.615,4.615,0,0,0,.84,3.01c1.54,1.89,5.321,2.17,8.961.07a27.323,27.323,0,0,1-.63,10.011,23.56,23.56,0,0,1-4.06,8.751,21.016,21.016,0,0,1-6.721,6.091c-4.55,2.59-6.931,1.33-12.811,3.29-.98.35-6.161,2.03-9.381,5.041-7.561,7-4.62,21.072-4.06,23.312a21.126,21.126,0,0,0,12.531,2.38,18.556,18.556,0,0,0,4.55-1.26,13.076,13.076,0,0,1-3.78-7.981c-.35-4.971,2.73-8.471,4.06-10.011,3.5-4.06,8.191-5.671,12.531-7.211,4.971-1.75,6.161-1.19,8.471-3.01,1.61-1.26,3.29-3.36,5.041-9.731,1.33-5.041,3.22-12.391,1.75-22.122-.98-6.371-3.01-11.061-5.041-15.682a92.751,92.751,0,0,0-5.951-11.271,6.5,6.5,0,0,1-3.15-.77,6.944,6.944,0,0,1-3.15-3.57,8.692,8.692,0,0,1-.14-4.2,8.8,8.8,0,0,1,1.26-3.01A8.053,8.053,0,0,0,616.7,663.5",
    transform: "translate(-597.095 -569.832)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4933",
    "data-name": "Group 4933",
    transform: "translate(0 89.335)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4932",
    "data-name": "Group 4932"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2874",
    "data-name": "Path 2874",
    d: "M599.919,758.643c-1.75-2.8-.91-6.861-.56-9.941a26.708,26.708,0,0,1,2.52-9.241c3.22-6.231,8.681-7.491,15.052-8.471,9.451-1.4,16.312-7,19.252-16.242,3.36-10.641-.28-22.192-5.181-31.783-2.1-4.13-4.9-8.4-9.1-10.641-2.31-1.19-7.071-1.68-6.371-5.531.63-3.78,8.961-9.381,11.271-3.92.49,1.26,2.52.7,2.03-.56-3.15-7.561-13.792-2.17-15.332,3.92-.91,3.57,1.68,5.531,4.62,6.721,5.6,2.31,8.681,6.161,11.341,11.481,5.321,10.641,8.961,23.943,2.38,34.864a19.215,19.215,0,0,1-13.231,9.241c-4.76.91-9.8.98-13.791,3.99-3.71,2.8-5.811,7.211-6.791,11.691-1.05,4.55-2.45,11.271.14,15.4a1,1,0,1,0,1.75-.98Z",
    transform: "translate(-596.695 -658.608)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4935",
    "data-name": "Group 4935",
    transform: "translate(14.601 103.134)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4934",
    "data-name": "Group 4934"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2875",
    "data-name": "Path 2875",
    d: "M638.517,679.916a75.56,75.56,0,0,1,10.221,27.933,49.775,49.775,0,0,1-.07,15.122c-.77,4.691-2.17,10.291-5.881,13.581-3.5,3.15-8.821,3.15-13.021,4.831a21.64,21.64,0,0,0-8.331,5.811c-4.551,5.391-5.391,13.371-.98,19.112.84,1.05,2.66,0,1.82-1.05-6.931-9.031.63-19.742,10.011-22.612,3.71-1.12,7.771-1.54,10.991-3.85a17.062,17.062,0,0,0,5.671-8.471c6.091-17.082.35-36.614-8.541-51.525-.77-1.12-2.59-.07-1.89,1.12Z",
    transform: "translate(-617.551 -678.319)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4937",
    "data-name": "Group 4937",
    transform: "translate(20.798 102.854)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4936",
    "data-name": "Group 4936"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2876",
    "data-name": "Path 2876",
    d: "M627.521,678.4c-2.17,3.08-.91,7.281,1.47,9.871a7.189,7.189,0,0,0,9.8.91c1.05-.84-.42-2.31-1.47-1.47-4.691,3.64-11.2-3.71-7.981-8.191.77-1.19-1.05-2.24-1.82-1.12Z",
    transform: "translate(-626.403 -677.919)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4939",
    "data-name": "Group 4939",
    transform: "translate(21.425 109.921)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4938",
    "data-name": "Group 4938"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2877",
    "data-name": "Path 2877",
    d: "M627.65,688.774a9.9,9.9,0,0,0,.63,6.791c.7,1.75,1.54,3.92,3.15,4.971,3.29,2.24,7.981.7,10.361-2.17.84-1.05-.63-2.52-1.47-1.47-1.75,2.1-5.671,3.85-8.121,1.61a10.763,10.763,0,0,1-2.52-9.171,1.053,1.053,0,0,0-2.03-.56Z",
    transform: "translate(-627.299 -688.014)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4941",
    "data-name": "Group 4941",
    transform: "translate(23.106 118.803)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4940",
    "data-name": "Group 4940"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2878",
    "data-name": "Path 2878",
    d: "M629.7,701.75c0,3.64.28,8.051,3.85,10.011,3.78,2.17,7.911-.28,10.991-2.59,1.05-.77,0-2.59-1.05-1.82-2.38,1.75-5.811,4.27-8.891,2.59-2.8-1.54-2.8-5.461-2.8-8.191a1.05,1.05,0,0,0-2.1,0Z",
    transform: "translate(-629.7 -700.7)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4943",
    "data-name": "Group 4943",
    transform: "translate(28.495 129.216)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4942",
    "data-name": "Group 4942"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2879",
    "data-name": "Path 2879",
    d: "M637.4,716.573c.28,5.531,7.421,5.741,11.131,3.57a1.051,1.051,0,0,0-1.05-1.82c-2.17,1.26-7.771,2.1-7.981-1.75-.07-1.33-2.17-1.33-2.1,0Z",
    transform: "translate(-637.398 -715.575)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2880",
    "data-name": "Path 2880",
    d: "M752.212,551.2a169.859,169.859,0,0,1-9.8,25.9c-5.041,10.5-13.371,27.653-30.663,43.685-10.641,9.941-25.763,24.013-48.165,25.9a60.242,60.242,0,0,1-17.852-1.19c1.75,3.78,3.29,8.331,1.47,10.081-3.22,3.15-14.211-4.9-16.942-1.75-1.82,2.03,1.26,7.491,2.38,9.521,1.68,3.01,3.71,6.581,7.141,7.141,2.31.35,4.55-1.05,8.891-3.85a61.331,61.331,0,0,0,5.671-4.13,26.063,26.063,0,0,0,6.231-2.1,27.157,27.157,0,0,0,8.331-6.231,160.647,160.647,0,0,0,18.132-5.951c8.821-3.5,19.742-7.771,30.033-16.032,3.01-2.38,8.821-7.491,18.412-21.422a230.073,230.073,0,0,0,24.993-47.255C757.742,559.321,755.012,555.26,752.212,551.2Z",
    transform: "translate(-606.593 -537.059)",
    fill: "#6d6d6d",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2881",
    "data-name": "Path 2881",
    d: "M762.211,584.7c-3.5,4.831-9.031,12.391-15.752,21.7-11.551,15.892-15.332,21.282-16.382,22.612-7.911,10.641-26.183,24.433-72.878,36.894,1.26,2.45,2.59,4.971,3.85,7.421a27.8,27.8,0,0,0,7.7-2.38,28.455,28.455,0,0,0,10.081-8.051,100.05,100.05,0,0,0,49.635-24.993C749.05,619.494,758.431,596.181,762.211,584.7Z",
    transform: "translate(-614.842 -547.106)",
    fill: "#6d6d6d",
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2882",
    "data-name": "Path 2882",
    d: "M636.321,678.6c4.48,8.681,9.031,21.282,8.051,35.984-.49,7.281-.91,12.881-5.041,17.222-6.441,6.791-13.931,2.38-23.522,10.081-2.17,1.75-8.4,6.791-8.611,14.562a17.758,17.758,0,0,0,4.13,11.271c2.45-.07,4.971-.21,7.421-.28-.7-.91-4.55-5.951-3.29-12.181a14.525,14.525,0,0,1,4.13-7.421c2.8-2.87,4.831-2.87,12.181-6.231,5.741-2.66,8.611-3.99,10.431-5.951,3.22-3.57,3.99-7.841,4.76-12.461a46.442,46.442,0,0,0,.28-13.091C645.772,696.522,639.4,684.13,636.321,678.6Z",
    transform: "translate(-599.844 -575.269)",
    fill: "#6d6d6d",
    opacity: 0.15
  })), /*#__PURE__*/React.createElement("g", {
    id: "torso",
    transform: "translate(134.761 83.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2883",
    "data-name": "Path 2883",
    d: "M804.7,490.939a32.946,32.946,0,0,0-11.061,14.071c-2.03,5.11-2.1,9.381-2.24,14.632-.14,8.191,1.26,14.211,3.57,24.083,1.96,8.121,2.87,12.181,4.691,16.032,1.75,3.78,2.45,4.06,10.5,17.712,2.73,4.62,3.92,6.721,4.691,9.941.84,3.36.42,4.48,1.12,10.781.56,5.251,1.05,6.161,1.68,10.781a103.977,103.977,0,0,1,.84,14.632,127.84,127.84,0,0,1-3.29,27.933c2.45.7,6.021,1.68,10.5,2.52,22.542,4.13,41.024.07,52.015-2.52a161.936,161.936,0,0,0,28.213-9.381,58.97,58.97,0,0,0,.56-13.021c-.28-3.71-1.19-7.771-3.01-15.752-2.1-9.1-2.94-11.271-4.13-17.992-.63-3.36-.98-5.811-1.4-8.541-1.68-11.621-2.52-17.432-3.85-27.373-2.31-16.942-3.43-25.483-5.251-32.063-3.5-12.951-6.441-23.592-15.752-33.184-2.87-2.94-12.181-12.321-27.373-14.911C823.879,475.608,807.358,488.7,804.7,490.939Z",
    transform: "translate(-789.849 -477.358)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4945",
    "data-name": "Group 4945",
    transform: "translate(0 37.226)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4944",
    "data-name": "Group 4944"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2884",
    "data-name": "Path 2884",
    d: "M789.2,530.973c1.89,14.632,3.71,29.543,9.171,43.335,5.391,13.651,15.052,24.993,20.232,38.714.49,1.26,2.52.7,2.03-.56-4.97-13.161-14.141-24.153-19.6-37.1-5.881-14.071-7.841-29.4-9.731-44.385-.14-1.33-2.24-1.33-2.1,0Z",
    transform: "translate(-789.19 -529.975)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4947",
    "data-name": "Group 4947",
    transform: "translate(22.089 103.535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4946",
    "data-name": "Group 4946"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2885",
    "data-name": "Path 2885",
    d: "M820.783,626.028a152.375,152.375,0,0,1,5.251,36.894,150.446,150.446,0,0,1-.77,17.782c-.35,3.43-.77,6.791-1.4,10.151a13.691,13.691,0,0,0-.49,2.87c0,.7.98,1.26.56,2.03a1.066,1.066,0,0,0,.63,1.54,144.24,144.24,0,0,0,90.449-10.431c1.19-.56.14-2.38-1.05-1.82a142.19,142.19,0,0,1-88.839,10.221c.21.49.42,1.05.63,1.54.77-1.47.14-1.96-.07-3.36-.42-2.66.84-6.161,1.19-8.891a143.048,143.048,0,0,0,1.19-19.742,156.34,156.34,0,0,0-5.321-39.414c-.28-1.26-2.31-.7-1.96.63Z",
    transform: "translate(-820.742 -624.691)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4949",
    "data-name": "Group 4949",
    transform: "translate(74.158 9.014)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4948",
    "data-name": "Group 4948"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2886",
    "data-name": "Path 2886",
    d: "M895.6,491.723c10.361,7.071,16.1,18.622,19.952,30.243,4.13,12.741,6.651,25.973,8.681,39.134,2.1,13.511,3.78,27.023,6.091,40.464,1.19,6.931,2.73,13.792,4.34,20.582,1.75,7.421,3.36,14.912,1.75,22.472-.28,1.33,1.75,1.89,2.03.56,2.31-10.851-1.4-21.422-3.641-31.853-2.52-11.411-4.2-22.962-5.811-34.514-3.15-21.982-5.671-45.015-14.421-65.667-3.92-9.241-9.451-17.642-17.852-23.312-1.19-.7-2.24,1.12-1.12,1.89Z",
    transform: "translate(-895.119 -489.675)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4951",
    "data-name": "Group 4951",
    transform: "translate(0.297 0.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4950",
    "data-name": "Group 4950"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2887",
    "data-name": "Path 2887",
    d: "M791.845,518.526c-1.4-8.681,4.13-17.572,9.661-23.732a47.887,47.887,0,0,1,18.762-12.951c15.262-5.811,32.833-2.73,45.715,7.071,1.05.84,2.1-.98,1.05-1.82-14-10.711-33.254-13.441-49.5-6.371a50.269,50.269,0,0,0-19.812,15.4c-4.971,6.441-9.241,14.632-7.841,22.962.14,1.33,2.17.77,1.96-.56Z",
    transform: "translate(-789.615 -476.807)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2888",
    "data-name": "Path 2888",
    d: "M854.6,476.8c2.1,5.251,5.18,12.881,8.751,22.122,13.091,33.884,21.982,54.186,24.433,69.1,2.45,14.7,5.181,45.855-10.711,86.249a190.23,190.23,0,0,0,23.662-4.55,179.406,179.406,0,0,0,24.433-8.4,79.083,79.083,0,0,0,0-14.141,74.165,74.165,0,0,0-3.85-17.922c-2.59-13.792-4.62-26.043-6.091-36.264-3.781-25.483-3.991-34.024-8.751-48.865a123.233,123.233,0,0,0-16.382-31.713c-1.12-1.54-1.75-2.38-2.66-3.43C877.982,478.41,863.771,476.8,854.6,476.8Z",
    transform: "translate(-808.808 -476.8)",
    fill: "#6d6d6d",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2889",
    "data-name": "Path 2889",
    d: "M913.1,518.8a175.288,175.288,0,0,0-1.89,28.633c.49,33.394,10.431,46.695,9.171,70.637-.56,10.641-3.5,26.533-15.682,45.785a100.925,100.925,0,0,0,16.8-3.43,104.086,104.086,0,0,0,18.342-7.281c-.07-4.06-.35-10.151-1.12-17.572-1.68-15.752-4.41-23.242-7.281-36.614-5.321-24.783-2.1-26.953-6.861-46.975A178.321,178.321,0,0,0,913.1,518.8Z",
    transform: "translate(-823.835 -489.397)",
    fill: "#6d6d6d",
    opacity: 0.16
  })), /*#__PURE__*/React.createElement("g", {
    id: "hand_left",
    transform: "translate(61.788 112.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2890",
    "data-name": "Path 2890",
    d: "M839.107,518.659c-4.621-.7-8.541,2.59-10.781,4.411A28.382,28.382,0,0,0,820,535.531s-2.24,6.581-20.442,53.136c-7.281,18.482-15.122,29.893-25.413,44.8-2.45,3.57-13.441,19.182-27.093,25.413-4.69,2.17-7.911,3.64-12.741,4.13-5.531.56-8.121-.63-13.021,1.12-1.05.35-7.911,2.8-7.771,6.371.14,2.17,2.94,4.271,6.651,5.251-3.71-.84-14.352-3.01-22.122-.28-1.47.49-5.391,1.89-5.811,4.41-.21,1.54.98,2.73.28,3.85-.84,1.4-3.01.7-3.85,1.96-.49.7-.49,2.03,1.12,4.69a3.506,3.506,0,0,0-1.68,2.8,3.2,3.2,0,0,0,1.68,3.01c-1.82.07-3.36.77-3.85,1.96-.77,1.82,1.4,4.06,2.8,4.971,2.66,1.82,5.811,1.33,8.541.84a140.186,140.186,0,0,0,22.122-6.091c6.651-2.31,8.471-3.01,10.781-4.691,3.36-2.52,4.27-4.48,7.211-7.491,4.41-4.551,8.751-6.441,13.021-8.541,2.66-1.33,24.713-12.461,39.554-25.693,6.091-5.461,9.521-9.941,15.472-17.712,12.111-15.822,18.342-29.193,26.533-46.765,13.231-28.353,5.671-20.792,14.912-40.674,1.19-2.59,4.06-8.611,2.52-15.472C848.278,526.29,844.918,519.569,839.107,518.659Z",
    transform: "translate(-685.199 -518.167)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4953",
    "data-name": "Group 4953",
    transform: "translate(27.05)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4952",
    "data-name": "Group 4952"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2891",
    "data-name": "Path 2891",
    d: "M850.521,518c-15.752.98-21.072,17.992-25.343,30.453-5.321,15.332-10.851,30.593-17.712,45.365-7,15.052-15.262,29.543-25.763,42.495-10.011,12.321-22.122,23.943-38.574,25.833-5.041.56-17.712.07-19.322,6.651-1.75,7,7.631,8.261,12.251,8.191a1.051,1.051,0,0,0,0-2.1,19.206,19.206,0,0,1-5.671-.35c-1.68-.42-5.181-2.24-4.62-4.691.98-4.34,9.1-4.76,12.531-5.11,6.441-.7,12.461-1.4,18.412-4.13,11.9-5.461,21-15.612,28.843-25.833,17.222-22.332,28.353-48.655,37.8-75.048,2.66-7.491,4.9-15.192,8.051-22.542,3.43-8.121,9.451-16.522,19.042-17.082,1.47-.07,1.47-2.17.07-2.1Z",
    transform: "translate(-723.593 -517.998)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4955",
    "data-name": "Group 4955",
    transform: "translate(0 12.419)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4954",
    "data-name": "Group 4954"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2892",
    "data-name": "Path 2892",
    d: "M848.173,536.761c-1.4,18.412-8.891,35.564-16.522,52.155-6.371,13.931-12.951,27.723-21.212,40.674-8.331,13.091-18.482,25.273-31.153,34.373-12.461,8.961-27.163,14.212-39.484,23.453a75.056,75.056,0,0,0-8.891,8.121c-3.85,3.991-8.121,5.391-13.371,6.861l-14.7,4.2a72.119,72.119,0,0,1-7.631,2.03,9.752,9.752,0,0,1-4.27-.07,6.143,6.143,0,0,1-2.87-1.61c-1.68-3.01-.84-4.621,2.45-4.831a1.053,1.053,0,0,0,.56-2.03,4.89,4.89,0,0,0-5.811,3.01c-1.05,2.66.7,5.321,3.01,6.651,3.08,1.75,6.721,1.12,10.011.28,5.6-1.4,11.061-3.15,16.662-4.76,4.2-1.19,8.891-2.1,12.741-4.34,3.78-2.24,6.371-5.951,9.591-8.821,6.931-6.091,15.122-10.431,23.242-14.7,8.051-4.27,15.962-8.541,23.172-14.141a110.752,110.752,0,0,0,18.552-18.552c10.921-13.581,19.182-29.053,26.6-44.735,9.521-20.022,19.672-40.814,21.422-63.217.07-1.4-2.03-1.33-2.1,0Z",
    transform: "translate(-684.954 -535.737)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4957",
    "data-name": "Group 4957",
    transform: "translate(5.52 156.438)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4956",
    "data-name": "Group 4956"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2893",
    "data-name": "Path 2893",
    d: "M721.3,741.7c-7.351,0-14.772-.49-22.052-.07-3.29.21-7.771,2.38-6.021,6.441,1.82,4.13,7.911,4.41,11.691,4.831,6.231.7,12.391,1.05,18.132-1.61,1.19-.56.14-2.38-1.05-1.82-4.27,2.03-8.891,2.1-13.511,1.68-1.89-.14-3.78-.35-5.741-.63-1.68-.21-5.11-.49-6.371-1.82-.98-.35-1.12-1.19-.42-2.31-.42-1.96.49-2.8,2.59-2.59.7-.07,1.4-.07,2.1-.07h6.861c4.551,0,9.1.07,13.651.07a1.052,1.052,0,0,0,.14-2.1Z",
    transform: "translate(-692.839 -741.457)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4959",
    "data-name": "Group 4959",
    transform: "translate(1.781 163.651)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4958",
    "data-name": "Group 4958"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2894",
    "data-name": "Path 2894",
    d: "M695.69,752.488c-4.27-3.01-11.9,4.06-6.091,7.631,7.631,4.69,19.042,2.17,27.163.56,1.33-.28.77-2.31-.56-2.03a77.423,77.423,0,0,1-14.492,1.82,28.828,28.828,0,0,1-6.931-.77c-.7-.21-3.85-.84-4.13-1.4.14-1.19.28-2.31.42-3.5a3.726,3.726,0,0,1,3.57-.49c1.05.77,2.1-1.05,1.05-1.82Z",
    transform: "translate(-687.498 -751.76)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4961",
    "data-name": "Group 4961",
    transform: "translate(1.835 171.663)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4960",
    "data-name": "Group 4960"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2895",
    "data-name": "Path 2895",
    d: "M692.353,763.692a3.106,3.106,0,0,0-4.48,1.19c-.98,2.1.63,4.27,2.45,5.181,3.08,1.61,7.561,1.61,10.921,1.47a39.32,39.32,0,0,0,12.671-2.59c1.26-.49.7-2.52-.56-2.03a38.371,38.371,0,0,1-11.481,2.52,37.106,37.106,0,0,1-4.83-.07,35.188,35.188,0,0,1-3.78-.56c-.28-.07-.63-.14-.91-.21-1.26-.21-1.61-1.26-1.05-3.08,1.19.63,2.24-1.19,1.05-1.82Z",
    transform: "translate(-687.576 -763.205)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2896",
    "data-name": "Path 2896",
    d: "M840.431,521.529c-5.111,1.54-5.321,14.281-5.531,18.762-1.19,24.363-13.371,45.365-27.093,69.167-8.121,14.071-22.962,39.064-52.506,57.336a134.946,134.946,0,0,1-31.293,14.282,30.055,30.055,0,0,1-34.094,9.381,53.761,53.761,0,0,1-2.45,7.281,5.574,5.574,0,0,0-.7,3.5,6,6,0,0,0,2.8,3.5c2.66,1.54,5.881.7,7.281.35,5.251-1.4,15.682-4.55,29.193-9.031a42.533,42.533,0,0,0,5.881-3.85c4.971-3.78,5.671-6.021,10.081-9.731,3.22-2.73,5.951-4.2,10.431-6.581a94.251,94.251,0,0,1,11.481-5.181c17.082-6.651,30.8-21.282,32.343-22.962,3.5-3.78,6.371-8.191,12.181-17.012a331.789,331.789,0,0,0,23.312-41.724c1.12-2.45,5.881-12.811,10.781-26.743,8.541-24.363,3.01-18.132,6.931-28.843a8.81,8.81,0,0,0,.35-5.881C848.482,523.559,843.511,520.619,840.431,521.529Z",
    transform: "translate(-685.473 -519.007)",
    fill: "#6d6d6d",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2897",
    "data-name": "Path 2897",
    d: "M872.47,555.3c-.56-.21-2.94,5.251-10.081,19.952-8.191,16.732-21.912,45.015-30.313,58.876-8.821,14.562-25.063,35.354-56.776,55.026a137.446,137.446,0,0,0,49.355-34.514c11.2-12.391,17.152-23.732,24.713-38.084C865.469,585.681,873.8,555.788,872.47,555.3Z",
    transform: "translate(-712.051 -529.183)",
    fill: "#6d6d6d",
    opacity: 0.13
  })), /*#__PURE__*/React.createElement("g", {
    id: "head",
    transform: "translate(81.059 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2898",
    "data-name": "Path 2898",
    d: "M726.346,407.256c-1.33,5.811-.28,10.361,1.75,19.322,3.92,17.152,8.751,38.224,25.133,44.875,13.231,5.461,27.513-1.19,33.114-4.2.21.7,2.17,7.421,7.981,9.1,5.461,1.61,10.361-2.45,12.461-4.2,1.47-1.19,6.231-5.531,9.311-19.322a82.486,82.486,0,0,0,1.33-28.913c-1.33-10.081-2.52-18.762-8.191-27.093-9.171-13.3-27.3-21.912-45.575-19.322C747.418,379.743,729.987,391.154,726.346,407.256Z",
    transform: "translate(-716.462 -363.064)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4963",
    "data-name": "Group 4963",
    transform: "translate(69.595 85.417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4962",
    "data-name": "Group 4962"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2899",
    "data-name": "Path 2899",
    d: "M813.718,494.077a33.61,33.61,0,0,0,8.4-13.721c.42-1.26-1.61-1.82-2.03-.56a30.6,30.6,0,0,1-7.911,12.811c-.91.91.56,2.38,1.54,1.47Z",
    transform: "translate(-811.892 -479.085)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4965",
    "data-name": "Group 4965",
    transform: "translate(70.22 81.166)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4964",
    "data-name": "Group 4964"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2900",
    "data-name": "Path 2900",
    d: "M814.615,492.746c5.461-4.34,8.611-11.691,9.941-18.412.28-1.33-1.75-1.89-2.03-.56-1.19,6.441-4.13,13.3-9.381,17.5-1.05.84.42,2.31,1.47,1.47Z",
    transform: "translate(-812.784 -473.014)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2901",
    "data-name": "Path 2901",
    d: "M751.978,380.545a41.774,41.774,0,0,0,14,12.881,43.254,43.254,0,0,0,29.753,4.27,9.263,9.263,0,0,1,6.861-.98c4.9,1.54,7.631,8.541,5.321,13.511-2.03,4.27-6.861,5.321-7.561,5.461-.7,2.52-1.61,6.021-2.38,10.291-2.1,11.411-3.15,17.152-.77,22.612a22.134,22.134,0,0,0,14.492,11.971c11.9,3.08,23.452-5.181,28.773-14,1.33-2.17,5.811-10.5,3.43-20.022-2.52-10.151-10.361-10.781-20.022-22.052-13.931-16.172-6.861-25.2-20.022-36.614-11.9-10.151-26.6-10.711-28.983-10.781a46.632,46.632,0,0,0-17.432,2.87,37.07,37.07,0,0,0-14.632,2.03c-14.212,4.971-20.862,17.432-23.733,22.892a53.634,53.634,0,0,0-5.951,33.674,52.447,52.447,0,0,0,5.951,17.012,43.125,43.125,0,0,0-3.99,20.022c.21,5.111,1.75,19.952,14.282,30.383,2.1,1.75,13.651,11.411,28.7,8.821,9.381-1.61,14.982-7.071,22.332-14.282,4.76-4.691,8.471-8.471,8.121-13.651-.35-5.321-4.69-9.031-6.441-10.361-2.94,2.03-5.811,4.06-8.751,6.091A34.325,34.325,0,0,1,762.9,460.7c-10.5-3.57-16.312-11.2-23.172-20.022a105.069,105.069,0,0,1-14.911-26.043Q738.362,397.522,751.978,380.545Z",
    transform: "translate(-712.481 -357.074)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4967",
    "data-name": "Group 4967",
    transform: "translate(10.859 55.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4966",
    "data-name": "Group 4966"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2902",
    "data-name": "Path 2902",
    d: "M728.068,437.869c8.051,20.442,21.072,41.164,43.125,48.375,2.38.77,4.831,1.68,7.211.77,1.75-.63,3.36-2.1,4.831-3.22a49.813,49.813,0,0,0,10.291-10.711,52.131,52.131,0,0,0,9.8-28.843c.07-1.33-2.03-1.33-2.1,0a50.469,50.469,0,0,1-8.261,26.113,47.768,47.768,0,0,1-9.171,10.361c-2.45,2.1-5.391,4.76-8.821,4.48a23.472,23.472,0,0,1-6.371-2.1c-19.532-7.981-31.083-26.953-38.5-45.785-.49-1.19-2.52-.7-2.03.56Z",
    transform: "translate(-727.992 -436.629)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4969",
    "data-name": "Group 4969",
    transform: "translate(68.819 98.544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4968",
    "data-name": "Group 4968"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2903",
    "data-name": "Path 2903",
    d: "M811.145,499.561c3.57,3.29,4.76,7.421,6.581,11.691,1.12,2.52,2.66,3.01,5.321,2.73a18.638,18.638,0,0,0,14.7-11.411c.49-1.26-1.54-1.82-2.03-.56a16.275,16.275,0,0,1-6.231,7.491c-2.38,1.54-6.371,3.5-8.821,1.68-2.03-1.47-2.45-4.76-3.57-7a19.077,19.077,0,0,0-4.481-6.021c-1.05-.98-2.52.49-1.47,1.4Z",
    transform: "translate(-810.784 -497.837)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4971",
    "data-name": "Group 4971",
    transform: "translate(81.78 38.187)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4970",
    "data-name": "Group 4970"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2904",
    "data-name": "Path 2904",
    d: "M831.4,417.977c-.07-3.78,3.92-5.111,6.861-3.36a8.777,8.777,0,0,1,3.57,5.531c.84,3.78.28,12.111-5.741,10.361-1.33-.42-1.82,1.61-.56,2.03,8.681,2.59,9.941-9.8,7.561-15.262-1.4-3.22-4.621-6.091-8.4-5.6a6.115,6.115,0,0,0-5.391,6.3,1.052,1.052,0,0,0,2.1,0Z",
    transform: "translate(-829.298 -411.622)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4973",
    "data-name": "Group 4973",
    transform: "translate(35.051 48.538)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4972",
    "data-name": "Group 4972"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2905",
    "data-name": "Path 2905",
    d: "M762.655,428.013c1.96,4.41,2.52,9.661,3.5,14.351.98,4.621,1.96,9.241,3.01,13.861a1.066,1.066,0,0,0,1.54.63,49.97,49.97,0,0,0,6.511-4.971c.98-.91-.49-2.38-1.47-1.47a44.037,44.037,0,0,1-6.091,4.69c.49.21,1.05.42,1.54.63-1.12-5.041-2.17-10.151-3.29-15.192-.98-4.48-1.54-9.311-3.43-13.581-.56-1.26-2.38-.14-1.82,1.05Z",
    transform: "translate(-762.549 -426.408)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4975",
    "data-name": "Group 4975",
    transform: "translate(17.475 48.548)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4974",
    "data-name": "Group 4974"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2906",
    "data-name": "Path 2906",
    d: "M739.513,432.987a6.13,6.13,0,0,1,8.611-3.92c1.19.56,2.31-1.26,1.05-1.82a8.32,8.32,0,0,0-11.691,5.181,1.056,1.056,0,0,0,2.03.56Z",
    transform: "translate(-737.442 -426.421)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4977",
    "data-name": "Group 4977",
    transform: "translate(43.482 39.632)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4976",
    "data-name": "Group 4976"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2907",
    "data-name": "Path 2907",
    d: "M776.347,419.366a9.925,9.925,0,0,1,13.441-1.68c1.12.77,2.17-1.05,1.05-1.82a12.014,12.014,0,0,0-16.032,2.03c-.77,1.05.7,2.52,1.54,1.47Z",
    transform: "translate(-774.591 -413.686)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4979",
    "data-name": "Group 4979",
    transform: "translate(25.876 59.974)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4978",
    "data-name": "Group 4978"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2908",
    "data-name": "Path 2908",
    d: "M753.333,448.173a5.729,5.729,0,0,1-1.4-1.75,4.528,4.528,0,0,1-.28-.91c-.07-.35.14-.84-.28-.63s.21.63.42.91a5.226,5.226,0,0,1,.49.84c.14.35.91,1.68.7,1.89.21-.14.42-.35.63-.49.14-.07-.35-.56-.35-.63-.14-.21-.28-.49-.42-.7a13.029,13.029,0,0,1-.7-1.75,1.053,1.053,0,0,0-2.03.56c.42,1.54,1.75,5.041,3.85,4.62,2.45-.49.42-4.34-.35-5.461-.49-.7-1.12-1.68-2.03-1.89a1.708,1.708,0,0,0-1.96,1.26c-.7,1.96.77,4.34,2.24,5.6.98.91,2.52-.56,1.47-1.47Z",
    transform: "translate(-749.443 -442.742)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4981",
    "data-name": "Group 4981",
    transform: "translate(53.459 53.743)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4980",
    "data-name": "Group 4980"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2909",
    "data-name": "Path 2909",
    d: "M792.733,439.273a5.729,5.729,0,0,1-1.4-1.75,4.528,4.528,0,0,1-.28-.91c-.07-.35.14-.84-.28-.63s.21.63.42.91a5.216,5.216,0,0,1,.49.84c.14.35.91,1.68.7,1.89.21-.14.42-.35.63-.49.14-.07-.35-.56-.35-.63-.14-.21-.28-.49-.42-.7a13.03,13.03,0,0,1-.7-1.75,1.053,1.053,0,0,0-2.03.56c.42,1.54,1.75,5.041,3.85,4.621,2.45-.49.42-4.34-.35-5.461-.49-.7-1.12-1.68-2.03-1.89a1.708,1.708,0,0,0-1.96,1.26c-.7,1.96.77,4.34,2.24,5.6,1.05.84,2.52-.63,1.47-1.47Z",
    transform: "translate(-788.843 -433.842)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4983",
    "data-name": "Group 4983",
    transform: "translate(47.212 71.851)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4982",
    "data-name": "Group 4982"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2910",
    "data-name": "Path 2910",
    d: "M780.676,474.194c3.36.77,6.721-1.54,9.241-3.57a25.937,25.937,0,0,0,7.141-9.311c.56-1.19-1.26-2.31-1.82-1.05a24.505,24.505,0,0,1-4.76,7.141c-2.03,2.03-6.021,5.531-9.171,4.831a1.03,1.03,0,1,0-.63,1.96Z",
    transform: "translate(-779.92 -459.708)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4985",
    "data-name": "Group 4985",
    transform: "translate(60.155 69.968)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4984",
    "data-name": "Group 4984"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2911",
    "data-name": "Path 2911",
    d: "M798.542,458.616a5.55,5.55,0,0,0,5.881,2.73c1.33-.21.77-2.24-.56-2.03a3.493,3.493,0,0,1-3.5-1.82,1.071,1.071,0,0,0-1.82,1.12Z",
    transform: "translate(-798.408 -457.019)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4987",
    "data-name": "Group 4987",
    transform: "translate(62.162 62.955)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4986",
    "data-name": "Group 4986"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2912",
    "data-name": "Path 2912",
    d: "M802.273,449.1a1.051,1.051,0,0,0,0-2.1,1.051,1.051,0,0,0,0,2.1Z",
    transform: "translate(-801.275 -447)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4989",
    "data-name": "Group 4989",
    transform: "translate(66.94 55.534)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4988",
    "data-name": "Group 4988"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2913",
    "data-name": "Path 2913",
    d: "M810.2,437.66v-.21a1.05,1.05,0,0,0-2.1,0v.21a1.077,1.077,0,0,0,1.05,1.05,1.031,1.031,0,0,0,1.05-1.05Z",
    transform: "translate(-808.1 -436.4)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4991",
    "data-name": "Group 4991",
    transform: "translate(67.203 61.764)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4990",
    "data-name": "Group 4990"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2914",
    "data-name": "Path 2914",
    d: "M809.473,447.4a1.051,1.051,0,0,0,0-2.1,1.051,1.051,0,0,0,0,2.1Z",
    transform: "translate(-808.475 -445.3)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4993",
    "data-name": "Group 4993",
    transform: "translate(25.636 70.725)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4992",
    "data-name": "Group 4992"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2915",
    "data-name": "Path 2915",
    d: "M750.15,460.2h.42a1.05,1.05,0,1,0,0-2.1h-.42a1.077,1.077,0,0,0-1.05,1.05,1.031,1.031,0,0,0,1.05,1.05Z",
    transform: "translate(-749.1 -458.1)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4995",
    "data-name": "Group 4995",
    transform: "translate(31.079 69.325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4994",
    "data-name": "Group 4994"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2916",
    "data-name": "Path 2916",
    d: "M757.873,458.2a1.052,1.052,0,0,0,0-2.1,1.052,1.052,0,0,0,0,2.1Z",
    transform: "translate(-756.875 -456.1)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4997",
    "data-name": "Group 4997",
    transform: "translate(29.136 74.576)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4996",
    "data-name": "Group 4996"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2917",
    "data-name": "Path 2917",
    d: "M755.15,465.7a1.052,1.052,0,0,0,0-2.1,1.052,1.052,0,0,0,0,2.1Z",
    transform: "translate(-754.1 -463.6)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4999",
    "data-name": "Group 4999",
    transform: "translate(57.703 80.824)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4998",
    "data-name": "Group 4998"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2918",
    "data-name": "Path 2918",
    d: "M795.182,473.487c3.92,2.1,7.771,4.41,11.481,6.861.56.35,1.12-.56.56-.91-3.71-2.45-7.561-4.69-11.481-6.861-.63-.28-1.19.63-.56.91Z",
    transform: "translate(-794.905 -472.524)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5001",
    "data-name": "Group 5001",
    transform: "translate(69.111 86.676)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5000",
    "data-name": "Group 5000"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2919",
    "data-name": "Path 2919",
    d: "M812.32,483.556c0-.42.42-2.1,1.12-1.61.63.42-.21,1.54-.56,1.89-.07.07-.28.28-.35.28-.14,0-.07-.42-.07-.49,0-.21.14-1.12.35-1.19a4.462,4.462,0,0,0-.14.49c-.07.07-.07.14-.14.21l.28.28c.07,0,.28-.42.35-.49s.07-.14.14-.14c.21-.14.21-.21-.07-.21-.07-.07-.14-.21-.21-.28.14.42-.49.84-.77.91-.63.21-.35,1.26.28.98.77-.28,1.75-1.12,1.54-2.03a.626.626,0,0,0-.7-.56c-.42,0-.7.35-.98.7a1.99,1.99,0,0,0-.63,1.19.777.777,0,0,0,.77.77c.84,0,1.47-1.19,1.4-1.96-.07-.84-1.12-1.47-1.75-.77a3.838,3.838,0,0,0-.77,2.87c.21.98,1.19.98,1.89.49a3.119,3.119,0,0,0,1.33-2.45,1.467,1.467,0,0,0-1.89-1.47,2.838,2.838,0,0,0-1.54,2.73.573.573,0,0,0,1.12-.14Z",
    transform: "translate(-811.2 -480.884)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5003",
    "data-name": "Group 5003",
    transform: "translate(57.924 78.272)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5002",
    "data-name": "Group 5002"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2920",
    "data-name": "Path 2920",
    d: "M795.906,472.324c4.97-.77,9.941-1.61,14.842-2.45.63-.14.35-1.12-.28-.98-4.971.84-9.871,1.68-14.842,2.45-.7.07-.42,1.05.28.98Z",
    transform: "translate(-795.221 -468.881)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5005",
    "data-name": "Group 5005",
    transform: "translate(72.934 75.875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5004",
    "data-name": "Group 5004"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2921",
    "data-name": "Path 2921",
    d: "M817.948,468.987a2.528,2.528,0,0,1-.21-1.26,1.351,1.351,0,0,1,.21-.7c.07-.14,0-.35.07.07a3.718,3.718,0,0,1-.49,2.45c.28-.07.56-.07.84-.14a1.444,1.444,0,0,1,.07-2.31c-.28-.07-.56-.07-.84-.14a1.592,1.592,0,0,1-.35,1.96c.28.07.56.07.84.14a2.145,2.145,0,0,1,.42-2.45c-.28-.07-.56-.07-.84-.14a1.592,1.592,0,0,1-.28,1.82c-.42.49.28,1.26.77.77a2.877,2.877,0,0,0,.42-3.15.581.581,0,0,0-.84-.14,3.31,3.31,0,0,0-.63,3.71.534.534,0,0,0,.84.14,2.651,2.651,0,0,0,.49-3.29c-.21-.35-.56-.28-.84-.14a2.5,2.5,0,0,0-.07,3.78.534.534,0,0,0,.84-.14,4.343,4.343,0,0,0,.7-2.45c0-.63-.14-1.54-.77-1.82-.7-.35-1.19.28-1.4.84a3.668,3.668,0,0,0,0,2.59c.28.91,1.33.63,1.05,0Z",
    transform: "translate(-816.661 -465.456)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2922",
    "data-name": "Path 2922",
    d: "M797.1,411.9a52.152,52.152,0,0,1,10.781,19.392c6.791,23.1-5.531,43.055-7.841,46.695,4.971-4.691,9.941-9.451,14.982-14.142,3.57,6.931,7.141,13.791,10.781,20.722a15.111,15.111,0,0,0,5.251-4.48,15.487,15.487,0,0,0,2.38-4.971,20.181,20.181,0,0,0,6.021,2.38c6.651,1.26,12.041-1.75,14.982-3.43a31.088,31.088,0,0,0,13.371-15.472c1.33-3.43,3.5-8.821,1.61-15.192a20.535,20.535,0,0,0-6.791-9.941,27.514,27.514,0,0,1-3.92,10.991c-3.71,5.881-12.461,14.632-21.282,12.321-8.051-2.1-14.492-13.091-11.831-25.693.7.21,3.36.91,5.251-.56,1.82-1.33,1.82-3.78,1.82-6.581,0-3.15.07-8.191-2.87-10.221-2.59-1.82-6.161-.28-9.451.56C815.162,415.54,807.671,415.96,797.1,411.9Z",
    transform: "translate(-737.86 -373.518)",
    fill: "#6d6d6d",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2923",
    "data-name": "Path 2923",
    d: "M717.533,482a24.657,24.657,0,0,0,5.531,15.192c4.9,5.881,15.052,12.041,21,7.841,4.41-3.15,5.671-11.411,2.1-19.672a39.747,39.747,0,0,0,27.793,15.752c3.08-2.17,6.091-4.34,9.171-6.581a18.518,18.518,0,0,1,3.92,4.971c1.05,1.89,2.45,4.41,2.1,7.351-.35,2.87-2.24,4.831-3.92,6.581-9.451,9.451-14.211,14.211-16.242,15.192a33.087,33.087,0,0,1-14.422,3.92c-13.861.42-23.382-8.541-25.483-10.5a40.56,40.56,0,0,1-11.831-22.052A43.658,43.658,0,0,1,717.533,482Z",
    transform: "translate(-713.669 -394.543)",
    fill: "#6d6d6d",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2924",
    "data-name": "Path 2924",
    d: "M763.1,429.1v28.913c2.17-.28,4.34-.63,6.511-.91C767.44,447.792,765.27,438.481,763.1,429.1Z",
    transform: "translate(-727.663 -378.677)",
    fill: "#6d6d6d",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2925",
    "data-name": "Path 2925",
    d: "M826.971,429.8c-.7-.07-1.26,7.071-3.08,16.172a156.529,156.529,0,0,1-8.191,27.653,58.69,58.69,0,0,0,11.761-27.653C828.511,438.061,827.741,429.87,826.971,429.8Z",
    transform: "translate(-743.439 -378.887)",
    fill: "#6d6d6d",
    opacity: 0.11
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsImage);
export default __webpack_public_path__ + "static/media/settingsImage.8fffe282.svg";
export { ForwardRef as ReactComponent };